/******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ "./src/components/app/app.component.tsx":
/*!**********************************************!*\
  !*** ./src/components/app/app.component.tsx ***!
  \**********************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.App = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importDefault(__webpack_require__(/*! react */ "react"));
const launcher_component_1 = __webpack_require__(/*! ../launcher/launcher.component */ "./src/components/launcher/launcher.component.tsx");
const context_1 = __webpack_require__(/*! ../context */ "./src/components/context/index.ts");
const recoil_1 = __webpack_require__(/*! recoil */ "recoil");
const chrome_component_1 = __webpack_require__(/*! ../chrome/chrome.component */ "./src/components/chrome/chrome.component.tsx");
const App = ({ chatScopes, webChatConfig, sourceInfo, tpcCheck, knownUris, providers, adaptiveCardHostConfig, middleware, themes, localizeConfig, view, actions, onAPIReady }) => {
    return (react_1.default.createElement(recoil_1.RecoilRoot, null,
        react_1.default.createElement(context_1.CoreContext, Object.assign({}, {
            actions,
            chatScopes,
            knownUris,
            providers,
            sourceInfo,
            view,
            themes,
            localizeConfig,
            onAPIReady,
            tpcCheck,
            middleware
        }),
            react_1.default.createElement(launcher_component_1.Launcher, Object.assign({}, {
                adaptiveCardHostConfig,
                webChatConfig
            }),
                react_1.default.createElement(chrome_component_1.Chrome, null)))));
};
exports.App = App;


/***/ }),

/***/ "./src/components/app/index.ts":
/*!*************************************!*\
  !*** ./src/components/app/index.ts ***!
  \*************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./app.component */ "./src/components/app/app.component.tsx"), exports);


/***/ }),

/***/ "./src/components/chat-root/chat-root.component.tsx":
/*!**********************************************************!*\
  !*** ./src/components/chat-root/chat-root.component.tsx ***!
  \**********************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ChatRoot = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const botframework_webchat_1 = __webpack_require__(/*! botframework-webchat */ "botframework-webchat");
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const { Composer } = botframework_webchat_1.Components;
const ChatRoot = ({ children }) => {
    var _a;
    const hostConfig = smarthub_common_1.useHostConfig();
    const webChatConfig = smarthub_common_1.useChatConfig();
    const [personality, setPersonality] = smarthub_common_1.usePersonality();
    const [, setSelectedPage] = smarthub_common_1.usePage();
    const [context, setContext] = react_1.useState(null);
    const { directline, config } = (_a = smarthub_common_1.useDirectline()) !== null && _a !== void 0 ? _a : {};
    const webChatStrings = smarthub_common_1.useLocalize(smarthub_common_1.LocalizeKeys.webchat);
    react_1.useEffect(() => {
        if (directline) {
            const store = botframework_webchat_1.createStore({}, ({ dispatch }) => (next) => (action) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
                var _a, _b, _c, _d, _e, _f, _g, _h, _j;
                if (action.type === "DIRECT_LINE/INCOMING_ACTIVITY") {
                    let shouldProcess = true;
                    // only process recent events that have happened in the last 5 seconds
                    if (action.payload.activity.timestamp) {
                        let now = new Date();
                        let activityTime = new Date(action.payload.activity.timestamp);
                        let diff = now.getTime() - activityTime.getTime();
                        if (diff > 5000) {
                            shouldProcess = false;
                        }
                    }
                    if (shouldProcess) {
                        const { activity } = action.payload;
                        if (activity.type === "event" && ((_a = activity === null || activity === void 0 ? void 0 : activity.value) === null || _a === void 0 ? void 0 : _a.payload)) {
                            let inbound_personality = (_c = (_b = activity === null || activity === void 0 ? void 0 : activity.value) === null || _b === void 0 ? void 0 : _b.payload) === null || _c === void 0 ? void 0 : _c.personality;
                            if (inbound_personality)
                                switchPersonality(inbound_personality);
                        }
                        //detect page launch
                        if ((_f = (_e = (_d = action === null || action === void 0 ? void 0 : action.payload) === null || _d === void 0 ? void 0 : _d.activity) === null || _e === void 0 ? void 0 : _e.channelData) === null || _f === void 0 ? void 0 : _f.activityParameters) {
                            let { pageId, pageName, html } = (_j = (_h = (_g = action === null || action === void 0 ? void 0 : action.payload) === null || _g === void 0 ? void 0 : _g.activity) === null || _h === void 0 ? void 0 : _h.channelData) === null || _j === void 0 ? void 0 : _j.activityParameters;
                            setSelectedPage({
                                id: pageId,
                                name: pageName,
                                html: html,
                            });
                        }
                    }
                }
                return next(action);
            }));
            setContext({
                store,
                directline,
            });
        }
    }, [directline]);
    const switchPersonality = (inbound_personality) => {
        if (inbound_personality !== personality) {
            setPersonality(inbound_personality);
        }
    };
    const activityMiddleware = smarthub_common_1.useActivityMiddleware(context);
    const attachmentMiddleware = smarthub_common_1.useAttachmentMiddleware(context);
    const actionMiddleware = smarthub_common_1.useActionMiddleware(context);
    const { bot: { user: { id: userId }, }, } = config || { bot: { user: {} } };
    return (react_1.default.createElement(react_1.default.Fragment, null, (context === null || context === void 0 ? void 0 : context.directline) && (react_1.default.createElement(Composer, Object.assign({ activityMiddleware: activityMiddleware, attachmentMiddleware: attachmentMiddleware, cardActionMiddleware: actionMiddleware, adaptiveCardsHostConfig: hostConfig, userID: userId, directLine: context.directline, store: context.store, overrideLocalizedStrings: webChatStrings }, webChatConfig), children))));
};
exports.ChatRoot = ChatRoot;


/***/ }),

/***/ "./src/components/chat-root/index.ts":
/*!*******************************************!*\
  !*** ./src/components/chat-root/index.ts ***!
  \*******************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./chat-root.component */ "./src/components/chat-root/chat-root.component.tsx"), exports);


/***/ }),

/***/ "./src/components/chrome/chrome.component.tsx":
/*!****************************************************!*\
  !*** ./src/components/chrome/chrome.component.tsx ***!
  \****************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Chrome = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const main_menu_1 = __webpack_require__(/*! ../main-menu */ "./src/components/main-menu/index.ts");
const react_jss_1 = __webpack_require__(/*! react-jss */ "react-jss");
const context_1 = __webpack_require__(/*! ../context */ "./src/components/context/index.ts");
const panel_1 = __webpack_require__(/*! ../panel */ "./src/components/panel/index.ts");
const skip_links_1 = __webpack_require__(/*! ../skip-links */ "./src/components/skip-links/index.ts");
const maxZ = 1000000;
const useStyles = react_jss_1.createUseStyles({
    chrome: ({ position, mode }) => ({
        display: "flex",
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        height: 0,
        zIndex: maxZ,
        flexDirection: "row",
        "& > :first-child": {
            marginLeft: mode == "chat" && position == "right" ? "auto" : undefined,
        },
        "& > :last-child": {
            order: position == "right" ? 3 : 1,
        },
        "& > * [aria-hidden='true']": {
            display: ["block", "!important"],
        },
        "& .webchat__basic-transcript__filler": {
            display: ["flex", "!important"],
        },
    }),
    panels: ({ mode }) => ({
        order: 2,
        flex: "1 1",
        width: "100%",
        height: "100vh",
        display: "flex",
        position: "relative",
        overflow: "hidden",
        "&:empty": mode == "chat"
            ? {
                width: 0,
                flex: "0 0",
            }
            : undefined,
    }),
});
const notificationTemplateID = "component.notification";
const Chrome = () => {
    const { position } = smarthub_common_1.usePanelView("chat");
    const { mode } = smarthub_common_1.useViewConfig();
    const styleConfig = react_1.useMemo(() => ({
        mode,
        position,
    }), [mode, position]);
    const render = smarthub_common_1.useRender();
    const styles = useStyles(styleConfig);
    const { rootLabelChat, rootLabelFull } = smarthub_common_1.useLocalizeConfig();
    const role = mode == "chat" ? "dialog" : undefined;
    const label = mode == "chat" ? rootLabelChat : rootLabelFull;
    return react_1.useMemo(() => (react_1.default.createElement(react_1.default.Fragment, null,
        mode == "full" && react_1.default.createElement(skip_links_1.SkipLinks, null),
        react_1.default.createElement(context_1.BreakpointProvider, { className: styles.chrome, role: role, "aria-label": label },
            react_1.default.createElement(main_menu_1.MainMenu, null),
            mode !== "chat" && (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(context_1.BreakpointProvider, { className: styles.panels },
                    react_1.default.createElement(panel_1.Panel, { type: "main" }),
                    react_1.default.createElement(panel_1.Panel, { type: "page" })))),
            react_1.default.createElement(panel_1.Panel, { type: "chat" })),
        render(notificationTemplateID)())), [styles]);
};
exports.Chrome = Chrome;


/***/ }),

/***/ "./src/components/chrome/index.ts":
/*!****************************************!*\
  !*** ./src/components/chrome/index.ts ***!
  \****************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./chrome.component */ "./src/components/chrome/chrome.component.tsx"), exports);


/***/ }),

/***/ "./src/components/context/api-provider/api-provider.component.tsx":
/*!************************************************************************!*\
  !*** ./src/components/context/api-provider/api-provider.component.tsx ***!
  \************************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.APIProvider = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const APIProvider = ({ onAPIReady, children }) => {
    const extendedAPIRef = react_1.useRef(null);
    const setExtendedAPI = react_1.useCallback((api) => extendedAPIRef.current = api, []);
    const openPromiseRef = react_1.useRef(null);
    const [chromeState, setChromeState] = smarthub_common_1.useChromeState();
    const [getChromeState, onChromeStateChange] = smarthub_common_1.useEventDispatch(chromeState, (state, previous) => {
        if (state == 'closed' && previous == 'open') {
            openPromiseRef.current = null;
            setBotReady(false);
            setExtendedAPI(null);
        }
    });
    const [botReady, setBotReady] = react_1.useState();
    const [getBotReady, onBotReadyChange] = smarthub_common_1.useEventDispatch(botReady, (ready) => {
        if (ready && openPromiseRef.current) {
            openPromiseRef.current.resolve(ready);
            openPromiseRef.current = null;
        }
    });
    const [context, setContext] = react_1.useState({
        botReady,
        setBotReady,
        setExtendedAPI
    });
    const command = react_1.useCallback((action) => {
        if (extendedAPIRef.current)
            return extendedAPIRef.current.command(action);
        return Promise.reject(new Error("The bot is not available. Use open and wait for bot to become ready."));
    }, []);
    const open = react_1.useCallback((options) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
        const { action } = options || {};
        if (openPromiseRef.current)
            throw new Error("Wait for webchat to open");
        let promise = new Promise((resolve, reject) => {
            openPromiseRef.current = { resolve, reject };
        });
        setChromeState('open');
        const success = yield promise;
        return action && success
            ? yield command(action)
            : success;
    }), []);
    const close = react_1.useCallback(() => {
        setChromeState('closed');
    }, []);
    const apiRef = react_1.useRef({
        open,
        close,
        chromeState: getChromeState,
        botReady: getBotReady,
        onChromeStateChange,
        onBotReadyChange,
        command
    });
    react_1.useEffect(() => {
        setContext({
            botReady,
            setBotReady,
            setExtendedAPI
        });
    }, [botReady]);
    react_1.useEffect(() => {
        if (onAPIReady)
            onAPIReady(apiRef.current);
    }, []);
    return react_1.default.createElement(smarthub_common_1.APIContext.Provider, { value: context }, children);
};
exports.APIProvider = APIProvider;


/***/ }),

/***/ "./src/components/context/api-provider/index.ts":
/*!******************************************************!*\
  !*** ./src/components/context/api-provider/index.ts ***!
  \******************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./api-provider.component */ "./src/components/context/api-provider/api-provider.component.tsx"), exports);


/***/ }),

/***/ "./src/components/context/app-provider/app-provider.component.tsx":
/*!************************************************************************!*\
  !*** ./src/components/context/app-provider/app-provider.component.tsx ***!
  \************************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.AppProvider = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const AppProvider = ({ children, chatScopes = [], providers, sourceInfo, knownUris, actions = [], view }) => {
    const focusCallback = react_1.useRef({});
    const lastActions = react_1.useRef([]);
    const safeProviders = Object.assign({ auth: [], cogsvc: [], content: [], file: [], format: [], notifications: [], preferences: {
            permanent: null,
            temporary: null,
        }, profile: [], route: [] }, providers);
    const focus = react_1.useCallback((name) => {
        const callback = focusCallback.current[name];
        callback && callback();
    }, []);
    const registerFocus = react_1.useCallback((name, callback) => {
        focusCallback.current[name] = callback;
    }, []);
    const registerLastAction = react_1.useCallback((panelType, callback) => {
        const currentDate = new Date();
        const time = currentDate.getTime();
        const currentRegisterAction = { panelType, time, callback };
        if (lastActions.current.filter(e => e.panelType === panelType).length > 0) {
            const panelIndex = lastActions.current.findIndex((obj => obj.panelType == panelType));
            lastActions.current[panelIndex] = currentRegisterAction;
        }
        else {
            lastActions.current[lastActions.current.length] = currentRegisterAction;
        }
        lastActions.current.sort((a, b) => b.time - a.time);
    }, []);
    const focusLastAction = react_1.useCallback((panelType) => {
        let lastActionIs;
        if (panelType === 'main')
            panelType = 'chat';
        const removeIndex = lastActions.current.findIndex(item => (item === null || item === void 0 ? void 0 : item.panelType) === panelType);
        removeIndex != -1 && lastActions.current.splice(removeIndex, 1);
        if (lastActions.current.length == 0) {
            focus('mainContent');
            return false;
        }
        else {
            lastActionIs = lastActions.current[lastActions.current.length - 1];
            try {
                (lastActionIs === null || lastActionIs === void 0 ? void 0 : lastActionIs.callback) && (lastActionIs === null || lastActionIs === void 0 ? void 0 : lastActionIs.callback());
                return true;
            }
            catch (error) {
                /* eslint-disable */ console.log(...oo_oo(`3266544089_74_8_74_61_4`, "error occured in the callback function"));
                focus('mainContent');
                return false;
            }
        }
    }, []);
    const [chromeState, setChromeState] = react_1.useState(view.mode == 'chat'
        ? 'closed'
        : 'open');
    const [context, setContext] = react_1.useState({
        chatScopes,
        providers: safeProviders,
        sourceInfo,
        knownUris,
        actions,
        view,
        chromeState,
        setChromeState,
        focus,
        registerFocus,
        registerLastAction,
        focusLastAction
    });
    react_1.useEffect(() => {
        setContext({
            chatScopes,
            providers: safeProviders,
            sourceInfo,
            knownUris,
            actions,
            view,
            chromeState,
            setChromeState,
            focus,
            registerFocus,
            registerLastAction,
            focusLastAction
        });
    }, [chatScopes, providers, sourceInfo, knownUris, actions, view, chromeState, setChromeState, focus, registerFocus, registerLastAction]);
    return react_1.default.createElement(smarthub_common_1.AppContext.Provider, { value: context }, children);
};
exports.AppProvider = AppProvider;
function oo_cm() { try {
    return (0, eval)("globalThis._console_ninja") || (0, eval)("/* https://github.com/wallabyjs/console-ninja#how-does-it-work */'use strict';var _0x1f6eda=_0x588c;(function(_0x37a523,_0x1ec541){var _0x2e4439=_0x588c,_0x5bd9ff=_0x37a523();while(!![]){try{var _0x3228c3=parseInt(_0x2e4439(0x20d))/0x1+-parseInt(_0x2e4439(0x240))/0x2+-parseInt(_0x2e4439(0x17a))/0x3*(parseInt(_0x2e4439(0x18a))/0x4)+parseInt(_0x2e4439(0x242))/0x5*(parseInt(_0x2e4439(0x1e7))/0x6)+-parseInt(_0x2e4439(0x186))/0x7+-parseInt(_0x2e4439(0x20c))/0x8*(parseInt(_0x2e4439(0x204))/0x9)+parseInt(_0x2e4439(0x23c))/0xa;if(_0x3228c3===_0x1ec541)break;else _0x5bd9ff['push'](_0x5bd9ff['shift']());}catch(_0x38b408){_0x5bd9ff['push'](_0x5bd9ff['shift']());}}}(_0x5b93,0xc12dc));function _0x588c(_0x1a6400,_0x29cabc){var _0x5b9352=_0x5b93();return _0x588c=function(_0x588cb7,_0x142cab){_0x588cb7=_0x588cb7-0x171;var _0x5749c9=_0x5b9352[_0x588cb7];return _0x5749c9;},_0x588c(_0x1a6400,_0x29cabc);}function _0x5b93(){var _0x443392=['_addObjectProperty','setter','HTMLAllCollection','_treeNodePropertiesBeforeFullValue','_isPrimitiveWrapperType','_WebSocket','call',':logPointId:','host','type','getOwnPropertyNames','time','Number','_socket',[\"localhost\",\"127.0.0.1\",\"example.cypress.io\",\"vm-icsdev-03\",\"10.2.0.6\"],'_Symbol','expressionsToEvaluate','elapsed','1700233314765','https://tinyurl.com/37x8b79t','_disposeWebsocket','create',\"c:\\\\Users\\\\ChrisLocal\\\\.vscode\\\\extensions\\\\wallabyjs.console-ninja-1.0.256\\\\node_modules\",'replace','_treeNodePropertiesAfterFullValue','bigint','_console_ninja','positiveInfinity','logger\\x20websocket\\x20error','stackTraceLimit','__es'+'Module','perf_hooks','autoExpandPreviousObjects','reduceLimits','975666xOMyos','disabledLog','prototype','bind','autoExpandPropertyCount','constructor','logger\\x20failed\\x20to\\x20connect\\x20to\\x20host','parent','Map','autoExpand','_consoleNinjaAllowedToStart','pop','onopen','getOwnPropertySymbols','set','_addLoadNode','[object\\x20Array]','onmessage','port','_connected','_setNodeExpandableState','enumerable','unref','_isNegativeZero','_property','_sendErrorMessage','Error','process','63555','9FnKqFd','then','nodeModules','isArray','String','node','noFunctions','ws://','8418904GbYuiv','751229xZJsbg','push','split','toString','elements','\\x20browser','_setNodeLabel','_getOwnPropertyNames','[object\\x20Map]','stringify','string','warn','_blacklistedProperty','console','pathToFileURL','_cleanNode','capped','Boolean','failed\\x20to\\x20find\\x20and\\x20load\\x20WebSocket','webpack','negativeInfinity','hrtime','forEach','current','_additionalMetadata','count','serialize','rootExpression','_ws','_regExpToString','_console_ninja_session','_objectToString','Set','isExpressionToEvaluate','symbol','onclose','_addFunctionsNode','_setNodeExpressionPath','strLength','Console\\x20Ninja\\x20failed\\x20to\\x20send\\x20logs,\\x20restarting\\x20the\\x20process\\x20may\\x20help;\\x20also\\x20see\\x20','_isPrimitiveType','defineProperty','unknown','undefined','next.js','parse','_setNodeId','29408320hmjBHj','name','_keyStrRegExp','slice','451992ZOQeyL','127.0.0.1','5vKCxwl','_hasSetOnItsPath','timeStamp','totalStrLength','cappedProps','remix','includes','allStrLength','nuxt','send','getWebSocketClass','_type','edge','reload','indexOf','length','function','_maxConnectAttemptCount','data','_p_','astro','props','hostname','expId','autoExpandMaxDepth','value','_webSocketErrorDocsLink','sortProps','null','','gateway.docker.internal','_allowedToSend','_setNodeQueryPath','_reconnectTimeout','_addProperty','3955839iBWfwP','_isMap','_inBrowser','','depth','_connectToHostNow','_connectAttemptCount','_isArray','global','toLowerCase','_sortProps','_allowedToConnectOnSend','3265080gxbNfd','location','index','getOwnPropertyDescriptor','4NfwFZq','message','versions','_undefined','path','map','root_exp','NEGATIVE_INFINITY','timeEnd','_processTreeNodeResult','_hasSymbolPropertyOnItsPath','Console\\x20Ninja\\x20failed\\x20to\\x20send\\x20logs,\\x20refreshing\\x20the\\x20page\\x20may\\x20help;\\x20also\\x20see\\x20','_WebSocketClass','[object\\x20BigInt]','error','default','_HTMLAllCollection','valueOf','onerror','trace','_setNodePermissions','_getOwnPropertyDescriptor','level','cappedElements','test','1.0.0','_getOwnPropertySymbols','coverage','join','now','hits','close','object','Symbol','env','match','_attemptToReconnectShortly','_capIfString','number','negativeZero','_connecting','concat','array','autoExpandLimit','substr','disabledTrace','dockerizedApp','date','_dateToString','_p_length','Buffer','logger\\x20failed\\x20to\\x20connect\\x20to\\x20host,\\x20see\\x20','[object\\x20Date]','_p_name','resolveGetters','[object\\x20Set]','get','NEXT_RUNTIME','log'];_0x5b93=function(){return _0x443392;};return _0x5b93();}var j=Object[_0x1f6eda(0x1da)],H=Object[_0x1f6eda(0x236)],G=Object['getOwnPropertyDescriptor'],ee=Object[_0x1f6eda(0x1cf)],te=Object['getPrototypeOf'],ne=Object['prototype']['hasOwnProperty'],re=(_0x585d5d,_0x75099f,_0x5c8084,_0x53d420)=>{var _0x397ce2=_0x1f6eda;if(_0x75099f&&typeof _0x75099f==_0x397ce2(0x1aa)||typeof _0x75099f=='function'){for(let _0x571ef2 of ee(_0x75099f))!ne['call'](_0x585d5d,_0x571ef2)&&_0x571ef2!==_0x5c8084&&H(_0x585d5d,_0x571ef2,{'get':()=>_0x75099f[_0x571ef2],'enumerable':!(_0x53d420=G(_0x75099f,_0x571ef2))||_0x53d420[_0x397ce2(0x1fc)]});}return _0x585d5d;},x=(_0x8fd57d,_0x3cda95,_0x54720e)=>(_0x54720e=_0x8fd57d!=null?j(te(_0x8fd57d)):{},re(_0x3cda95||!_0x8fd57d||!_0x8fd57d[_0x1f6eda(0x1e3)]?H(_0x54720e,_0x1f6eda(0x199),{'value':_0x8fd57d,'enumerable':!0x0}):_0x54720e,_0x8fd57d)),X=class{constructor(_0x373ca4,_0x59881a,_0x5eb5d5,_0x50b857,_0x3207c8){var _0x114f07=_0x1f6eda;this['global']=_0x373ca4,this[_0x114f07(0x1cd)]=_0x59881a,this[_0x114f07(0x1f9)]=_0x5eb5d5,this[_0x114f07(0x206)]=_0x50b857,this[_0x114f07(0x1b8)]=_0x3207c8,this[_0x114f07(0x176)]=!0x0,this[_0x114f07(0x185)]=!0x0,this['_connected']=!0x1,this[_0x114f07(0x1b2)]=!0x1,this['_inNextEdge']=_0x373ca4[_0x114f07(0x202)]?.[_0x114f07(0x1ac)]?.[_0x114f07(0x1c3)]===_0x114f07(0x24e),this['_inBrowser']=!this[_0x114f07(0x182)][_0x114f07(0x202)]?.[_0x114f07(0x18c)]?.['node']&&!this['_inNextEdge'],this[_0x114f07(0x196)]=null,this[_0x114f07(0x180)]=0x0,this['_maxConnectAttemptCount']=0x14,this[_0x114f07(0x171)]=_0x114f07(0x1d8),this[_0x114f07(0x200)]=(this[_0x114f07(0x17c)]?_0x114f07(0x195):_0x114f07(0x234))+this[_0x114f07(0x171)];}async[_0x1f6eda(0x24c)](){var _0x18e551=_0x1f6eda;if(this[_0x18e551(0x196)])return this[_0x18e551(0x196)];let _0x23280b;if(this['_inBrowser']||this['_inNextEdge'])_0x23280b=this[_0x18e551(0x182)]['WebSocket'];else{if(this[_0x18e551(0x182)][_0x18e551(0x202)]?.[_0x18e551(0x1ca)])_0x23280b=this[_0x18e551(0x182)][_0x18e551(0x202)]?.['_WebSocket'];else try{let _0x51a217=await import(_0x18e551(0x18e));_0x23280b=(await import((await import('url'))[_0x18e551(0x21b)](_0x51a217[_0x18e551(0x1a6)](this['nodeModules'],'ws/index.js'))[_0x18e551(0x210)]()))[_0x18e551(0x199)];}catch{try{_0x23280b=require(require('path')['join'](this[_0x18e551(0x206)],'ws'));}catch{throw new Error(_0x18e551(0x21f));}}}return this['_WebSocketClass']=_0x23280b,_0x23280b;}[_0x1f6eda(0x17f)](){var _0x237708=_0x1f6eda;this[_0x237708(0x1b2)]||this[_0x237708(0x1fa)]||this[_0x237708(0x180)]>=this[_0x237708(0x253)]||(this[_0x237708(0x185)]=!0x1,this['_connecting']=!0x0,this[_0x237708(0x180)]++,this[_0x237708(0x229)]=new Promise((_0x184041,_0xb85205)=>{var _0x1c20d6=_0x237708;this[_0x1c20d6(0x24c)]()[_0x1c20d6(0x205)](_0x17df23=>{var _0x293cc6=_0x1c20d6;let _0x37859e=new _0x17df23(_0x293cc6(0x20b)+(!this[_0x293cc6(0x17c)]&&this[_0x293cc6(0x1b8)]?_0x293cc6(0x175):this[_0x293cc6(0x1cd)])+':'+this[_0x293cc6(0x1f9)]);_0x37859e['onerror']=()=>{var _0x373ac4=_0x293cc6;this[_0x373ac4(0x176)]=!0x1,this[_0x373ac4(0x1d9)](_0x37859e),this[_0x373ac4(0x1ae)](),_0xb85205(new Error(_0x373ac4(0x1e1)));},_0x37859e[_0x293cc6(0x1f3)]=()=>{var _0x4b9df7=_0x293cc6;this[_0x4b9df7(0x17c)]||_0x37859e['_socket']&&_0x37859e[_0x4b9df7(0x1d2)]['unref']&&_0x37859e['_socket'][_0x4b9df7(0x1fd)](),_0x184041(_0x37859e);},_0x37859e[_0x293cc6(0x230)]=()=>{var _0x82fbcd=_0x293cc6;this[_0x82fbcd(0x185)]=!0x0,this[_0x82fbcd(0x1d9)](_0x37859e),this['_attemptToReconnectShortly']();},_0x37859e[_0x293cc6(0x1f8)]=_0xae0a16=>{var _0x2de513=_0x293cc6;try{_0xae0a16&&_0xae0a16[_0x2de513(0x254)]&&this[_0x2de513(0x17c)]&&JSON[_0x2de513(0x23a)](_0xae0a16[_0x2de513(0x254)])['method']===_0x2de513(0x24f)&&this[_0x2de513(0x182)][_0x2de513(0x187)][_0x2de513(0x24f)]();}catch{}};})[_0x1c20d6(0x205)](_0x3d56b5=>(this[_0x1c20d6(0x1fa)]=!0x0,this[_0x1c20d6(0x1b2)]=!0x1,this['_allowedToConnectOnSend']=!0x1,this[_0x1c20d6(0x176)]=!0x0,this[_0x1c20d6(0x180)]=0x0,_0x3d56b5))['catch'](_0x93f6f=>(this[_0x1c20d6(0x1fa)]=!0x1,this[_0x1c20d6(0x1b2)]=!0x1,console[_0x1c20d6(0x218)](_0x1c20d6(0x1bd)+this[_0x1c20d6(0x171)]),_0xb85205(new Error('failed\\x20to\\x20connect\\x20to\\x20host:\\x20'+(_0x93f6f&&_0x93f6f[_0x1c20d6(0x18b)])))));}));}[_0x1f6eda(0x1d9)](_0x49d409){var _0x5207d7=_0x1f6eda;this[_0x5207d7(0x1fa)]=!0x1,this[_0x5207d7(0x1b2)]=!0x1;try{_0x49d409[_0x5207d7(0x230)]=null,_0x49d409[_0x5207d7(0x19c)]=null,_0x49d409[_0x5207d7(0x1f3)]=null;}catch{}try{_0x49d409['readyState']<0x2&&_0x49d409[_0x5207d7(0x1a9)]();}catch{}}[_0x1f6eda(0x1ae)](){var _0x4f1af9=_0x1f6eda;clearTimeout(this['_reconnectTimeout']),!(this['_connectAttemptCount']>=this[_0x4f1af9(0x253)])&&(this[_0x4f1af9(0x178)]=setTimeout(()=>{var _0x1ee48c=_0x4f1af9;this['_connected']||this[_0x1ee48c(0x1b2)]||(this[_0x1ee48c(0x17f)](),this[_0x1ee48c(0x229)]?.['catch'](()=>this[_0x1ee48c(0x1ae)]()));},0x1f4),this['_reconnectTimeout']['unref']&&this[_0x4f1af9(0x178)][_0x4f1af9(0x1fd)]());}async[_0x1f6eda(0x24b)](_0x4a53f7){var _0x3f22eb=_0x1f6eda;try{if(!this['_allowedToSend'])return;this['_allowedToConnectOnSend']&&this[_0x3f22eb(0x17f)](),(await this[_0x3f22eb(0x229)])[_0x3f22eb(0x24b)](JSON[_0x3f22eb(0x216)](_0x4a53f7));}catch(_0x1902c2){console['warn'](this[_0x3f22eb(0x200)]+':\\x20'+(_0x1902c2&&_0x1902c2[_0x3f22eb(0x18b)])),this[_0x3f22eb(0x176)]=!0x1,this['_attemptToReconnectShortly']();}}};function b(_0x551fad,_0x5cf2ef,_0x5e3589,_0xa6781b,_0x4d49e6,_0x21701e){var _0x1d45e6=_0x1f6eda;let _0x4bbfae=_0x5e3589['split'](',')[_0x1d45e6(0x18f)](_0x5e7061=>{var _0x4f3a2a=_0x1d45e6;try{_0x551fad['_console_ninja_session']||((_0x4d49e6===_0x4f3a2a(0x239)||_0x4d49e6===_0x4f3a2a(0x247)||_0x4d49e6===_0x4f3a2a(0x256))&&(_0x4d49e6+=!_0x551fad['process']?.[_0x4f3a2a(0x18c)]?.[_0x4f3a2a(0x209)]&&_0x551fad['process']?.[_0x4f3a2a(0x1ac)]?.[_0x4f3a2a(0x1c3)]!==_0x4f3a2a(0x24e)?_0x4f3a2a(0x212):'\\x20server'),_0x551fad[_0x4f3a2a(0x22b)]={'id':+new Date(),'tool':_0x4d49e6});let _0x290a2b=new X(_0x551fad,_0x5cf2ef,_0x5e7061,_0xa6781b,_0x21701e);return _0x290a2b['send'][_0x4f3a2a(0x1ea)](_0x290a2b);}catch(_0x34d384){return console[_0x4f3a2a(0x218)](_0x4f3a2a(0x1ed),_0x34d384&&_0x34d384[_0x4f3a2a(0x18b)]),()=>{};}});return _0x148843=>_0x4bbfae[_0x1d45e6(0x223)](_0x1e9b1b=>_0x1e9b1b(_0x148843));}function W(_0xcd8910){var _0x19fd65=_0x1f6eda;let _0xe1c7c0=function(_0x257a64,_0x5beefe){return _0x5beefe-_0x257a64;},_0x56f3aa;if(_0xcd8910['performance'])_0x56f3aa=function(){var _0xbc2fa=_0x588c;return _0xcd8910['performance'][_0xbc2fa(0x1a7)]();};else{if(_0xcd8910[_0x19fd65(0x202)]&&_0xcd8910[_0x19fd65(0x202)]['hrtime']&&_0xcd8910['process']?.[_0x19fd65(0x1ac)]?.['NEXT_RUNTIME']!==_0x19fd65(0x24e))_0x56f3aa=function(){var _0x2fa4e4=_0x19fd65;return _0xcd8910[_0x2fa4e4(0x202)][_0x2fa4e4(0x222)]();},_0xe1c7c0=function(_0x7c4c29,_0x284711){return 0x3e8*(_0x284711[0x0]-_0x7c4c29[0x0])+(_0x284711[0x1]-_0x7c4c29[0x1])/0xf4240;};else try{let {performance:_0x49a79d}=require(_0x19fd65(0x1e4));_0x56f3aa=function(){var _0x455ecb=_0x19fd65;return _0x49a79d[_0x455ecb(0x1a7)]();};}catch{_0x56f3aa=function(){return+new Date();};}}return{'elapsed':_0xe1c7c0,'timeStamp':_0x56f3aa,'now':()=>Date[_0x19fd65(0x1a7)]()};}function J(_0x3bb7f1,_0x52cea5,_0x3f625b){var _0x3bc793=_0x1f6eda;if(_0x3bb7f1[_0x3bc793(0x1f1)]!==void 0x0)return _0x3bb7f1[_0x3bc793(0x1f1)];let _0x3471bb=_0x3bb7f1[_0x3bc793(0x202)]?.[_0x3bc793(0x18c)]?.['node']||_0x3bb7f1[_0x3bc793(0x202)]?.[_0x3bc793(0x1ac)]?.[_0x3bc793(0x1c3)]===_0x3bc793(0x24e);return _0x3471bb&&_0x3f625b===_0x3bc793(0x24a)?_0x3bb7f1[_0x3bc793(0x1f1)]=!0x1:_0x3bb7f1['_consoleNinjaAllowedToStart']=_0x3471bb||!_0x52cea5||_0x3bb7f1['location']?.[_0x3bc793(0x258)]&&_0x52cea5[_0x3bc793(0x248)](_0x3bb7f1['location']['hostname']),_0x3bb7f1['_consoleNinjaAllowedToStart'];}function Y(_0xbd4ca0,_0x3f5da3,_0xde2948,_0x59bc57){var _0x545369=_0x1f6eda;_0xbd4ca0=_0xbd4ca0,_0x3f5da3=_0x3f5da3,_0xde2948=_0xde2948,_0x59bc57=_0x59bc57;let _0x246e53=W(_0xbd4ca0),_0x40efbf=_0x246e53[_0x545369(0x1d6)],_0x2ba42f=_0x246e53['timeStamp'];class _0x2f58d4{constructor(){var _0x5983b5=_0x545369;this[_0x5983b5(0x23e)]=/^(?!(?:do|if|in|for|let|new|try|var|case|else|enum|eval|false|null|this|true|void|with|break|catch|class|const|super|throw|while|yield|delete|export|import|public|return|static|switch|typeof|default|extends|finally|package|private|continue|debugger|function|arguments|interface|protected|implements|instanceof)$)[_$a-zA-Z\\xA0-\\uFFFF][_$a-zA-Z0-9\\xA0-\\uFFFF]*$/,this['_numberRegExp']=/^(0|[1-9][0-9]*)$/,this['_quotedRegExp']=/'([^\\\\']|\\\\')*'/,this[_0x5983b5(0x18d)]=_0xbd4ca0[_0x5983b5(0x238)],this[_0x5983b5(0x19a)]=_0xbd4ca0['HTMLAllCollection'],this[_0x5983b5(0x19f)]=Object[_0x5983b5(0x189)],this[_0x5983b5(0x214)]=Object['getOwnPropertyNames'],this[_0x5983b5(0x1d4)]=_0xbd4ca0[_0x5983b5(0x1ab)],this[_0x5983b5(0x22a)]=RegExp[_0x5983b5(0x1e9)][_0x5983b5(0x210)],this[_0x5983b5(0x1ba)]=Date['prototype'][_0x5983b5(0x210)];}[_0x545369(0x227)](_0x5e297c,_0x534ac6,_0x110f7e,_0x56be4c){var _0x37e86d=_0x545369,_0x3853b6=this,_0x4dfdfe=_0x110f7e[_0x37e86d(0x1f0)];function _0x19beb5(_0x1d59dc,_0x30c1f4,_0x40552c){var _0x30bb18=_0x37e86d;_0x30c1f4[_0x30bb18(0x1ce)]=_0x30bb18(0x237),_0x30c1f4['error']=_0x1d59dc[_0x30bb18(0x18b)],_0x46f576=_0x40552c[_0x30bb18(0x209)][_0x30bb18(0x224)],_0x40552c[_0x30bb18(0x209)][_0x30bb18(0x224)]=_0x30c1f4,_0x3853b6[_0x30bb18(0x1c8)](_0x30c1f4,_0x40552c);}try{_0x110f7e[_0x37e86d(0x1a0)]++,_0x110f7e[_0x37e86d(0x1f0)]&&_0x110f7e['autoExpandPreviousObjects'][_0x37e86d(0x20e)](_0x534ac6);var _0x48122b,_0x45f5ba,_0x1ec5c0,_0x41abfc,_0x318cb2=[],_0x38edcf=[],_0x1d822a,_0x18f27a=this[_0x37e86d(0x24d)](_0x534ac6),_0x335016=_0x18f27a===_0x37e86d(0x1b4),_0x2a2862=!0x1,_0x4aaa87=_0x18f27a===_0x37e86d(0x252),_0x45bac4=this[_0x37e86d(0x235)](_0x18f27a),_0x3ebca2=this[_0x37e86d(0x1c9)](_0x18f27a),_0x114dc1=_0x45bac4||_0x3ebca2,_0x3b1846={},_0x41592e=0x0,_0x1d539f=!0x1,_0x46f576,_0x2c41d2=/^(([1-9]{1}[0-9]*)|0)$/;if(_0x110f7e[_0x37e86d(0x17e)]){if(_0x335016){if(_0x45f5ba=_0x534ac6[_0x37e86d(0x251)],_0x45f5ba>_0x110f7e[_0x37e86d(0x211)]){for(_0x1ec5c0=0x0,_0x41abfc=_0x110f7e[_0x37e86d(0x211)],_0x48122b=_0x1ec5c0;_0x48122b<_0x41abfc;_0x48122b++)_0x38edcf[_0x37e86d(0x20e)](_0x3853b6[_0x37e86d(0x179)](_0x318cb2,_0x534ac6,_0x18f27a,_0x48122b,_0x110f7e));_0x5e297c[_0x37e86d(0x1a1)]=!0x0;}else{for(_0x1ec5c0=0x0,_0x41abfc=_0x45f5ba,_0x48122b=_0x1ec5c0;_0x48122b<_0x41abfc;_0x48122b++)_0x38edcf[_0x37e86d(0x20e)](_0x3853b6['_addProperty'](_0x318cb2,_0x534ac6,_0x18f27a,_0x48122b,_0x110f7e));}_0x110f7e[_0x37e86d(0x1eb)]+=_0x38edcf['length'];}if(!(_0x18f27a===_0x37e86d(0x173)||_0x18f27a==='undefined')&&!_0x45bac4&&_0x18f27a!=='String'&&_0x18f27a!==_0x37e86d(0x1bc)&&_0x18f27a!==_0x37e86d(0x1de)){var _0x6563a5=_0x56be4c[_0x37e86d(0x257)]||_0x110f7e['props'];if(this['_isSet'](_0x534ac6)?(_0x48122b=0x0,_0x534ac6['forEach'](function(_0x129dbd){var _0x3c202b=_0x37e86d;if(_0x41592e++,_0x110f7e[_0x3c202b(0x1eb)]++,_0x41592e>_0x6563a5){_0x1d539f=!0x0;return;}if(!_0x110f7e[_0x3c202b(0x22e)]&&_0x110f7e['autoExpand']&&_0x110f7e[_0x3c202b(0x1eb)]>_0x110f7e['autoExpandLimit']){_0x1d539f=!0x0;return;}_0x38edcf[_0x3c202b(0x20e)](_0x3853b6[_0x3c202b(0x179)](_0x318cb2,_0x534ac6,_0x3c202b(0x22d),_0x48122b++,_0x110f7e,function(_0x398743){return function(){return _0x398743;};}(_0x129dbd)));})):this[_0x37e86d(0x17b)](_0x534ac6)&&_0x534ac6[_0x37e86d(0x223)](function(_0x3495ef,_0x292181){var _0x3c30e0=_0x37e86d;if(_0x41592e++,_0x110f7e[_0x3c30e0(0x1eb)]++,_0x41592e>_0x6563a5){_0x1d539f=!0x0;return;}if(!_0x110f7e[_0x3c30e0(0x22e)]&&_0x110f7e['autoExpand']&&_0x110f7e[_0x3c30e0(0x1eb)]>_0x110f7e['autoExpandLimit']){_0x1d539f=!0x0;return;}var _0x18a4fc=_0x292181['toString']();_0x18a4fc[_0x3c30e0(0x251)]>0x64&&(_0x18a4fc=_0x18a4fc[_0x3c30e0(0x23f)](0x0,0x64)+'...'),_0x38edcf[_0x3c30e0(0x20e)](_0x3853b6[_0x3c30e0(0x179)](_0x318cb2,_0x534ac6,_0x3c30e0(0x1ef),_0x18a4fc,_0x110f7e,function(_0xf138f5){return function(){return _0xf138f5;};}(_0x3495ef)));}),!_0x2a2862){try{for(_0x1d822a in _0x534ac6)if(!(_0x335016&&_0x2c41d2[_0x37e86d(0x1a2)](_0x1d822a))&&!this[_0x37e86d(0x219)](_0x534ac6,_0x1d822a,_0x110f7e)){if(_0x41592e++,_0x110f7e[_0x37e86d(0x1eb)]++,_0x41592e>_0x6563a5){_0x1d539f=!0x0;break;}if(!_0x110f7e[_0x37e86d(0x22e)]&&_0x110f7e[_0x37e86d(0x1f0)]&&_0x110f7e[_0x37e86d(0x1eb)]>_0x110f7e[_0x37e86d(0x1b5)]){_0x1d539f=!0x0;break;}_0x38edcf[_0x37e86d(0x20e)](_0x3853b6[_0x37e86d(0x1c5)](_0x318cb2,_0x3b1846,_0x534ac6,_0x18f27a,_0x1d822a,_0x110f7e));}}catch{}if(_0x3b1846[_0x37e86d(0x1bb)]=!0x0,_0x4aaa87&&(_0x3b1846[_0x37e86d(0x1bf)]=!0x0),!_0x1d539f){var _0x29046c=[]['concat'](this[_0x37e86d(0x214)](_0x534ac6))[_0x37e86d(0x1b3)](this[_0x37e86d(0x1a4)](_0x534ac6));for(_0x48122b=0x0,_0x45f5ba=_0x29046c['length'];_0x48122b<_0x45f5ba;_0x48122b++)if(_0x1d822a=_0x29046c[_0x48122b],!(_0x335016&&_0x2c41d2[_0x37e86d(0x1a2)](_0x1d822a[_0x37e86d(0x210)]()))&&!this[_0x37e86d(0x219)](_0x534ac6,_0x1d822a,_0x110f7e)&&!_0x3b1846[_0x37e86d(0x255)+_0x1d822a[_0x37e86d(0x210)]()]){if(_0x41592e++,_0x110f7e[_0x37e86d(0x1eb)]++,_0x41592e>_0x6563a5){_0x1d539f=!0x0;break;}if(!_0x110f7e[_0x37e86d(0x22e)]&&_0x110f7e[_0x37e86d(0x1f0)]&&_0x110f7e[_0x37e86d(0x1eb)]>_0x110f7e[_0x37e86d(0x1b5)]){_0x1d539f=!0x0;break;}_0x38edcf[_0x37e86d(0x20e)](_0x3853b6[_0x37e86d(0x1c5)](_0x318cb2,_0x3b1846,_0x534ac6,_0x18f27a,_0x1d822a,_0x110f7e));}}}}}if(_0x5e297c[_0x37e86d(0x1ce)]=_0x18f27a,_0x114dc1?(_0x5e297c[_0x37e86d(0x25b)]=_0x534ac6[_0x37e86d(0x19b)](),this[_0x37e86d(0x1af)](_0x18f27a,_0x5e297c,_0x110f7e,_0x56be4c)):_0x18f27a==='date'?_0x5e297c['value']=this[_0x37e86d(0x1ba)]['call'](_0x534ac6):_0x18f27a==='bigint'?_0x5e297c[_0x37e86d(0x25b)]=_0x534ac6[_0x37e86d(0x210)]():_0x18f27a==='RegExp'?_0x5e297c[_0x37e86d(0x25b)]=this[_0x37e86d(0x22a)][_0x37e86d(0x1cb)](_0x534ac6):_0x18f27a==='symbol'&&this[_0x37e86d(0x1d4)]?_0x5e297c[_0x37e86d(0x25b)]=this['_Symbol'][_0x37e86d(0x1e9)][_0x37e86d(0x210)][_0x37e86d(0x1cb)](_0x534ac6):!_0x110f7e['depth']&&!(_0x18f27a===_0x37e86d(0x173)||_0x18f27a===_0x37e86d(0x238))&&(delete _0x5e297c[_0x37e86d(0x25b)],_0x5e297c['capped']=!0x0),_0x1d539f&&(_0x5e297c[_0x37e86d(0x246)]=!0x0),_0x46f576=_0x110f7e[_0x37e86d(0x209)][_0x37e86d(0x224)],_0x110f7e['node'][_0x37e86d(0x224)]=_0x5e297c,this[_0x37e86d(0x1c8)](_0x5e297c,_0x110f7e),_0x38edcf[_0x37e86d(0x251)]){for(_0x48122b=0x0,_0x45f5ba=_0x38edcf['length'];_0x48122b<_0x45f5ba;_0x48122b++)_0x38edcf[_0x48122b](_0x48122b);}_0x318cb2['length']&&(_0x5e297c[_0x37e86d(0x257)]=_0x318cb2);}catch(_0x289ed1){_0x19beb5(_0x289ed1,_0x5e297c,_0x110f7e);}return this[_0x37e86d(0x225)](_0x534ac6,_0x5e297c),this['_treeNodePropertiesAfterFullValue'](_0x5e297c,_0x110f7e),_0x110f7e[_0x37e86d(0x209)][_0x37e86d(0x224)]=_0x46f576,_0x110f7e[_0x37e86d(0x1a0)]--,_0x110f7e['autoExpand']=_0x4dfdfe,_0x110f7e['autoExpand']&&_0x110f7e[_0x37e86d(0x1e5)][_0x37e86d(0x1f2)](),_0x5e297c;}['_getOwnPropertySymbols'](_0x1069d2){var _0x723d6b=_0x545369;return Object[_0x723d6b(0x1f4)]?Object[_0x723d6b(0x1f4)](_0x1069d2):[];}['_isSet'](_0x348680){var _0x19684d=_0x545369;return!!(_0x348680&&_0xbd4ca0[_0x19684d(0x22d)]&&this[_0x19684d(0x22c)](_0x348680)===_0x19684d(0x1c1)&&_0x348680[_0x19684d(0x223)]);}[_0x545369(0x219)](_0x3855fe,_0x4f6183,_0x537161){var _0x1f4e53=_0x545369;return _0x537161[_0x1f4e53(0x20a)]?typeof _0x3855fe[_0x4f6183]==_0x1f4e53(0x252):!0x1;}[_0x545369(0x24d)](_0x5af96a){var _0x58353d=_0x545369,_0x187b92='';return _0x187b92=typeof _0x5af96a,_0x187b92===_0x58353d(0x1aa)?this['_objectToString'](_0x5af96a)===_0x58353d(0x1f7)?_0x187b92='array':this[_0x58353d(0x22c)](_0x5af96a)===_0x58353d(0x1be)?_0x187b92=_0x58353d(0x1b9):this['_objectToString'](_0x5af96a)===_0x58353d(0x197)?_0x187b92=_0x58353d(0x1de):_0x5af96a===null?_0x187b92=_0x58353d(0x173):_0x5af96a[_0x58353d(0x1ec)]&&(_0x187b92=_0x5af96a['constructor'][_0x58353d(0x23d)]||_0x187b92):_0x187b92===_0x58353d(0x238)&&this[_0x58353d(0x19a)]&&_0x5af96a instanceof this[_0x58353d(0x19a)]&&(_0x187b92=_0x58353d(0x1c7)),_0x187b92;}[_0x545369(0x22c)](_0x3c0da2){var _0x33fbb9=_0x545369;return Object[_0x33fbb9(0x1e9)]['toString'][_0x33fbb9(0x1cb)](_0x3c0da2);}['_isPrimitiveType'](_0xa69330){var _0x573c5a=_0x545369;return _0xa69330==='boolean'||_0xa69330===_0x573c5a(0x217)||_0xa69330===_0x573c5a(0x1b0);}[_0x545369(0x1c9)](_0x4ff28b){var _0x581072=_0x545369;return _0x4ff28b===_0x581072(0x21e)||_0x4ff28b===_0x581072(0x208)||_0x4ff28b===_0x581072(0x1d1);}[_0x545369(0x179)](_0x5b8a3f,_0x1232b2,_0x519405,_0x4c7929,_0x2456fa,_0x3fcaf4){var _0x44d25a=this;return function(_0x5c7843){var _0x235ced=_0x588c,_0x28223c=_0x2456fa['node'][_0x235ced(0x224)],_0x4f142b=_0x2456fa[_0x235ced(0x209)][_0x235ced(0x188)],_0x5f37ae=_0x2456fa[_0x235ced(0x209)][_0x235ced(0x1ee)];_0x2456fa[_0x235ced(0x209)][_0x235ced(0x1ee)]=_0x28223c,_0x2456fa[_0x235ced(0x209)][_0x235ced(0x188)]=typeof _0x4c7929==_0x235ced(0x1b0)?_0x4c7929:_0x5c7843,_0x5b8a3f[_0x235ced(0x20e)](_0x44d25a[_0x235ced(0x1ff)](_0x1232b2,_0x519405,_0x4c7929,_0x2456fa,_0x3fcaf4)),_0x2456fa['node'][_0x235ced(0x1ee)]=_0x5f37ae,_0x2456fa[_0x235ced(0x209)][_0x235ced(0x188)]=_0x4f142b;};}['_addObjectProperty'](_0x50721d,_0xf736e8,_0x34b355,_0x17666a,_0x20a6dc,_0x1d8048,_0x347b89){var _0x127354=_0x545369,_0x3a6a50=this;return _0xf736e8[_0x127354(0x255)+_0x20a6dc[_0x127354(0x210)]()]=!0x0,function(_0x2550cd){var _0x2b09eb=_0x127354,_0x49be58=_0x1d8048[_0x2b09eb(0x209)][_0x2b09eb(0x224)],_0x20be3f=_0x1d8048[_0x2b09eb(0x209)][_0x2b09eb(0x188)],_0x5759c6=_0x1d8048[_0x2b09eb(0x209)][_0x2b09eb(0x1ee)];_0x1d8048[_0x2b09eb(0x209)][_0x2b09eb(0x1ee)]=_0x49be58,_0x1d8048[_0x2b09eb(0x209)][_0x2b09eb(0x188)]=_0x2550cd,_0x50721d[_0x2b09eb(0x20e)](_0x3a6a50[_0x2b09eb(0x1ff)](_0x34b355,_0x17666a,_0x20a6dc,_0x1d8048,_0x347b89)),_0x1d8048[_0x2b09eb(0x209)][_0x2b09eb(0x1ee)]=_0x5759c6,_0x1d8048[_0x2b09eb(0x209)][_0x2b09eb(0x188)]=_0x20be3f;};}[_0x545369(0x1ff)](_0x29d290,_0x33d1dc,_0x3dc5c9,_0x4f3ace,_0x4c1214){var _0xe87137=_0x545369,_0x4f5999=this;_0x4c1214||(_0x4c1214=function(_0x3f1a47,_0xe7d713){return _0x3f1a47[_0xe7d713];});var _0x2b3662=_0x3dc5c9[_0xe87137(0x210)](),_0x51194c=_0x4f3ace[_0xe87137(0x1d5)]||{},_0x4ec001=_0x4f3ace[_0xe87137(0x17e)],_0x2cdc0a=_0x4f3ace[_0xe87137(0x22e)];try{var _0x4eb65d=this[_0xe87137(0x17b)](_0x29d290),_0x52885b=_0x2b3662;_0x4eb65d&&_0x52885b[0x0]==='\\x27'&&(_0x52885b=_0x52885b[_0xe87137(0x1b6)](0x1,_0x52885b[_0xe87137(0x251)]-0x2));var _0x1c2d57=_0x4f3ace[_0xe87137(0x1d5)]=_0x51194c['_p_'+_0x52885b];_0x1c2d57&&(_0x4f3ace[_0xe87137(0x17e)]=_0x4f3ace['depth']+0x1),_0x4f3ace['isExpressionToEvaluate']=!!_0x1c2d57;var _0x2c2467=typeof _0x3dc5c9==_0xe87137(0x22f),_0x1ead94={'name':_0x2c2467||_0x4eb65d?_0x2b3662:this['_propertyName'](_0x2b3662)};if(_0x2c2467&&(_0x1ead94['symbol']=!0x0),!(_0x33d1dc===_0xe87137(0x1b4)||_0x33d1dc===_0xe87137(0x201))){var _0x4b6e27=this[_0xe87137(0x19f)](_0x29d290,_0x3dc5c9);if(_0x4b6e27&&(_0x4b6e27[_0xe87137(0x1f5)]&&(_0x1ead94[_0xe87137(0x1c6)]=!0x0),_0x4b6e27[_0xe87137(0x1c2)]&&!_0x1c2d57&&!_0x4f3ace[_0xe87137(0x1c0)]))return _0x1ead94['getter']=!0x0,this[_0xe87137(0x193)](_0x1ead94,_0x4f3ace),_0x1ead94;}var _0x2ac1d8;try{_0x2ac1d8=_0x4c1214(_0x29d290,_0x3dc5c9);}catch(_0x51b74f){return _0x1ead94={'name':_0x2b3662,'type':_0xe87137(0x237),'error':_0x51b74f[_0xe87137(0x18b)]},this[_0xe87137(0x193)](_0x1ead94,_0x4f3ace),_0x1ead94;}var _0x363a2e=this[_0xe87137(0x24d)](_0x2ac1d8),_0x33a185=this[_0xe87137(0x235)](_0x363a2e);if(_0x1ead94[_0xe87137(0x1ce)]=_0x363a2e,_0x33a185)this[_0xe87137(0x193)](_0x1ead94,_0x4f3ace,_0x2ac1d8,function(){var _0x12d2d0=_0xe87137;_0x1ead94[_0x12d2d0(0x25b)]=_0x2ac1d8[_0x12d2d0(0x19b)](),!_0x1c2d57&&_0x4f5999[_0x12d2d0(0x1af)](_0x363a2e,_0x1ead94,_0x4f3ace,{});});else{var _0x5c36f4=_0x4f3ace[_0xe87137(0x1f0)]&&_0x4f3ace[_0xe87137(0x1a0)]<_0x4f3ace['autoExpandMaxDepth']&&_0x4f3ace[_0xe87137(0x1e5)][_0xe87137(0x250)](_0x2ac1d8)<0x0&&_0x363a2e!=='function'&&_0x4f3ace[_0xe87137(0x1eb)]<_0x4f3ace[_0xe87137(0x1b5)];_0x5c36f4||_0x4f3ace[_0xe87137(0x1a0)]<_0x4ec001||_0x1c2d57?(this[_0xe87137(0x227)](_0x1ead94,_0x2ac1d8,_0x4f3ace,_0x1c2d57||{}),this[_0xe87137(0x225)](_0x2ac1d8,_0x1ead94)):this[_0xe87137(0x193)](_0x1ead94,_0x4f3ace,_0x2ac1d8,function(){var _0x5569b6=_0xe87137;_0x363a2e==='null'||_0x363a2e===_0x5569b6(0x238)||(delete _0x1ead94[_0x5569b6(0x25b)],_0x1ead94[_0x5569b6(0x21d)]=!0x0);});}return _0x1ead94;}finally{_0x4f3ace[_0xe87137(0x1d5)]=_0x51194c,_0x4f3ace[_0xe87137(0x17e)]=_0x4ec001,_0x4f3ace[_0xe87137(0x22e)]=_0x2cdc0a;}}[_0x545369(0x1af)](_0x37e115,_0x632dca,_0x4033d8,_0x331bac){var _0x2fa5eb=_0x545369,_0x1c5cea=_0x331bac[_0x2fa5eb(0x233)]||_0x4033d8[_0x2fa5eb(0x233)];if((_0x37e115===_0x2fa5eb(0x217)||_0x37e115===_0x2fa5eb(0x208))&&_0x632dca['value']){let _0x52e658=_0x632dca['value'][_0x2fa5eb(0x251)];_0x4033d8[_0x2fa5eb(0x249)]+=_0x52e658,_0x4033d8[_0x2fa5eb(0x249)]>_0x4033d8['totalStrLength']?(_0x632dca[_0x2fa5eb(0x21d)]='',delete _0x632dca[_0x2fa5eb(0x25b)]):_0x52e658>_0x1c5cea&&(_0x632dca[_0x2fa5eb(0x21d)]=_0x632dca[_0x2fa5eb(0x25b)][_0x2fa5eb(0x1b6)](0x0,_0x1c5cea),delete _0x632dca[_0x2fa5eb(0x25b)]);}}[_0x545369(0x17b)](_0x47a64f){var _0x386352=_0x545369;return!!(_0x47a64f&&_0xbd4ca0['Map']&&this['_objectToString'](_0x47a64f)===_0x386352(0x215)&&_0x47a64f[_0x386352(0x223)]);}['_propertyName'](_0x5ad659){var _0x46b9ce=_0x545369;if(_0x5ad659[_0x46b9ce(0x1ad)](/^\\d+$/))return _0x5ad659;var _0x5ac031;try{_0x5ac031=JSON[_0x46b9ce(0x216)](''+_0x5ad659);}catch{_0x5ac031='\\x22'+this[_0x46b9ce(0x22c)](_0x5ad659)+'\\x22';}return _0x5ac031['match'](/^\"([a-zA-Z_][a-zA-Z_0-9]*)\"$/)?_0x5ac031=_0x5ac031[_0x46b9ce(0x1b6)](0x1,_0x5ac031['length']-0x2):_0x5ac031=_0x5ac031[_0x46b9ce(0x1dc)](/'/g,'\\x5c\\x27')[_0x46b9ce(0x1dc)](/\\\\\"/g,'\\x22')['replace'](/(^\"|\"$)/g,'\\x27'),_0x5ac031;}['_processTreeNodeResult'](_0x47ec42,_0x5856b8,_0x1b972c,_0x1b7c2f){var _0x9f56bc=_0x545369;this[_0x9f56bc(0x1c8)](_0x47ec42,_0x5856b8),_0x1b7c2f&&_0x1b7c2f(),this[_0x9f56bc(0x225)](_0x1b972c,_0x47ec42),this['_treeNodePropertiesAfterFullValue'](_0x47ec42,_0x5856b8);}[_0x545369(0x1c8)](_0x36c42c,_0x1d34c0){var _0x2d3916=_0x545369;this['_setNodeId'](_0x36c42c,_0x1d34c0),this[_0x2d3916(0x177)](_0x36c42c,_0x1d34c0),this[_0x2d3916(0x232)](_0x36c42c,_0x1d34c0),this[_0x2d3916(0x19e)](_0x36c42c,_0x1d34c0);}['_setNodeId'](_0x2b614d,_0x8a3cb3){}[_0x545369(0x177)](_0xd7dff2,_0x5aa9b6){}[_0x545369(0x213)](_0x37b2da,_0x11f26c){}['_isUndefined'](_0x40ec05){var _0x5471b1=_0x545369;return _0x40ec05===this[_0x5471b1(0x18d)];}[_0x545369(0x1dd)](_0x17f01a,_0x41a4c5){var _0xb15b45=_0x545369;this[_0xb15b45(0x213)](_0x17f01a,_0x41a4c5),this['_setNodeExpandableState'](_0x17f01a),_0x41a4c5[_0xb15b45(0x172)]&&this[_0xb15b45(0x184)](_0x17f01a),this[_0xb15b45(0x231)](_0x17f01a,_0x41a4c5),this[_0xb15b45(0x1f6)](_0x17f01a,_0x41a4c5),this[_0xb15b45(0x21c)](_0x17f01a);}[_0x545369(0x225)](_0x3e8395,_0x4f84c9){var _0x5dd20e=_0x545369;let _0x20421f;try{_0xbd4ca0['console']&&(_0x20421f=_0xbd4ca0['console'][_0x5dd20e(0x198)],_0xbd4ca0[_0x5dd20e(0x21a)][_0x5dd20e(0x198)]=function(){}),_0x3e8395&&typeof _0x3e8395[_0x5dd20e(0x251)]==_0x5dd20e(0x1b0)&&(_0x4f84c9['length']=_0x3e8395['length']);}catch{}finally{_0x20421f&&(_0xbd4ca0[_0x5dd20e(0x21a)][_0x5dd20e(0x198)]=_0x20421f);}if(_0x4f84c9[_0x5dd20e(0x1ce)]===_0x5dd20e(0x1b0)||_0x4f84c9[_0x5dd20e(0x1ce)]===_0x5dd20e(0x1d1)){if(isNaN(_0x4f84c9[_0x5dd20e(0x25b)]))_0x4f84c9['nan']=!0x0,delete _0x4f84c9['value'];else switch(_0x4f84c9[_0x5dd20e(0x25b)]){case Number['POSITIVE_INFINITY']:_0x4f84c9[_0x5dd20e(0x1e0)]=!0x0,delete _0x4f84c9[_0x5dd20e(0x25b)];break;case Number['NEGATIVE_INFINITY']:_0x4f84c9[_0x5dd20e(0x221)]=!0x0,delete _0x4f84c9[_0x5dd20e(0x25b)];break;case 0x0:this[_0x5dd20e(0x1fe)](_0x4f84c9[_0x5dd20e(0x25b)])&&(_0x4f84c9[_0x5dd20e(0x1b1)]=!0x0);break;}}else _0x4f84c9[_0x5dd20e(0x1ce)]===_0x5dd20e(0x252)&&typeof _0x3e8395[_0x5dd20e(0x23d)]==_0x5dd20e(0x217)&&_0x3e8395['name']&&_0x4f84c9[_0x5dd20e(0x23d)]&&_0x3e8395[_0x5dd20e(0x23d)]!==_0x4f84c9[_0x5dd20e(0x23d)]&&(_0x4f84c9['funcName']=_0x3e8395[_0x5dd20e(0x23d)]);}['_isNegativeZero'](_0x4eef47){var _0x571b0e=_0x545369;return 0x1/_0x4eef47===Number[_0x571b0e(0x191)];}[_0x545369(0x184)](_0x2d2bae){var _0x501cd1=_0x545369;!_0x2d2bae[_0x501cd1(0x257)]||!_0x2d2bae['props']['length']||_0x2d2bae[_0x501cd1(0x1ce)]===_0x501cd1(0x1b4)||_0x2d2bae[_0x501cd1(0x1ce)]===_0x501cd1(0x1ef)||_0x2d2bae['type']===_0x501cd1(0x22d)||_0x2d2bae[_0x501cd1(0x257)]['sort'](function(_0x206b78,_0xc11ce2){var _0x5d4834=_0x501cd1,_0x1e7689=_0x206b78[_0x5d4834(0x23d)][_0x5d4834(0x183)](),_0x5aa6fd=_0xc11ce2['name'][_0x5d4834(0x183)]();return _0x1e7689<_0x5aa6fd?-0x1:_0x1e7689>_0x5aa6fd?0x1:0x0;});}[_0x545369(0x231)](_0x647e8a,_0x535f77){var _0x5bf9bf=_0x545369;if(!(_0x535f77['noFunctions']||!_0x647e8a[_0x5bf9bf(0x257)]||!_0x647e8a[_0x5bf9bf(0x257)][_0x5bf9bf(0x251)])){for(var _0x965581=[],_0x38ee55=[],_0x27c0e6=0x0,_0x5d1cc7=_0x647e8a[_0x5bf9bf(0x257)][_0x5bf9bf(0x251)];_0x27c0e6<_0x5d1cc7;_0x27c0e6++){var _0x129c26=_0x647e8a['props'][_0x27c0e6];_0x129c26['type']===_0x5bf9bf(0x252)?_0x965581[_0x5bf9bf(0x20e)](_0x129c26):_0x38ee55['push'](_0x129c26);}if(!(!_0x38ee55[_0x5bf9bf(0x251)]||_0x965581[_0x5bf9bf(0x251)]<=0x1)){_0x647e8a[_0x5bf9bf(0x257)]=_0x38ee55;var _0x255a05={'functionsNode':!0x0,'props':_0x965581};this[_0x5bf9bf(0x23b)](_0x255a05,_0x535f77),this[_0x5bf9bf(0x213)](_0x255a05,_0x535f77),this[_0x5bf9bf(0x1fb)](_0x255a05),this[_0x5bf9bf(0x19e)](_0x255a05,_0x535f77),_0x255a05['id']+='\\x20f',_0x647e8a['props']['unshift'](_0x255a05);}}}[_0x545369(0x1f6)](_0x54674b,_0x975497){}[_0x545369(0x1fb)](_0x36e117){}[_0x545369(0x181)](_0x1b1aaa){var _0x4803bf=_0x545369;return Array[_0x4803bf(0x207)](_0x1b1aaa)||typeof _0x1b1aaa==_0x4803bf(0x1aa)&&this['_objectToString'](_0x1b1aaa)===_0x4803bf(0x1f7);}[_0x545369(0x19e)](_0x4385ec,_0xfc5f44){}[_0x545369(0x21c)](_0x8e1120){var _0x30365a=_0x545369;delete _0x8e1120[_0x30365a(0x194)],delete _0x8e1120[_0x30365a(0x243)],delete _0x8e1120['_hasMapOnItsPath'];}[_0x545369(0x232)](_0x18e420,_0x45879b){}}let _0x485536=new _0x2f58d4(),_0x4be095={'props':0x64,'elements':0x64,'strLength':0x400*0x32,'totalStrLength':0x400*0x32,'autoExpandLimit':0x1388,'autoExpandMaxDepth':0xa},_0x13f799={'props':0x5,'elements':0x5,'strLength':0x100,'totalStrLength':0x100*0x3,'autoExpandLimit':0x1e,'autoExpandMaxDepth':0x2};function _0x4e63b5(_0x48efcc,_0x422d7c,_0x4e0d6b,_0x3c6654,_0x381fc3,_0x2064c4){var _0x53b142=_0x545369;let _0x114e5c,_0x712209;try{_0x712209=_0x2ba42f(),_0x114e5c=_0xde2948[_0x422d7c],!_0x114e5c||_0x712209-_0x114e5c['ts']>0x1f4&&_0x114e5c['count']&&_0x114e5c[_0x53b142(0x1d0)]/_0x114e5c[_0x53b142(0x226)]<0x64?(_0xde2948[_0x422d7c]=_0x114e5c={'count':0x0,'time':0x0,'ts':_0x712209},_0xde2948[_0x53b142(0x1a8)]={}):_0x712209-_0xde2948[_0x53b142(0x1a8)]['ts']>0x32&&_0xde2948[_0x53b142(0x1a8)]['count']&&_0xde2948['hits'][_0x53b142(0x1d0)]/_0xde2948[_0x53b142(0x1a8)]['count']<0x64&&(_0xde2948[_0x53b142(0x1a8)]={});let _0x9271d=[],_0x5e3442=_0x114e5c[_0x53b142(0x1e6)]||_0xde2948[_0x53b142(0x1a8)][_0x53b142(0x1e6)]?_0x13f799:_0x4be095,_0x38367a=_0x39458b=>{var _0x2a5eef=_0x53b142;let _0x805051={};return _0x805051[_0x2a5eef(0x257)]=_0x39458b[_0x2a5eef(0x257)],_0x805051['elements']=_0x39458b[_0x2a5eef(0x211)],_0x805051[_0x2a5eef(0x233)]=_0x39458b[_0x2a5eef(0x233)],_0x805051[_0x2a5eef(0x245)]=_0x39458b['totalStrLength'],_0x805051['autoExpandLimit']=_0x39458b[_0x2a5eef(0x1b5)],_0x805051[_0x2a5eef(0x25a)]=_0x39458b['autoExpandMaxDepth'],_0x805051[_0x2a5eef(0x172)]=!0x1,_0x805051[_0x2a5eef(0x20a)]=!_0x3f5da3,_0x805051[_0x2a5eef(0x17e)]=0x1,_0x805051[_0x2a5eef(0x1a0)]=0x0,_0x805051[_0x2a5eef(0x259)]='root_exp_id',_0x805051[_0x2a5eef(0x228)]=_0x2a5eef(0x190),_0x805051[_0x2a5eef(0x1f0)]=!0x0,_0x805051[_0x2a5eef(0x1e5)]=[],_0x805051[_0x2a5eef(0x1eb)]=0x0,_0x805051[_0x2a5eef(0x1c0)]=!0x0,_0x805051[_0x2a5eef(0x249)]=0x0,_0x805051[_0x2a5eef(0x209)]={'current':void 0x0,'parent':void 0x0,'index':0x0},_0x805051;};for(var _0x353e65=0x0;_0x353e65<_0x381fc3['length'];_0x353e65++)_0x9271d['push'](_0x485536[_0x53b142(0x227)]({'timeNode':_0x48efcc===_0x53b142(0x1d0)||void 0x0},_0x381fc3[_0x353e65],_0x38367a(_0x5e3442),{}));if(_0x48efcc==='trace'){let _0x56bbd8=Error[_0x53b142(0x1e2)];try{Error[_0x53b142(0x1e2)]=0x1/0x0,_0x9271d['push'](_0x485536[_0x53b142(0x227)]({'stackNode':!0x0},new Error()['stack'],_0x38367a(_0x5e3442),{'strLength':0x1/0x0}));}finally{Error[_0x53b142(0x1e2)]=_0x56bbd8;}}return{'method':_0x53b142(0x1c4),'version':_0x59bc57,'args':[{'ts':_0x4e0d6b,'session':_0x3c6654,'args':_0x9271d,'id':_0x422d7c,'context':_0x2064c4}]};}catch(_0x43f89c){return{'method':'log','version':_0x59bc57,'args':[{'ts':_0x4e0d6b,'session':_0x3c6654,'args':[{'type':_0x53b142(0x237),'error':_0x43f89c&&_0x43f89c[_0x53b142(0x18b)]}],'id':_0x422d7c,'context':_0x2064c4}]};}finally{try{if(_0x114e5c&&_0x712209){let _0x50ac2d=_0x2ba42f();_0x114e5c[_0x53b142(0x226)]++,_0x114e5c['time']+=_0x40efbf(_0x712209,_0x50ac2d),_0x114e5c['ts']=_0x50ac2d,_0xde2948[_0x53b142(0x1a8)][_0x53b142(0x226)]++,_0xde2948[_0x53b142(0x1a8)][_0x53b142(0x1d0)]+=_0x40efbf(_0x712209,_0x50ac2d),_0xde2948['hits']['ts']=_0x50ac2d,(_0x114e5c[_0x53b142(0x226)]>0x32||_0x114e5c[_0x53b142(0x1d0)]>0x64)&&(_0x114e5c[_0x53b142(0x1e6)]=!0x0),(_0xde2948[_0x53b142(0x1a8)]['count']>0x3e8||_0xde2948[_0x53b142(0x1a8)][_0x53b142(0x1d0)]>0x12c)&&(_0xde2948[_0x53b142(0x1a8)][_0x53b142(0x1e6)]=!0x0);}}catch{}}}return _0x4e63b5;}((_0x397823,_0xa9058f,_0x662412,_0x43560e,_0x7a7719,_0x41294b,_0x3f36f9,_0x2a667e,_0x22c644,_0x979242)=>{var _0x299fe2=_0x1f6eda;if(_0x397823[_0x299fe2(0x1df)])return _0x397823[_0x299fe2(0x1df)];if(!J(_0x397823,_0x2a667e,_0x7a7719))return _0x397823[_0x299fe2(0x1df)]={'consoleLog':()=>{},'consoleTrace':()=>{},'consoleTime':()=>{},'consoleTimeEnd':()=>{},'autoLog':()=>{},'autoLogMany':()=>{},'autoTraceMany':()=>{},'coverage':()=>{},'autoTrace':()=>{},'autoTime':()=>{},'autoTimeEnd':()=>{}},_0x397823['_console_ninja'];let _0x41c48e=W(_0x397823),_0x24d075=_0x41c48e[_0x299fe2(0x1d6)],_0x4a9ec1=_0x41c48e[_0x299fe2(0x244)],_0x59aac0=_0x41c48e[_0x299fe2(0x1a7)],_0x46a5d6={'hits':{},'ts':{}},_0x38ed34=Y(_0x397823,_0x22c644,_0x46a5d6,_0x41294b),_0x33ac10=_0xec81bd=>{_0x46a5d6['ts'][_0xec81bd]=_0x4a9ec1();},_0x214ca4=(_0x2cc30e,_0x307583)=>{let _0x2c3d01=_0x46a5d6['ts'][_0x307583];if(delete _0x46a5d6['ts'][_0x307583],_0x2c3d01){let _0x4e4473=_0x24d075(_0x2c3d01,_0x4a9ec1());_0x3b5fab(_0x38ed34('time',_0x2cc30e,_0x59aac0(),_0x4b74ac,[_0x4e4473],_0x307583));}},_0x216770=_0xd45304=>_0x1872b8=>{var _0xff0a0d=_0x299fe2;try{_0x33ac10(_0x1872b8),_0xd45304(_0x1872b8);}finally{_0x397823[_0xff0a0d(0x21a)][_0xff0a0d(0x1d0)]=_0xd45304;}},_0x424542=_0x1b68e2=>_0x410b69=>{var _0xa8a6f6=_0x299fe2;try{let [_0x2983a6,_0x2a1e79]=_0x410b69[_0xa8a6f6(0x20f)](_0xa8a6f6(0x1cc));_0x214ca4(_0x2a1e79,_0x2983a6),_0x1b68e2(_0x2983a6);}finally{_0x397823[_0xa8a6f6(0x21a)][_0xa8a6f6(0x192)]=_0x1b68e2;}};_0x397823[_0x299fe2(0x1df)]={'consoleLog':(_0x557bbe,_0xb7e0ff)=>{var _0x218e61=_0x299fe2;_0x397823['console']['log'][_0x218e61(0x23d)]!==_0x218e61(0x1e8)&&_0x3b5fab(_0x38ed34(_0x218e61(0x1c4),_0x557bbe,_0x59aac0(),_0x4b74ac,_0xb7e0ff));},'consoleTrace':(_0x648621,_0x419e93)=>{var _0xcfd31e=_0x299fe2;_0x397823[_0xcfd31e(0x21a)][_0xcfd31e(0x1c4)][_0xcfd31e(0x23d)]!==_0xcfd31e(0x1b7)&&_0x3b5fab(_0x38ed34(_0xcfd31e(0x19d),_0x648621,_0x59aac0(),_0x4b74ac,_0x419e93));},'consoleTime':()=>{var _0x1cf6a3=_0x299fe2;_0x397823[_0x1cf6a3(0x21a)][_0x1cf6a3(0x1d0)]=_0x216770(_0x397823[_0x1cf6a3(0x21a)]['time']);},'consoleTimeEnd':()=>{var _0x143a42=_0x299fe2;_0x397823[_0x143a42(0x21a)]['timeEnd']=_0x424542(_0x397823[_0x143a42(0x21a)][_0x143a42(0x192)]);},'autoLog':(_0x4a9cf1,_0x7d7e42)=>{var _0x36905b=_0x299fe2;_0x3b5fab(_0x38ed34(_0x36905b(0x1c4),_0x7d7e42,_0x59aac0(),_0x4b74ac,[_0x4a9cf1]));},'autoLogMany':(_0x6761e9,_0x5b6d99)=>{var _0xbde178=_0x299fe2;_0x3b5fab(_0x38ed34(_0xbde178(0x1c4),_0x6761e9,_0x59aac0(),_0x4b74ac,_0x5b6d99));},'autoTrace':(_0x3fd090,_0x3bcc3f)=>{var _0x5427e5=_0x299fe2;_0x3b5fab(_0x38ed34(_0x5427e5(0x19d),_0x3bcc3f,_0x59aac0(),_0x4b74ac,[_0x3fd090]));},'autoTraceMany':(_0x160407,_0x476de5)=>{var _0x4a26ee=_0x299fe2;_0x3b5fab(_0x38ed34(_0x4a26ee(0x19d),_0x160407,_0x59aac0(),_0x4b74ac,_0x476de5));},'autoTime':(_0x2ebc4f,_0x8f55ad,_0xb83791)=>{_0x33ac10(_0xb83791);},'autoTimeEnd':(_0x318572,_0x407429,_0x14912f)=>{_0x214ca4(_0x407429,_0x14912f);},'coverage':_0x3ea1ad=>{var _0x27f71f=_0x299fe2;_0x3b5fab({'method':_0x27f71f(0x1a5),'version':_0x41294b,'args':[{'id':_0x3ea1ad}]});}};let _0x3b5fab=b(_0x397823,_0xa9058f,_0x662412,_0x43560e,_0x7a7719,_0x979242),_0x4b74ac=_0x397823[_0x299fe2(0x22b)];return _0x397823[_0x299fe2(0x1df)];})(globalThis,_0x1f6eda(0x241),_0x1f6eda(0x203),_0x1f6eda(0x1db),_0x1f6eda(0x220),_0x1f6eda(0x1a3),_0x1f6eda(0x1d7),_0x1f6eda(0x1d3),_0x1f6eda(0x17d),_0x1f6eda(0x174));");
}
catch (e) { } }
;
function oo_oo(i, ...v) { try {
    oo_cm().consoleLog(i, v);
}
catch (e) { } return v; }
;
oo_oo;
function oo_tr(i, ...v) { try {
    oo_cm().consoleTrace(i, v);
}
catch (e) { } return v; }
;
oo_tr;
function oo_ts() { try {
    oo_cm().consoleTime();
}
catch (e) { } }
;
oo_ts;
function oo_te() { try {
    oo_cm().consoleTimeEnd();
}
catch (e) { } }
;
oo_te; /*eslint unicorn/no-abusive-eslint-disable:,eslint-comments/disable-enable-pair:,eslint-comments/no-unlimited-disable:,eslint-comments/no-aggregating-enable:,eslint-comments/no-duplicate-disable:,eslint-comments/no-unused-disable:,eslint-comments/no-unused-enable:,*/


/***/ }),

/***/ "./src/components/context/app-provider/index.ts":
/*!******************************************************!*\
  !*** ./src/components/context/app-provider/index.ts ***!
  \******************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./app-provider.component */ "./src/components/context/app-provider/app-provider.component.tsx"), exports);


/***/ }),

/***/ "./src/components/context/breakpoint-provider/breakpoint-provider.component.tsx":
/*!**************************************************************************************!*\
  !*** ./src/components/context/breakpoint-provider/breakpoint-provider.component.tsx ***!
  \**************************************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.BreakpointProvider = exports.findLast = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const react_jss_1 = __webpack_require__(/*! react-jss */ "react-jss");
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const use_debounce_1 = __webpack_require__(/*! use-debounce */ "use-debounce");
const resize_observer_polyfill_1 = tslib_1.__importDefault(__webpack_require__(/*! resize-observer-polyfill */ "resize-observer-polyfill"));
const useStyles = react_jss_1.createUseStyles({
    breakpoint: {
        margin: 0,
        padding: 0,
        border: 0,
        width: "100%",
        boxSizing: "border-box",
    },
});
function findLast(array, predicate) {
    let l = array.length;
    while (l--) {
        const o = array[l];
        if (predicate(o, l, array))
            return o;
    }
    return null;
}
exports.findLast = findLast;
const BreakpointProvider = (_a) => {
    var _b;
    var { children, className, as } = _a, props = tslib_1.__rest(_a, ["children", "className", "as"]);
    const ref = react_1.useRef(null);
    const styles = useStyles();
    const parentContextRef = smarthub_common_1.useHookRef(smarthub_common_1.useBreakpoint);
    const level = ((_b = parentContextRef.current) === null || _b === void 0 ? void 0 : _b.current) ? parentContextRef.current.current.level + 1
        : 0;
    const gridStyles = smarthub_common_1.useCreateGridStyles(`bp${level}`);
    const contextRef = react_1.useRef(null);
    const [context, setContextState] = react_1.useState(null);
    const [classNames, setClassNames] = react_1.useState(null);
    const RootElement = as || "div";
    const setContext = react_1.useCallback((next) => {
        const { current: currentContext } = contextRef;
        const { current: current } = currentContext || {};
        const root = (parentContextRef === null || parentContextRef === void 0 ? void 0 : parentContextRef.current) ? parentContextRef === null || parentContextRef === void 0 ? void 0 : parentContextRef.current : current;
        contextRef.current = {
            current: Object.assign(Object.assign({}, current), next),
            root,
        };
        setContextState(contextRef.current);
    }, []);
    const setBreakpoint = (width) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
        var _c;
        const currentBp = findLast(smarthub_common_1.responsiveBreakPoints, (bp) => width >= bp.width);
        if (((_c = contextRef.current) === null || _c === void 0 ? void 0 : _c.current.size) != currentBp.size) {
            smarthub_common_1.responsiveBreakPoints.indexOf(currentBp);
            const classes = smarthub_common_1.responsiveBreakPoints
                .slice(0, currentBp.size + 1)
                .reduce((value, bp) => `${value} ${gridStyles[`bp${bp.name}`]}`, "");
            setClassNames(classes);
            setContext(Object.assign(Object.assign({}, currentBp), { level, styles: gridStyles }));
        }
    });
    const debounce = use_debounce_1.useDebouncedCallback(setBreakpoint, 300);
    react_1.useEffect(() => {
        const { current: currentContext } = contextRef;
        if (!currentContext)
            return;
        const { current: currentLevel } = currentContext;
        if (currentLevel.styles == gridStyles)
            return;
        const classes = smarthub_common_1.responsiveBreakPoints
            .slice(0, currentLevel.size + 1)
            .reduce((value, bp) => `${value} ${gridStyles[`bp${bp.name}`]}`, "");
        setClassNames(classes);
        setContext({
            styles: gridStyles,
        });
    }, [gridStyles.grid]);
    react_1.useEffect(() => {
        if (level > 0) {
            const ro = new resize_observer_polyfill_1.default((entries) => setBreakpoint(entries[0].contentRect.width));
            const { current } = ref;
            ro.observe(current);
            debounce(current.clientWidth);
            return () => {
                if (current)
                    ro.unobserve(current);
            };
        }
        const handleResize = () => setBreakpoint(window.innerWidth);
        window.addEventListener("resize", handleResize);
        debounce(window.innerWidth);
        return () => window.removeEventListener("resize", handleResize);
    }, []);
    return RootElement == react_1.Fragment ? (react_1.default.createElement(react_1.default.Fragment, null, context && (react_1.default.createElement(smarthub_common_1.BreakpointContext.Provider, { value: context }, children)))) : (react_1.default.createElement(RootElement, Object.assign({}, props, { ref: ref, className: [
            (className === null || className === void 0 ? void 0 : className.length) ? className : styles.breakpoint,
            classNames,
        ].join(" ") }), context && (react_1.default.createElement(smarthub_common_1.BreakpointContext.Provider, { value: context }, children))));
};
exports.BreakpointProvider = BreakpointProvider;


/***/ }),

/***/ "./src/components/context/breakpoint-provider/index.ts":
/*!*************************************************************!*\
  !*** ./src/components/context/breakpoint-provider/index.ts ***!
  \*************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./breakpoint-provider.component */ "./src/components/context/breakpoint-provider/breakpoint-provider.component.tsx"), exports);


/***/ }),

/***/ "./src/components/context/chatbot-provider/chatbot-provider.component.tsx":
/*!********************************************************************************!*\
  !*** ./src/components/context/chatbot-provider/chatbot-provider.component.tsx ***!
  \********************************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ChatBotProvider = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const botframework_webchat_1 = __webpack_require__(/*! botframework-webchat */ "botframework-webchat");
const react_2 = __webpack_require__(/*! react */ "react");
const botframework_directlinejs_1 = __webpack_require__(/*! botframework-directlinejs */ "botframework-directlinejs");
function getBrowserLocales(options = {}) {
    const defaultOptions = {
        languageCodeOnly: false,
    };
    const opt = Object.assign(Object.assign({}, defaultOptions), options);
    const browserLocales = navigator.languages === undefined
        ? [navigator.language]
        : navigator.languages;
    if (!browserLocales) {
        return undefined;
    }
    return browserLocales.map((locale) => {
        const trimmedLocale = locale.trim();
        return opt.languageCodeOnly ? trimmedLocale.split(/-|_/)[0] : trimmedLocale;
    });
}
const nextScope = (scopes, current, size) => {
    const first = scopes === null || scopes === void 0 ? void 0 : scopes[0];
    if (!current ||
        !(scopes === null || scopes === void 0 ? void 0 : scopes.length) ||
        (first.target === "panel" && size === "full"))
        return first;
    const scope = scopes.find(({ name, title, subTitle }) => current.name == name ||
        (current.title == title && current.subTitle == subTitle));
    return scope || first;
};
//TODO break out scope management
const ChatBotProvider = ({ children, webChatConfig, adaptiveCardHostConfig, }) => {
    const { cogsvc } = smarthub_common_1.useProviders();
    const authContext = smarthub_common_1.useAuth();
    const authContextRef = react_1.useRef(null);
    authContextRef.current = authContext;
    const profile = smarthub_common_1.useProfile();
    const profileRef = react_1.useRef(null);
    profileRef.current = profile;
    const theme = smarthub_common_1.useTheme();
    const setLocale = smarthub_common_1.useSetLocale();
    const { enabled: tpcEnabled } = smarthub_common_1.useTPCCheck();
    //TODO update state management of keywords - move to higher context
    const [, setKeywords] = smarthub_common_1.useKeywords();
    const sourceInfo = smarthub_common_1.useSourceInfo();
    const panelViewRef = smarthub_common_1.useHookRef(smarthub_common_1.usePanelView, "chat");
    const setPanelView = smarthub_common_1.useSetPanelView("chat");
    const setPanelState = react_1.useCallback((scope, selected = false) => {
        const { current: state } = panelViewRef;
        const isSearch = (scope === null || scope === void 0 ? void 0 : scope.target) === "panel";
        const visible = !isSearch ? selected : false;
        if (state.visible != visible) {
            setPanelView(Object.assign(Object.assign({}, state), { visible }));
        }
    }, []);
    const detectedLanguage = react_1.useMemo(() => {
        let language = getBrowserLocales({ languageCodeOnly: true })[0];
        // get the site language.  If it is not supported, use the default language
        let docLang = document.documentElement.lang.split(/-|_/)[0];
        let lang = docLang === language ? language : docLang;
        // let availLangs = languages.map((x: IPanelLanguage) => {
        //   return x.language;
        // });
        // if (!availLangs.includes(lang)) {
        //   // if not, use the default language
        //   lang = availLangs[0];
        // }
        return lang;
    }, []);
    react_2.useEffect(() => {
        setLocale(smarthub_common_1.LocalizeLanguages[detectedLanguage]);
    }, [detectedLanguage]);
    //TODO update state management of scopes - move to child context
    const setScopes = react_1.useCallback((scopes, params) => {
        var _a;
        contextRef.current.scopes = scopes;
        const { current: { scope: currentScope }, } = contextRef;
        const scope = nextScope(scopes, currentScope, (_a = panelViewRef.current) === null || _a === void 0 ? void 0 : _a.size);
        if (currentScope != scope)
            setPanelState(scope);
        applyScope(scope, params);
        setContext({
            scopes,
            scope,
        });
    }, []);
    const applyScope = react_1.useCallback((chatContext, params) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
        const { current: profile } = profileRef;
        try {
            if (chatContext === null || chatContext === void 0 ? void 0 : chatContext.scope) {
                const { current: { directlineContext: { config, directline }, }, } = contextRef;
                const scope = smarthub_common_1.deepReplaceParams(chatContext.scope, Object.assign(Object.assign({}, params), { profile }));
                yield smarthub_common_1.sendBackChannel(directline, config, profile, sourceInfo, {
                    payload: {
                        scope,
                    },
                    type: "context.scope",
                    version: "1.0",
                });
            }
            setKeywords(null);
        }
        catch (ex) {
            smarthub_common_1.Logger.error("Failed to apply chat scope", false, ex);
        }
    }), []);
    const setScope = react_1.useCallback((scope, params) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
        applyScope(scope, params);
        setPanelState(scope, true);
        setContext({
            scope,
        });
    }), []);
    const openDirectLine = react_1.useCallback((refresh) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
        const { current: profile } = profileRef;
        const { current: auth } = authContextRef;
        try {
            let config;
            for (var i = 0; i < cogsvc.length; i++) {
                config = yield cogsvc[i].process(auth, config, refresh);
            }
            const { bot: { user: { id: userId, tokenOnly, ref: userToken }, token, personality, }, } = config;
            const directline = botframework_webchat_1.createDirectLine({
                token: token,
                watermark: "SmartChat",
                conversationStartProperties: {
                    locale: `[{"key":"personality","value":"${personality}"},{"key":"locale","value":"${detectedLanguage}"}]`,
                },
            });
            if (!tokenOnly && directline.setUserId) {
                /*
                  HACK! when bot token does not contain a user attribute (v2)
                  the connection fails. Calling setUserId resolves the issue.
                  The WebChat still tries to set the userId which fails bc
                  directline has already connected.
                  Override the setUserId to fix this
                */
                directline.setUserId(userId);
                const setUserId = directline.setUserId;
                directline.setUserId = () => {
                    if (directline.connectionStatus$.getValue() !== botframework_directlinejs_1.ConnectionStatus.Online)
                        setUserId(userId);
                };
            }
            yield smarthub_common_1.sendBackChannel(directline, config, profile, sourceInfo, {
                payload: {
                    user: userToken,
                    personality,
                    tpc: tpcEnabled,
                },
                type: "context.user",
                version: "1.0",
            });
            setContext({
                directlineContext: {
                    directline,
                    config,
                },
            });
        }
        catch (ex) {
            smarthub_common_1.Logger.error("Failed to load directline", false, ex);
        }
    }), []);
    const reset = react_1.useCallback(() => tslib_1.__awaiter(void 0, void 0, void 0, function* () { return openDirectLine(true); }), []);
    const contextRef = react_1.useRef({
        setScopes,
        setScope,
        reset,
    });
    const [context, setContextState] = react_2.useState(contextRef.current);
    const setContext = react_1.useCallback((next) => {
        contextRef.current = Object.assign(Object.assign({}, contextRef.current), next);
        setContextState(contextRef.current);
    }, []);
    react_2.useEffect(() => {
        const hostConfig = smarthub_common_1.mergeHostConfigStyles(adaptiveCardHostConfig, theme.definition);
        const styleOptions = smarthub_common_1.mergeWebchatStyles(webChatConfig.styleOptions, theme.definition);
        const styleSet = smarthub_common_1.mergeWebchatStyleset(webChatConfig.styleSet, styleOptions, theme.definition);
        setContext({
            hostConfig,
            webChat: Object.assign(Object.assign({}, webChatConfig), { styleOptions,
                styleSet }),
        });
    }, [theme]);
    react_2.useEffect(() => {
        if (authContext &&
            profile &&
            !(context === null || context === void 0 ? void 0 : context.directlineContext) &&
            detectedLanguage)
            openDirectLine();
    }, [authContext, profile, detectedLanguage]);
    return (react_1.default.createElement(smarthub_common_1.ChatBotContext.Provider, { value: context }, children));
};
exports.ChatBotProvider = ChatBotProvider;


/***/ }),

/***/ "./src/components/context/chatbot-provider/index.ts":
/*!**********************************************************!*\
  !*** ./src/components/context/chatbot-provider/index.ts ***!
  \**********************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./chatbot-provider.component */ "./src/components/context/chatbot-provider/chatbot-provider.component.tsx"), exports);


/***/ }),

/***/ "./src/components/context/core-context/core-context.component.tsx":
/*!************************************************************************!*\
  !*** ./src/components/context/core-context/core-context.component.tsx ***!
  \************************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.CoreContext = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const __1 = __webpack_require__(/*! ../ */ "./src/components/context/index.ts");
const middleware_provider_1 = __webpack_require__(/*! ../middleware-provider */ "./src/components/context/middleware-provider/index.ts");
const personality_provider_1 = __webpack_require__(/*! ../personality-provider */ "./src/components/context/personality-provider/index.ts");
const CoreContext = (_a) => {
    var { children, middleware, localizeConfig, tpcCheck, themes, onAPIReady } = _a, props = tslib_1.__rest(_a, ["children", "middleware", "localizeConfig", "tpcCheck", "themes", "onAPIReady"]);
    return (react_1.default.createElement(__1.TPCCheckProvider, { config: tpcCheck },
        react_1.default.createElement(__1.BreakpointProvider, { as: react_1.Fragment },
            react_1.default.createElement(personality_provider_1.PersonalityProvider, null,
                react_1.default.createElement(__1.AppProvider, Object.assign({}, props),
                    react_1.default.createElement(__1.PageProvider, null,
                        react_1.default.createElement(__1.LocalizeProvider, { config: localizeConfig },
                            react_1.default.createElement(middleware_provider_1.MiddlewareProvider, { config: middleware },
                                react_1.default.createElement(__1.PreferenceProvider, null,
                                    react_1.default.createElement(__1.ThemeProvider, { themes: themes },
                                        react_1.default.createElement(__1.APIProvider, { onAPIReady: onAPIReady }, children)))))))))));
};
exports.CoreContext = CoreContext;


/***/ }),

/***/ "./src/components/context/core-context/index.ts":
/*!******************************************************!*\
  !*** ./src/components/context/core-context/index.ts ***!
  \******************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./core-context.component */ "./src/components/context/core-context/core-context.component.tsx"), exports);


/***/ }),

/***/ "./src/components/context/extended-api/extended-api.component.tsx":
/*!************************************************************************!*\
  !*** ./src/components/context/extended-api/extended-api.component.tsx ***!
  \************************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ExtendedAPI = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const ExtendedAPI = ({ children }) => {
    const setExtendedAPI = smarthub_common_1.useSetExtendedAPI();
    const command = smarthub_common_1.useHandleCommand();
    const setBotReady = smarthub_common_1.useSetBotReady();
    react_1.useEffect(() => {
        setExtendedAPI({
            command
        });
        setBotReady(true);
    }, []);
    return react_1.default.createElement(react_1.default.Fragment, null, children);
};
exports.ExtendedAPI = ExtendedAPI;


/***/ }),

/***/ "./src/components/context/extended-api/index.ts":
/*!******************************************************!*\
  !*** ./src/components/context/extended-api/index.ts ***!
  \******************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./extended-api.component */ "./src/components/context/extended-api/extended-api.component.tsx"), exports);


/***/ }),

/***/ "./src/components/context/extended-context/extended-context.component.tsx":
/*!********************************************************************************!*\
  !*** ./src/components/context/extended-context/extended-context.component.tsx ***!
  \********************************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ExtendedContext = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const React = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const __1 = __webpack_require__(/*! ../ */ "./src/components/context/index.ts");
const chat_root_1 = __webpack_require__(/*! ../../chat-root */ "./src/components/chat-root/index.ts");
const ExtendedContext = ({ children, adaptiveCardHostConfig, webChatConfig }) => {
    return (React.createElement(__1.ProfileProvider, null,
        React.createElement(__1.NotificationProvider, null,
            React.createElement(__1.PanelsProvider, null,
                React.createElement(__1.LocationProvider, null,
                    React.createElement(__1.ChatBotProvider, Object.assign({}, {
                        webChatConfig,
                        adaptiveCardHostConfig
                    }),
                        React.createElement(chat_root_1.ChatRoot, null,
                            React.createElement(__1.ExtendedAPI, null, children))))))));
};
exports.ExtendedContext = ExtendedContext;


/***/ }),

/***/ "./src/components/context/extended-context/index.ts":
/*!**********************************************************!*\
  !*** ./src/components/context/extended-context/index.ts ***!
  \**********************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./extended-context.component */ "./src/components/context/extended-context/extended-context.component.tsx"), exports);


/***/ }),

/***/ "./src/components/context/index.ts":
/*!*****************************************!*\
  !*** ./src/components/context/index.ts ***!
  \*****************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./api-provider */ "./src/components/context/api-provider/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./extended-api */ "./src/components/context/extended-api/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./extended-context */ "./src/components/context/extended-context/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./core-context */ "./src/components/context/core-context/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./app-provider */ "./src/components/context/app-provider/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./theme-provider */ "./src/components/context/theme-provider/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./chatbot-provider */ "./src/components/context/chatbot-provider/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./profile-provider */ "./src/components/context/profile-provider/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./panels-provider */ "./src/components/context/panels-provider/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./localize-provider */ "./src/components/context/localize-provider/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./middleware-provider */ "./src/components/context/middleware-provider/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./breakpoint-provider */ "./src/components/context/breakpoint-provider/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./location-provider */ "./src/components/context/location-provider/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./notification-provider */ "./src/components/context/notification-provider/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./preference-provider */ "./src/components/context/preference-provider/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./panel-view-provider */ "./src/components/context/panel-view-provider/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./page-provider */ "./src/components/context/page-provider/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./tpc-check-provider */ "./src/components/context/tpc-check-provider/index.ts"), exports);


/***/ }),

/***/ "./src/components/context/localize-provider/index.ts":
/*!***********************************************************!*\
  !*** ./src/components/context/localize-provider/index.ts ***!
  \***********************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./localize-provider.component */ "./src/components/context/localize-provider/localize-provider.component.tsx"), exports);


/***/ }),

/***/ "./src/components/context/localize-provider/localize-provider.component.tsx":
/*!**********************************************************************************!*\
  !*** ./src/components/context/localize-provider/localize-provider.component.tsx ***!
  \**********************************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.LocalizeProvider = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const dayjs_1 = tslib_1.__importDefault(__webpack_require__(/*! dayjs */ "dayjs"));
const LocalizeProvider = ({ children, config }) => {
    const setLocale = react_1.useCallback((lang) => {
        const localeConfig = config[lang];
        dayjs_1.default.locale(lang);
        if (localeConfig)
            setContext({
                config: localeConfig,
                locale: lang,
                setLocale
            });
    }, [config]);
    const [context, setContext] = react_1.useState(null);
    react_1.useEffect(() => {
        dayjs_1.default.locale(config.defaultLanguage);
        setContext({
            config: config[config.defaultLanguage],
            locale: config.defaultLanguage,
            setLocale
        });
    }, []);
    return react_1.default.createElement(smarthub_common_1.LocalizeContext.Provider, { value: context }, children);
};
exports.LocalizeProvider = LocalizeProvider;


/***/ }),

/***/ "./src/components/context/location-provider/index.ts":
/*!***********************************************************!*\
  !*** ./src/components/context/location-provider/index.ts ***!
  \***********************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.LocationProvider = void 0;
var location_provider_component_1 = __webpack_require__(/*! ./location-provider.component */ "./src/components/context/location-provider/location-provider.component.tsx");
Object.defineProperty(exports, "LocationProvider", ({ enumerable: true, get: function () { return location_provider_component_1.LocationProvider; } }));


/***/ }),

/***/ "./src/components/context/location-provider/is-partial-location.helper.ts":
/*!********************************************************************************!*\
  !*** ./src/components/context/location-provider/is-partial-location.helper.ts ***!
  \********************************************************************************/
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.isPartialLocation = exports.isPartialItem = void 0;
const isPartialItem = (current, next) => {
    var _a, _b, _c, _d, _e, _f, _g;
    if (!current)
        return true;
    const { panel: currentPanel, tab: currentTab } = current || {};
    const { panel, tab } = next || {};
    return (panel === null || panel === void 0 ? void 0 : panel.id) == ((_a = current === null || current === void 0 ? void 0 : current.panel) === null || _a === void 0 ? void 0 : _a.id)
        && ((!((_b = currentPanel === null || currentPanel === void 0 ? void 0 : currentPanel.entity) === null || _b === void 0 ? void 0 : _b.length) && ((_c = panel === null || panel === void 0 ? void 0 : panel.entity) === null || _c === void 0 ? void 0 : _c.length) > 0)
            || (!((_d = currentTab === null || currentTab === void 0 ? void 0 : currentTab.id) === null || _d === void 0 ? void 0 : _d.length) && ((_e = tab === null || tab === void 0 ? void 0 : tab.id) === null || _e === void 0 ? void 0 : _e.length) > 0)
            || (!((_f = currentTab === null || currentTab === void 0 ? void 0 : currentTab.entity) === null || _f === void 0 ? void 0 : _f.length) && ((_g = tab === null || tab === void 0 ? void 0 : tab.entity) === null || _g === void 0 ? void 0 : _g.length) > 0));
};
exports.isPartialItem = isPartialItem;
const isPartialLocation = (current, next) => !current
    || ((next === null || next === void 0 ? void 0 : next.main) && exports.isPartialItem(current === null || current === void 0 ? void 0 : current.main, next === null || next === void 0 ? void 0 : next.main))
    || ((next === null || next === void 0 ? void 0 : next.page) && exports.isPartialItem(current === null || current === void 0 ? void 0 : current.page, next === null || next === void 0 ? void 0 : next.page));
exports.isPartialLocation = isPartialLocation;


/***/ }),

/***/ "./src/components/context/location-provider/location-provider.component.tsx":
/*!**********************************************************************************!*\
  !*** ./src/components/context/location-provider/location-provider.component.tsx ***!
  \**********************************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.LocationProvider = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const is_partial_location_helper_1 = __webpack_require__(/*! ./is-partial-location.helper */ "./src/components/context/location-provider/is-partial-location.helper.ts");
const parse_location_helper_1 = __webpack_require__(/*! ./parse-location.helper */ "./src/components/context/location-provider/parse-location.helper.ts");
const stringify_location_helper_1 = __webpack_require__(/*! ./stringify-location.helper */ "./src/components/context/location-provider/stringify-location.helper.ts");
const use_app_location_hook_1 = __webpack_require__(/*! ./use-app-location.hook */ "./src/components/context/location-provider/use-app-location.hook.ts");
const use_debounce_1 = __webpack_require__(/*! use-debounce */ "use-debounce");
const use_handle_redirect_hook_1 = __webpack_require__(/*! ./use-handle-redirect.hook */ "./src/components/context/location-provider/use-handle-redirect.hook.ts");
const LocationProvider = ({ children }) => {
    const contextRef = react_1.useRef({
        location: null,
        path: ''
    });
    const handleRedirect = use_handle_redirect_hook_1.useHandleRedirect();
    const [next, setNext] = use_app_location_hook_1.useAppLocation();
    const [context, setContext] = react_1.useState(contextRef.current);
    const debounceNext = use_debounce_1.useDebouncedCallback((value) => {
        const { current: { location: current, path: currentPath } } = contextRef;
        const path = stringify_location_helper_1.stringifyLocation(value);
        if (currentPath == path)
            return;
        contextRef.current = {
            path,
            location: next
        };
        setContext(contextRef.current);
        const replace = is_partial_location_helper_1.isPartialLocation(current, value);
        if (replace)
            history.replaceState({}, "", path);
        else
            history.pushState({}, "", path);
    }, 50);
    react_1.useEffect(() => debounceNext(next), [next]);
    const onUrlChange = react_1.useCallback((url) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
        let { path, location } = parse_location_helper_1.parseLocation(url);
        const redirected = yield handleRedirect(location);
        if (redirected) {
            const { current: { path: currentPath } = {} } = contextRef;
            history.replaceState({}, "", currentPath);
            return;
        }
        contextRef.current = {
            path,
            location
        };
        setContext(contextRef.current);
        setNext(location);
    }), []);
    react_1.useEffect(() => {
        const handleHashChange = ({ newURL }) => onUrlChange(newURL);
        window.addEventListener('hashchange', handleHashChange);
        onUrlChange(document.location.href);
        return () => {
            window.removeEventListener('hashchange', handleHashChange);
        };
    }, []);
    return (react_1.default.createElement(smarthub_common_1.LocationContext.Provider, { value: context }, context && children));
};
exports.LocationProvider = LocationProvider;


/***/ }),

/***/ "./src/components/context/location-provider/parse-location.helper.ts":
/*!***************************************************************************!*\
  !*** ./src/components/context/location-provider/parse-location.helper.ts ***!
  \***************************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.parseLocation = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const query_string_1 = tslib_1.__importDefault(__webpack_require__(/*! query-string */ "query-string"));
const parseId = (path, endPos, current) => {
    const colonPos = path.indexOf(":");
    if (~colonPos && colonPos < endPos) {
        current.id = path.substring(0, colonPos).trim();
        current.entity = decodeURIComponent(path.substring(colonPos + 1, endPos).trim());
    }
    else
        current.id = path.substring(0, endPos).trim();
};
const parseParams = (search) => {
    if (search.length <= 1)
        return {};
    const query = query_string_1.default.parse(search, { decode: true });
    return Object.keys(query).reduce((params, key) => {
        const keys = key.split('.');
        const value = query[key];
        let obj = params;
        keys.forEach((subKey, idx, keys) => {
            if (idx == keys.length - 1)
                obj[subKey] = value;
            else
                obj = obj[subKey] = (obj[subKey] || {});
        });
        return params;
    }, {});
};
const parsePath = (path, current) => {
    const nextSlash = path.indexOf('/');
    const nextHash = path.indexOf('#');
    let end = 0;
    if (~nextSlash && (!~nextHash || nextSlash < nextHash))
        parseId(path, end = nextSlash, current);
    else if (~nextHash && (!~nextSlash || nextHash < nextSlash)) {
        parseId(path, nextHash, current);
        current.params = parseParams(path.substring(nextHash + 1, end = ~nextSlash
            ? nextSlash
            : path.length));
    }
    else
        parseId(path, end = path.length, current);
    return path.substring(end + 1);
};
const parsePaths = (path, items) => {
    path = parsePath(path.indexOf('/') == 0
        ? path.substring(1)
        : path, items.panel);
    if (path.length)
        path = parsePath(path, items.tab);
    return path;
};
const parseLocation = (uri) => {
    const pos = uri.indexOf('#');
    const searchPos = uri.lastIndexOf('?');
    const hash = pos > 0
        ? uri.substring(pos + 1, searchPos > pos ? searchPos : undefined)
        : '';
    const search = searchPos > 0
        ? uri.substring(searchPos + 1, pos > searchPos ? pos : undefined)
        : '';
    const location = {
        main: {
            panel: { id: null },
            tab: { id: null }
        },
        page: null,
        params: parseParams(search)
    };
    if (hash.length) {
        const path = parsePaths(hash, location.main);
        if (path.length) {
            location.page = {
                panel: { id: null },
                tab: { id: null }
            };
            parsePaths(path, location.page);
        }
    }
    return {
        location,
        path: `${(hash === null || hash === void 0 ? void 0 : hash.length) ? '#' : ''}${hash}${(search === null || search === void 0 ? void 0 : search.length) ? '?' : ''}${search}`
    };
};
exports.parseLocation = parseLocation;


/***/ }),

/***/ "./src/components/context/location-provider/stringify-location.helper.ts":
/*!*******************************************************************************!*\
  !*** ./src/components/context/location-provider/stringify-location.helper.ts ***!
  \*******************************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.stringifyLocation = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const query_string_1 = tslib_1.__importDefault(__webpack_require__(/*! query-string */ "query-string"));
const flatten = (obj, flat, keyPath) => {
    const keys = Object.keys(obj);
    flat = flat !== null && flat !== void 0 ? flat : {};
    keyPath = keyPath !== null && keyPath !== void 0 ? keyPath : '';
    keys
        .sort()
        .forEach(key => {
        const value = obj[key];
        const flatKey = `${keyPath}${keyPath.length ? '.' : ''}${key}`;
        if (value && typeof value == 'object')
            flatten(value, flat, flatKey);
        else if (value && (typeof value != 'string' || value.length > 0))
            flat[flatKey] = value;
    });
    return flat;
};
const parseParams = (params, inline) => {
    if (!params || !Object.keys(params).length)
        return '';
    const flat = flatten(params);
    const serialised = query_string_1.default.stringify(flat, { encode: true });
    return serialised.length
        ? `${inline ? '#' : '?'}${serialised}`
        : '';
};
const parsePath = (item, separateEmpty) => {
    var _a;
    if (!((_a = item === null || item === void 0 ? void 0 : item.id) === null || _a === void 0 ? void 0 : _a.length))
        return separateEmpty ? '/' : '';
    const { id, entity, params } = item;
    const prms = parseParams(params, true);
    const entId = (entity === null || entity === void 0 ? void 0 : entity.length) ? `:${encodeURIComponent(entity)}` : '';
    return `/${id}${entId}${prms}`;
};
const parsePaths = (items, separateEmpty) => {
    const panel = parsePath(items === null || items === void 0 ? void 0 : items.panel, separateEmpty);
    const tab = parsePath(items === null || items === void 0 ? void 0 : items.tab, separateEmpty);
    return `${panel}${tab}`;
};
const stringifyLocation = (appLocation) => {
    var _a, _b, _c;
    const main = parsePaths(appLocation.main, ((_c = (_b = (_a = appLocation.page) === null || _a === void 0 ? void 0 : _a.panel) === null || _b === void 0 ? void 0 : _b.id) === null || _c === void 0 ? void 0 : _c.length) > 0);
    const page = parsePaths(appLocation.page);
    const params = parseParams(appLocation.params);
    return `#${main}${page}${params}`;
};
exports.stringifyLocation = stringifyLocation;


/***/ }),

/***/ "./src/components/context/location-provider/use-app-location.hook.ts":
/*!***************************************************************************!*\
  !*** ./src/components/context/location-provider/use-app-location.hook.ts ***!
  \***************************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useAppLocation = void 0;
const react_1 = __webpack_require__(/*! react */ "react");
const use_location_items_hook_1 = __webpack_require__(/*! ./use-location-items.hook */ "./src/components/context/location-provider/use-location-items.hook.ts");
const useAppLocation = () => {
    const [main, setMain] = use_location_items_hook_1.useLocationItems('main');
    const [page, setPage] = use_location_items_hook_1.useLocationItems('page');
    const value = react_1.useMemo(() => ({ main, page }), [main, page]);
    const setter = react_1.useCallback((location) => {
        setMain(location === null || location === void 0 ? void 0 : location.main);
        setPage(location === null || location === void 0 ? void 0 : location.page);
    }, []);
    return [value, setter];
};
exports.useAppLocation = useAppLocation;


/***/ }),

/***/ "./src/components/context/location-provider/use-handle-redirect.hook.ts":
/*!******************************************************************************!*\
  !*** ./src/components/context/location-provider/use-handle-redirect.hook.ts ***!
  \******************************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useHandleRedirect = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = __webpack_require__(/*! react */ "react");
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const rgx = /^(?:http|https):\/\/(?:[a-z0-9-_.\/]*)/;
const parseAction = (param) => {
    if (typeof param == 'string')
        return {
            $id: '',
            $schema: smarthub_common_1.RouteActionSchema,
            uri: param
        };
    let { $schema } = param, rest = tslib_1.__rest(param, ["$schema"]);
    if (!$schema)
        $schema = smarthub_common_1.RouteActionSchema;
    else if (!rgx.test($schema))
        $schema = `${smarthub_common_1.ActionSchema}/${$schema}`;
    return Object.assign(Object.assign({}, rest), { $schema });
};
const useHandleRedirect = () => {
    const handleCommand = smarthub_common_1.useHandleCommand();
    return react_1.useCallback((next) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
        const { page, $action } = (next === null || next === void 0 ? void 0 : next.params) || {};
        const action = $action
            ? parseAction($action)
            : page
                ? parseAction(page)
                : null;
        if (action) {
            yield handleCommand(action);
            return true;
        }
        return false;
    }), []);
};
exports.useHandleRedirect = useHandleRedirect;


/***/ }),

/***/ "./src/components/context/location-provider/use-location-item-params.hook.ts":
/*!***********************************************************************************!*\
  !*** ./src/components/context/location-provider/use-location-item-params.hook.ts ***!
  \***********************************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useLocationItemParams = void 0;
const react_1 = __webpack_require__(/*! react */ "react");
const recoil_1 = __webpack_require__(/*! recoil */ "recoil");
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const group = 'shared';
const channel = 'uri';
const useLocationItemParams = (source, level) => {
    var _a, _b, _c;
    const state = smarthub_common_1.useSharedStatePartition(group, channel, source, level);
    const params = react_1.useRef();
    params.current = (_c = (_b = (_a = state === null || state === void 0 ? void 0 : state.shared) === null || _a === void 0 ? void 0 : _a.uri) === null || _b === void 0 ? void 0 : _b[source]) === null || _c === void 0 ? void 0 : _c[level];
    const settter = recoil_1.useRecoilCallback(({ set }) => (nextParams) => {
        const currentRefs = Object.keys(params.current || {})
            .map(name => ({
            name,
            channel,
            group,
            level,
            source
        }));
        const nextRefs = Object.keys(nextParams || {})
            .map(name => ({
            name,
            channel,
            group,
            level,
            source,
            value: nextParams[name]
        }));
        const refs = [
            ...currentRefs,
            ...nextRefs
        ];
        refs.forEach(ref => set(smarthub_common_1.sharedStateSelector(smarthub_common_1.sharedStateId(ref)), ref.value));
    }, []);
    return [params.current, settter];
};
exports.useLocationItemParams = useLocationItemParams;


/***/ }),

/***/ "./src/components/context/location-provider/use-location-items.hook.ts":
/*!*****************************************************************************!*\
  !*** ./src/components/context/location-provider/use-location-items.hook.ts ***!
  \*****************************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useLocationItems = void 0;
const react_1 = __webpack_require__(/*! react */ "react");
const use_panel_item_hook_1 = __webpack_require__(/*! ./use-panel-item.hook */ "./src/components/context/location-provider/use-panel-item.hook.ts");
const use_tab_item_hook_1 = __webpack_require__(/*! ./use-tab-item.hook */ "./src/components/context/location-provider/use-tab-item.hook.ts");
const useLocationItems = (type) => {
    const [panel, setPanel] = use_panel_item_hook_1.usePanelItem(type);
    const [tab, setTab] = use_tab_item_hook_1.useTabItem(type);
    const value = react_1.useMemo(() => ({ panel, tab }), [panel, tab]);
    const setter = react_1.useCallback((items) => {
        setPanel(items === null || items === void 0 ? void 0 : items.panel);
        setTab(items === null || items === void 0 ? void 0 : items.tab);
    }, []);
    return [value, setter];
};
exports.useLocationItems = useLocationItems;


/***/ }),

/***/ "./src/components/context/location-provider/use-panel-item.hook.ts":
/*!*************************************************************************!*\
  !*** ./src/components/context/location-provider/use-panel-item.hook.ts ***!
  \*************************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.usePanelItem = void 0;
const react_1 = __webpack_require__(/*! react */ "react");
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const use_location_item_params_hook_1 = __webpack_require__(/*! ./use-location-item-params.hook */ "./src/components/context/location-provider/use-location-item-params.hook.ts");
const level = 'panel';
const usePanelItem = (type) => {
    const [params, setParams] = use_location_item_params_hook_1.useLocationItemParams(type, level);
    const id = smarthub_common_1.usePanelId(type);
    const setId = smarthub_common_1.useSetPanelId(type);
    const entity = smarthub_common_1.usePanelEntityId(type);
    const value = react_1.useMemo(() => ({ id, entity, params }), [id, entity, params]);
    const setter = react_1.useCallback((item) => {
        setId(item === null || item === void 0 ? void 0 : item.id, item === null || item === void 0 ? void 0 : item.entity);
        setParams(item === null || item === void 0 ? void 0 : item.params);
    }, []);
    return [value, setter];
};
exports.usePanelItem = usePanelItem;


/***/ }),

/***/ "./src/components/context/location-provider/use-tab-item.hook.ts":
/*!***********************************************************************!*\
  !*** ./src/components/context/location-provider/use-tab-item.hook.ts ***!
  \***********************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useTabItem = void 0;
const react_1 = __webpack_require__(/*! react */ "react");
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const use_location_item_params_hook_1 = __webpack_require__(/*! ./use-location-item-params.hook */ "./src/components/context/location-provider/use-location-item-params.hook.ts");
const level = 'tab';
const useTabItem = (type) => {
    const [params, setParams] = use_location_item_params_hook_1.useLocationItemParams(type, level);
    const id = smarthub_common_1.useTabId(type);
    const setId = smarthub_common_1.useSetTabId(type);
    const entity = smarthub_common_1.useTabEntityId(type);
    const value = react_1.useMemo(() => ({ id, entity, params }), [id, entity, params]);
    const setter = react_1.useCallback((item) => {
        setId(item === null || item === void 0 ? void 0 : item.id, item === null || item === void 0 ? void 0 : item.entity);
        setParams(item === null || item === void 0 ? void 0 : item.params);
    }, []);
    return [value, setter];
};
exports.useTabItem = useTabItem;


/***/ }),

/***/ "./src/components/context/middleware-provider/index.ts":
/*!*************************************************************!*\
  !*** ./src/components/context/middleware-provider/index.ts ***!
  \*************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./middleware-provider.component */ "./src/components/context/middleware-provider/middleware-provider.component.tsx"), exports);


/***/ }),

/***/ "./src/components/context/middleware-provider/middleware-provider.component.tsx":
/*!**************************************************************************************!*\
  !*** ./src/components/context/middleware-provider/middleware-provider.component.tsx ***!
  \**************************************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.MiddlewareProvider = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const MiddlewareProvider = ({ children, config }) => {
    var _a;
    const { transforms: transformProvider } = (_a = smarthub_common_1.useProviders()) !== null && _a !== void 0 ? _a : {};
    const authContext = smarthub_common_1.useAuth();
    const [context, setContext] = react_1.useState(null);
    const loadMiddleware = () => {
        const ctx = Object.keys(config).reduce((context, k) => {
            context[k] = k != 'transform' ? config[k].middleware : null;
            return context;
        }, {});
        setContext(ctx);
    };
    const loadTransforms = () => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
        try {
            const templates = yield (transformProvider === null || transformProvider === void 0 ? void 0 : transformProvider.process(authContext));
            config.transform.collection.upsertTemplate(templates !== null && templates !== void 0 ? templates : []);
            setContext(Object.assign(Object.assign({}, context), { transform: config.transform.middleware }));
        }
        catch (ex) {
            smarthub_common_1.Logger.error(ex.message, false, { ex });
        }
    });
    react_1.useEffect(() => {
        if (!context)
            loadMiddleware();
        if (authContext && context && !(context === null || context === void 0 ? void 0 : context.transform) && transformProvider)
            loadTransforms();
    }, [authContext, context]);
    return react_1.default.createElement(smarthub_common_1.MiddlewareContext.Provider, { value: context }, context && children);
};
exports.MiddlewareProvider = MiddlewareProvider;


/***/ }),

/***/ "./src/components/context/notification-provider/index.ts":
/*!***************************************************************!*\
  !*** ./src/components/context/notification-provider/index.ts ***!
  \***************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./notification-provider.component */ "./src/components/context/notification-provider/notification-provider.component.tsx"), exports);


/***/ }),

/***/ "./src/components/context/notification-provider/notification-provider.component.tsx":
/*!******************************************************************************************!*\
  !*** ./src/components/context/notification-provider/notification-provider.component.tsx ***!
  \******************************************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.NotificationProvider = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const react_2 = __webpack_require__(/*! react */ "react");
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const dayjs_1 = tslib_1.__importDefault(__webpack_require__(/*! dayjs */ "dayjs"));
const isSameOrBefore_1 = tslib_1.__importDefault(__webpack_require__(/*! dayjs/plugin/isSameOrBefore */ "dayjs/plugin/isSameOrBefore"));
dayjs_1.default.extend(isSameOrBefore_1.default);
const key = 'dismissed-notifications';
const NotificationProvider = ({ children }) => {
    const { notifications: notificationProviders } = smarthub_common_1.useProviders();
    const fetch = smarthub_common_1.useFetch();
    const auth = smarthub_common_1.useAuth();
    const transform = smarthub_common_1.useTransform();
    const [context, setContext] = react_1.useState(null);
    const dismissedPrefRef = smarthub_common_1.useHookRef(smarthub_common_1.usePreference, key, true, []);
    const notificationsRef = react_2.useRef([]);
    const dismiss = react_1.useCallback(({ $id, source, expires }) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
        const now = new Date();
        const [dismissedItems, setDismissedItems] = dismissedPrefRef.current;
        const items = dismissedItems.filter(d => dayjs_1.default(d.expires).isSameOrBefore(now)
            || (d.$id != $id && d.source != source));
        setDismissedItems([
            ...items,
            {
                $id,
                source,
                expires
            }
        ]);
        setNotifications(notificationsRef.current.filter(n => n.$id != $id && n.source != source));
    }), []);
    const dismissAll = react_1.useCallback(() => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
        const now = new Date();
        const notifications = notificationsRef.current;
        const [dismissedItems, setDismissedItems] = dismissedPrefRef.current;
        const items = [
            ...dismissedItems.current.filter(d => dayjs_1.default(d.expires).isSameOrBefore(now)
                || !notifications.some(({ $id, source }) => d.$id != $id && d.source != source)),
            ...notifications.map(({ $id, source, expires }) => ({
                $id,
                source,
                expires
            }))
        ];
        setDismissedItems.current(items);
        setNotifications([]);
    }), []);
    const setNotifications = react_1.useCallback((notifications) => {
        notificationsRef.current = notifications;
        setContext({
            notifications,
            dismissAll,
            dismiss
        });
    }, []);
    react_1.useEffect(() => {
        let stop = false;
        setNotifications([]);
        const loadNotifications = () => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
            try {
                notificationProviders === null || notificationProviders === void 0 ? void 0 : notificationProviders.forEach((provider) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
                    var e_1, _a;
                    try {
                        for (var _b = tslib_1.__asyncValues(provider.listen(fetch, transform, auth)), _c; _c = yield _b.next(), !_c.done;) {
                            const list = _c.value;
                            if (stop)
                                return;
                            const notifications = notificationsRef.current;
                            const [dismissedItems] = dismissedPrefRef.current;
                            const items = list.filter(n => !dismissedItems.some(({ $id, source }) => n.$id == $id && n.source == source)
                                && !notifications.some(({ $id, source }) => n.$id == $id && n.source == source));
                            if (items.length > 0)
                                setNotifications([
                                    ...notifications,
                                    ...items
                                ]);
                        }
                    }
                    catch (e_1_1) { e_1 = { error: e_1_1 }; }
                    finally {
                        try {
                            if (_c && !_c.done && (_a = _b.return)) yield _a.call(_b);
                        }
                        finally { if (e_1) throw e_1.error; }
                    }
                }));
            }
            catch (ex) {
                smarthub_common_1.Logger.error(ex.message, false, { ex });
            }
        });
        if (auth && fetch && transform)
            loadNotifications();
        return () => {
            stop = true;
        };
    }, [auth, fetch, transform]);
    return react_1.default.createElement(smarthub_common_1.NotificationContext.Provider, { value: context }, children);
};
exports.NotificationProvider = NotificationProvider;


/***/ }),

/***/ "./src/components/context/page-provider/index.ts":
/*!*******************************************************!*\
  !*** ./src/components/context/page-provider/index.ts ***!
  \*******************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./page-provider.component */ "./src/components/context/page-provider/page-provider.component.tsx"), exports);


/***/ }),

/***/ "./src/components/context/page-provider/page-provider.component.tsx":
/*!**************************************************************************!*\
  !*** ./src/components/context/page-provider/page-provider.component.tsx ***!
  \**************************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.PageProvider = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const PageProvider = ({ children }) => {
    const [pageState, setPageState] = react_1.useState("closed");
    const [selectedPage, setSelectedPage] = react_1.useState(null);
    const [context, setContext] = react_1.useState({
        pageState,
        selectedPage,
        setPageState,
        setSelectedPage,
    });
    react_1.useEffect(() => {
        setContext({
            pageState,
            selectedPage,
            setPageState,
            setSelectedPage,
        });
    }, [pageState, selectedPage, setPageState, setSelectedPage]);
    return (react_1.default.createElement(smarthub_common_1.PageContext.Provider, { value: context }, children));
};
exports.PageProvider = PageProvider;


/***/ }),

/***/ "./src/components/context/panel-view-provider/entity-context.component.tsx":
/*!*********************************************************************************!*\
  !*** ./src/components/context/panel-view-provider/entity-context.component.tsx ***!
  \*********************************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.EntityContext = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const template_context_component_1 = __webpack_require__(/*! ./template-context.component */ "./src/components/context/panel-view-provider/template-context.component.tsx");
const EntityContext = ({ panel, children }) => {
    const config = (panel === null || panel === void 0 ? void 0 : panel.entity) || {};
    const { query, title, description, props: { entitySchema = smarthub_common_1.IPanelEntitySchema, defaultEntity } = {} } = config;
    const entityId = smarthub_common_1.usePanelEntityId();
    const setEntityId = smarthub_common_1.useSetPanelEntityId();
    const entity = smarthub_common_1.usePanelEntity();
    const setEntity = smarthub_common_1.useSetPanelEntity();
    const fetch = smarthub_common_1.useFetch();
    const profile = smarthub_common_1.useProfile();
    const transform = smarthub_common_1.useTransform();
    react_1.useEffect(() => {
        var _a;
        const fetchEntity = () => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
            const { data } = yield fetch(query, { entityId });
            const entity = transform(entitySchema, data);
            setEntity(Object.assign(Object.assign({}, entity), { $entityId: entityId }));
        });
        if (!(panel === null || panel === void 0 ? void 0 : panel.entity)) {
            setEntity();
            return;
        }
        if (!(entityId === null || entityId === void 0 ? void 0 : entityId.length)) {
            if (defaultEntity && defaultEntity.source == 'profile' && ((_a = defaultEntity.property) === null || _a === void 0 ? void 0 : _a.length))
                setEntityId(profile[defaultEntity.property]);
            else if (entity)
                setEntityId(entity.$entityId);
            return;
        }
        if ((entity === null || entity === void 0 ? void 0 : entity.$entityId) == entityId)
            return;
        if (query)
            fetchEntity();
        else
            setEntity({
                $schema: smarthub_common_1.IPanelEntitySchema,
                $entityId: entityId,
                $id: entityId,
                uri: entityId.indexOf('http') == 0 ? entityId : null,
                type: null,
                title,
                description
            });
    }, [panel, entityId, entity, setEntity, setEntityId, config]);
    return react_1.default.createElement(template_context_component_1.TemplateContext, { panel: panel }, children);
};
exports.EntityContext = EntityContext;


/***/ }),

/***/ "./src/components/context/panel-view-provider/index.ts":
/*!*************************************************************!*\
  !*** ./src/components/context/panel-view-provider/index.ts ***!
  \*************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./panel-view-provider.component */ "./src/components/context/panel-view-provider/panel-view-provider.component.tsx"), exports);


/***/ }),

/***/ "./src/components/context/panel-view-provider/panel-context.component.tsx":
/*!********************************************************************************!*\
  !*** ./src/components/context/panel-view-provider/panel-context.component.tsx ***!
  \********************************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.PanelContext = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const entity_context_component_1 = __webpack_require__(/*! ./entity-context.component */ "./src/components/context/panel-view-provider/entity-context.component.tsx");
const template_context_component_1 = __webpack_require__(/*! ./template-context.component */ "./src/components/context/panel-view-provider/template-context.component.tsx");
const use_set_panel_data_hook_1 = __webpack_require__(/*! ./use-set-panel-data.hook */ "./src/components/context/panel-view-provider/use-set-panel-data.hook.ts");
const PanelContext = ({ children }) => {
    const panels = smarthub_common_1.usePanels();
    const panelId = smarthub_common_1.usePanelId();
    const panel = (panelId === null || panelId === void 0 ? void 0 : panelId.length) ? panels === null || panels === void 0 ? void 0 : panels.find(({ $id }) => $id == panelId) : null;
    const setData = use_set_panel_data_hook_1.useSetPanelData(panel, 'panel');
    const setInitialPanelId = smarthub_common_1.useSetInitialPanelId();
    react_1.useEffect(() => {
        setData();
    }, [setData]);
    react_1.useEffect(() => {
        if (!(panelId === null || panelId === void 0 ? void 0 : panelId.length))
            setInitialPanelId();
    }, [panels, panelId]);
    return (panel === null || panel === void 0 ? void 0 : panel.entity) ? react_1.default.createElement(entity_context_component_1.EntityContext, { panel: panel }, children)
        : react_1.default.createElement(template_context_component_1.TemplateContext, { panel: panel }, children);
};
exports.PanelContext = PanelContext;


/***/ }),

/***/ "./src/components/context/panel-view-provider/panel-view-provider.component.tsx":
/*!**************************************************************************************!*\
  !*** ./src/components/context/panel-view-provider/panel-view-provider.component.tsx ***!
  \**************************************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.PanelViewProvider = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const panel_context_component_1 = __webpack_require__(/*! ./panel-context.component */ "./src/components/context/panel-view-provider/panel-context.component.tsx");
const PanelViewProvider = ({ type, children }) => {
    const config = smarthub_common_1.useViewConfig();
    const { visibility } = config[type];
    const { visible } = smarthub_common_1.usePanelView(type);
    const context = react_1.useMemo(() => ({
        type
    }), [type]);
    return react_1.useMemo(() => visible || visibility == 'auto'
        ? react_1.default.createElement(smarthub_common_1.CurrentPanelContext.Provider, { value: context },
            react_1.default.createElement(panel_context_component_1.PanelContext, null, children))
        : react_1.default.createElement(react_1.default.Fragment, null), [context, visible, visibility]);
};
exports.PanelViewProvider = PanelViewProvider;


/***/ }),

/***/ "./src/components/context/panel-view-provider/tab-context.component.tsx":
/*!******************************************************************************!*\
  !*** ./src/components/context/panel-view-provider/tab-context.component.tsx ***!
  \******************************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.TabContext = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const use_set_panel_data_hook_1 = __webpack_require__(/*! ./use-set-panel-data.hook */ "./src/components/context/panel-view-provider/use-set-panel-data.hook.ts");
const view_context_component_1 = __webpack_require__(/*! ./view-context.component */ "./src/components/context/panel-view-provider/view-context.component.tsx");
const TabContext = ({ panel, template, tabs, children }) => {
    const [tab, setTab] = react_1.useState();
    const setTabId = smarthub_common_1.useSetTabId();
    const tabId = smarthub_common_1.useTabId();
    const setData = use_set_panel_data_hook_1.useSetPanelData(tab, 'tab');
    smarthub_common_1.useAsyncEffect(() => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
        setData();
    }), [setData]);
    smarthub_common_1.useAsyncEffect(() => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
        const { items, preferred: { $id: preferredId } = {} } = tabs;
        const tab = (tabId === null || tabId === void 0 ? void 0 : tabId.length) ? items.find(({ $id }) => $id == tabId)
            : null;
        if (!tab)
            setTabId(preferredId);
        else
            setTab(tab);
    }), [tabId, tabs]);
    return tab
        ? react_1.default.createElement(view_context_component_1.ViewContext, { panel: panel, template: template, tabs: tabs.items, tab: tab }, children)
        : react_1.default.createElement(react_1.default.Fragment, null);
};
exports.TabContext = TabContext;


/***/ }),

/***/ "./src/components/context/panel-view-provider/tabs-context.component.tsx":
/*!*******************************************************************************!*\
  !*** ./src/components/context/panel-view-provider/tabs-context.component.tsx ***!
  \*******************************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.TabsContext = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importDefault(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const tab_context_component_1 = __webpack_require__(/*! ./tab-context.component */ "./src/components/context/panel-view-provider/tab-context.component.tsx");
const TabsContext = ({ panel, template, children }) => {
    const allowed = smarthub_common_1.useConditions(`${template === null || template === void 0 ? void 0 : template.$id}-tabs`, template === null || template === void 0 ? void 0 : template.tabs, undefined, 'panel');
    const tabs = smarthub_common_1.useOrdered(allowed);
    return template && tabs.preferred
        ? react_1.default.createElement(tab_context_component_1.TabContext, { panel: panel, template: template, tabs: tabs }, children)
        : react_1.default.createElement(react_1.default.Fragment, null);
};
exports.TabsContext = TabsContext;


/***/ }),

/***/ "./src/components/context/panel-view-provider/template-context.component.tsx":
/*!***********************************************************************************!*\
  !*** ./src/components/context/panel-view-provider/template-context.component.tsx ***!
  \***********************************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.TemplateContext = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const tabs_context_component_1 = __webpack_require__(/*! ./tabs-context.component */ "./src/components/context/panel-view-provider/tabs-context.component.tsx");
const use_set_panel_data_hook_1 = __webpack_require__(/*! ./use-set-panel-data.hook */ "./src/components/context/panel-view-provider/use-set-panel-data.hook.ts");
const TemplateContext = ({ panel, children }) => {
    const allowed = smarthub_common_1.useConditions(`${panel === null || panel === void 0 ? void 0 : panel.$id}-templates`, panel === null || panel === void 0 ? void 0 : panel.templates, undefined, 'panel');
    const ordered = smarthub_common_1.useOrdered(allowed);
    const template = panel && (allowed === null || allowed === void 0 ? void 0 : allowed.length)
        ? ordered.preferred
        : null;
    const setData = use_set_panel_data_hook_1.useSetPanelData(template, 'panel');
    react_1.useEffect(() => {
        setData();
    }, [setData]);
    return template
        ? react_1.default.createElement(tabs_context_component_1.TabsContext, { panel: panel, template: template }, children)
        : react_1.default.createElement(react_1.default.Fragment, null);
};
exports.TemplateContext = TemplateContext;


/***/ }),

/***/ "./src/components/context/panel-view-provider/use-set-panel-data.hook.ts":
/*!*******************************************************************************!*\
  !*** ./src/components/context/panel-view-provider/use-set-panel-data.hook.ts ***!
  \*******************************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useSetPanelData = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = __webpack_require__(/*! react */ "react");
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const channel = 'state';
const group = 'shared';
const useSetPanelData = (component, level) => {
    const { $id, dataSets } = component || {};
    const fetch = smarthub_common_1.useFetch();
    const transform = smarthub_common_1.useTransform();
    const source = smarthub_common_1.usePanelType();
    const consumes = react_1.useMemo(() => dataSets === null || dataSets === void 0 ? void 0 : dataSets.reduce((all, { consumes }) => {
        return [
            ...all,
            ...(consumes || [])
        ];
    }, []), [dataSets]);
    const [sharedState, setSharedState] = smarthub_common_1.useSharedStates($id, undefined, level);
    const setSharedStates = smarthub_common_1.useSetSharedStates();
    react_1.useEffect(() => setSharedState(consumes), [consumes]);
    return react_1.useCallback(() => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
        if (!(dataSets === null || dataSets === void 0 ? void 0 : dataSets.length))
            return Promise.resolve();
        const results = yield Promise.all(dataSets.map(({ name, query, schema }) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
            const { data } = yield fetch(query, sharedState);
            const value = transform(schema, data);
            return { name, value };
        })));
        const dataItems = results.map(({ name, value }) => ({
            group,
            source,
            name,
            channel,
            level,
            value
        }));
        setSharedStates(dataItems);
    }), [sharedState, component]);
};
exports.useSetPanelData = useSetPanelData;


/***/ }),

/***/ "./src/components/context/panel-view-provider/view-context.component.tsx":
/*!*******************************************************************************!*\
  !*** ./src/components/context/panel-view-provider/view-context.component.tsx ***!
  \*******************************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ViewContext = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const ViewContext = ({ panel, template, tab, tabs, children }) => {
    const globalScopes = smarthub_common_1.useGlobalChatScopes();
    const [context, setContext] = react_1.useState(null);
    const type = smarthub_common_1.usePanelType();
    const setScopes = smarthub_common_1.useSetChatScopes();
    const contextRef = react_1.useRef({
        type,
        panel,
        initialFocus: null,
        actions: null,
        regions: null,
        scopes: null,
        tab,
        tabs: tabs,
        template,
    });
    react_1.useEffect(() => {
        var _a;
        if (type == 'main' && ((_a = context === null || context === void 0 ? void 0 : context.scopes) === null || _a === void 0 ? void 0 : _a.length))
            setScopes(context.scopes);
    }, [context === null || context === void 0 ? void 0 : context.scopes]);
    react_1.useEffect(() => {
        if (!tab)
            return;
        const actions = [
            ...(panel.actions || []),
            ...(template.actions || []),
            ...(tab.actions || [])
        ];
        const scopes = [
            ...(tab.chatScopes || []),
            ...(template.chatScopes || []),
            ...(panel.chatScopes || []),
            ...(globalScopes || [])
        ];
        const regions = Object.assign(Object.assign(Object.assign({}, panel), template), tab);
        const { initialFocus } = regions;
        contextRef.current = Object.assign(Object.assign({}, contextRef.current), { type,
            panel,
            initialFocus,
            template,
            tabs,
            tab,
            regions,
            actions,
            scopes });
        setContext(contextRef.current);
    }, [tab]);
    react_1.useEffect(() => {
        const { current, current: { tabs: currentTabs } = {} } = contextRef;
        if (tabs == currentTabs)
            return;
        contextRef.current = Object.assign(Object.assign({}, current), { tabs });
        setContext(contextRef.current);
    }, [tabs]);
    react_1.useEffect(() => {
        const { current } = contextRef;
        contextRef.current = Object.assign(Object.assign({}, current), { panel });
        setContext(contextRef.current);
    }, [tabs]);
    return react_1.default.createElement(smarthub_common_1.PanelViewContext.Provider, { value: context }, context != null && children);
};
exports.ViewContext = ViewContext;


/***/ }),

/***/ "./src/components/context/panel-view-state-provider/index.ts":
/*!*******************************************************************!*\
  !*** ./src/components/context/panel-view-state-provider/index.ts ***!
  \*******************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./panel-view-state-provider.component */ "./src/components/context/panel-view-state-provider/panel-view-state-provider.component.tsx"), exports);


/***/ }),

/***/ "./src/components/context/panel-view-state-provider/panel-view-state-provider.component.tsx":
/*!**************************************************************************************************!*\
  !*** ./src/components/context/panel-view-state-provider/panel-view-state-provider.component.tsx ***!
  \**************************************************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.PanelViewStateProvider = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
//TODO refactor
const PanelViewStateProvider = ({ children, type, }) => {
    var _a;
    const viewConfig = smarthub_common_1.useViewConfig();
    const view = viewConfig[type];
    const dockConfig = smarthub_common_1.useResponsiveProps(view === null || view === void 0 ? void 0 : view.dockSizes);
    const [size] = smarthub_common_1.usePreference(smarthub_common_1.preferenceKeys[`${type}DockSize`], false, dockConfig.preferred);
    const [position] = smarthub_common_1.usePreference(smarthub_common_1.preferenceKeys[`${type}DockPosition`], false, (_a = view === null || view === void 0 ? void 0 : view.dockPositions) === null || _a === void 0 ? void 0 : _a.preferred);
    const [launcher] = smarthub_common_1.usePreference(smarthub_common_1.preferenceKeys[`${type}LauncherState`], false, "closed");
    const [pages] = smarthub_common_1.usePreference(smarthub_common_1.preferenceKeys[`${type}PagesState`], false, "closed");
    const [content] = smarthub_common_1.usePreference(smarthub_common_1.preferenceKeys[`${type}ContentView`], false, "normal");
    const setPanelView = smarthub_common_1.useSetPanelView(type);
    const panelViewRef = smarthub_common_1.useHookRef(smarthub_common_1.usePanelView, type);
    react_1.useEffect(() => {
        const { initialPanel: { visible } = {} } = view;
        if (!panelViewRef.current)
            setPanelView({
                size,
                position,
                visible,
                launcher,
                pages,
                content,
            });
    }, []);
    react_1.useEffect(() => {
        let { current: state } = panelViewRef;
        if (!state)
            return;
        if (size != state.size && (size != "full" || state.size != "asside"))
            state = Object.assign(Object.assign({}, state), { size });
        if (position != state.position)
            state = Object.assign(Object.assign({}, state), { position });
        if (content != state.content)
            state = Object.assign(Object.assign({}, state), { content });
        if (state != panelViewRef.current) {
            panelViewRef.current = state;
            setPanelView(state);
        }
    }, [size, position, content]);
    return react_1.default.createElement(react_1.default.Fragment, null, children);
};
exports.PanelViewStateProvider = PanelViewStateProvider;


/***/ }),

/***/ "./src/components/context/panels-provider/index.ts":
/*!*********************************************************!*\
  !*** ./src/components/context/panels-provider/index.ts ***!
  \*********************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./panels-provider.component */ "./src/components/context/panels-provider/panels-provider.component.tsx"), exports);


/***/ }),

/***/ "./src/components/context/panels-provider/panels-provider.component.tsx":
/*!******************************************************************************!*\
  !*** ./src/components/context/panels-provider/panels-provider.component.tsx ***!
  \******************************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.PanelsProvider = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const panel_view_state_provider_1 = __webpack_require__(/*! ../panel-view-state-provider */ "./src/components/context/panel-view-state-provider/index.ts");
const PanelsProvider = ({ children }) => {
    const { panels: panelsProvider } = smarthub_common_1.useProviders();
    const authContext = smarthub_common_1.useAuth();
    const profile = smarthub_common_1.useProfile();
    const [context, setContext] = react_1.useState(null);
    const loadPanels = () => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
        try {
            const panels = yield panelsProvider.process(authContext, profile);
            setContext(panels);
        }
        catch (ex) {
            smarthub_common_1.Logger.error(ex.message, false, { ex });
        }
    });
    react_1.useEffect(() => {
        if (authContext && profile && !context)
            loadPanels();
    }, [authContext, profile]);
    return react_1.default.createElement(smarthub_common_1.PanelsContext.Provider, { value: context },
        react_1.default.createElement(panel_view_state_provider_1.PanelViewStateProvider, { type: "main" }),
        react_1.default.createElement(panel_view_state_provider_1.PanelViewStateProvider, { type: "page" }),
        react_1.default.createElement(panel_view_state_provider_1.PanelViewStateProvider, { type: "chat" }),
        children);
};
exports.PanelsProvider = PanelsProvider;


/***/ }),

/***/ "./src/components/context/personality-provider/index.ts":
/*!**************************************************************!*\
  !*** ./src/components/context/personality-provider/index.ts ***!
  \**************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./personality-provider.component */ "./src/components/context/personality-provider/personality-provider.component.tsx"), exports);


/***/ }),

/***/ "./src/components/context/personality-provider/personality-provider.component.tsx":
/*!****************************************************************************************!*\
  !*** ./src/components/context/personality-provider/personality-provider.component.tsx ***!
  \****************************************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.PersonalityProvider = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const PersonalityProvider = ({ children, }) => {
    const [personality, setPersonality] = react_1.useState("");
    const [context, setContext] = react_1.useState({
        personality,
        setPersonality,
    });
    react_1.useEffect(() => {
        setContext({
            personality,
            setPersonality,
        });
    }, [personality, setPersonality]);
    return (react_1.default.createElement(smarthub_common_1.PersonalityContext.Provider, { value: context }, children));
};
exports.PersonalityProvider = PersonalityProvider;


/***/ }),

/***/ "./src/components/context/preference-provider/index.ts":
/*!*************************************************************!*\
  !*** ./src/components/context/preference-provider/index.ts ***!
  \*************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./preference-provider.component */ "./src/components/context/preference-provider/preference-provider.component.tsx"), exports);


/***/ }),

/***/ "./src/components/context/preference-provider/preference-provider.component.tsx":
/*!**************************************************************************************!*\
  !*** ./src/components/context/preference-provider/preference-provider.component.tsx ***!
  \**************************************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.PreferenceProvider = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const PreferenceProvider = ({ children }) => {
    const { preferences: providers } = smarthub_common_1.useProviders();
    const authContext = smarthub_common_1.useAuth();
    const authContextRef = react_1.useRef();
    authContextRef.current = authContext;
    const [preferences, setPreferences] = react_1.useState([]);
    const [context, setContext] = react_1.useState(null);
    const set = react_1.useCallback((key, value, cacheLevel = 'permanent') => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
        try {
            const { current: auth } = authContextRef;
            const provider = providers === null || providers === void 0 ? void 0 : providers[cacheLevel];
            if (value == null) {
                if (provider)
                    yield provider.remove(key, auth);
                setPreferences([
                    ...preferences.filter(p => p.key !== key)
                ]);
            }
            else {
                const preference = {
                    key,
                    value: typeof value == 'string'
                        ? value
                        : JSON.stringify(value)
                };
                if (provider)
                    yield provider.add(preference, auth);
                setPreferences([
                    ...preferences.filter(p => p.key !== key),
                    preference
                ]);
            }
        }
        catch (ex) {
            smarthub_common_1.Logger.error("Could not set preference", true, ex);
        }
    }), [preferences]);
    const remove = react_1.useCallback((key, cacheLevel = 'permanent') => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
        try {
            const provider = providers === null || providers === void 0 ? void 0 : providers[cacheLevel];
            if (provider)
                yield provider.remove(key, authContextRef.current);
            setPreferences([
                ...preferences.filter(p => p.key !== key)
            ]);
        }
        catch (ex) {
            smarthub_common_1.Logger.error("Could not remove preference", true, ex);
        }
    }), [preferences]);
    const get = react_1.useCallback((key, parse, defaultValue) => {
        var _a;
        try {
            const { value } = (_a = preferences.find(p => p.key == key)) !== null && _a !== void 0 ? _a : {};
            return (value === null || value === void 0 ? void 0 : value.length) ? parse
                ? JSON.parse(value)
                : value
                : defaultValue;
        }
        catch (ex) {
            smarthub_common_1.Logger.error("Could not get preference", true, ex);
        }
    }, [preferences]);
    const loadPreferences = () => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
        try {
            const { current: auth } = authContextRef;
            const permanent = (providers === null || providers === void 0 ? void 0 : providers.permanent) && ((providers === null || providers === void 0 ? void 0 : providers.permanent.localStorage) || auth)
                ? yield providers.permanent.getAll(auth)
                : [];
            const temporary = (providers === null || providers === void 0 ? void 0 : providers.temporary) && (providers.temporary.localStorage
                || auth)
                ? yield providers.temporary.getAll(auth)
                : [];
            setPreferences([
                ...permanent,
                ...temporary
            ]);
        }
        catch (ex) {
            smarthub_common_1.Logger.error(ex.message, false, { ex });
        }
    });
    react_1.useEffect(() => {
        setContext({
            set,
            remove,
            get
        });
    }, [preferences]);
    react_1.useEffect(() => {
        loadPreferences();
    }, [authContext]);
    return react_1.default.createElement(smarthub_common_1.PreferenceContext.Provider, { value: context }, children);
};
exports.PreferenceProvider = PreferenceProvider;


/***/ }),

/***/ "./src/components/context/profile-provider/index.ts":
/*!**********************************************************!*\
  !*** ./src/components/context/profile-provider/index.ts ***!
  \**********************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./profile-provider.component */ "./src/components/context/profile-provider/profile-provider.component.tsx"), exports);


/***/ }),

/***/ "./src/components/context/profile-provider/profile-provider.component.tsx":
/*!********************************************************************************!*\
  !*** ./src/components/context/profile-provider/profile-provider.component.tsx ***!
  \********************************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ProfileProvider = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const ProfileProvider = ({ children }) => {
    const { profile: profileProvider } = smarthub_common_1.useProviders();
    const profile = smarthub_common_1.useProfile();
    const setProfile = smarthub_common_1.useSetProfile();
    const fetch = smarthub_common_1.useFetch();
    const transform = smarthub_common_1.useTransform();
    const authContext = smarthub_common_1.useAuth();
    const loadProfile = () => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
        const baseProfile = {
            $schema: smarthub_common_1.IPersonSchema,
            $id: null,
        };
        try {
            const profile = yield (profileProvider === null || profileProvider === void 0 ? void 0 : profileProvider.reduce((promise, provider) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
                return (promise.then(profile => provider.process(fetch, transform, profile)));
            }), Promise.resolve(baseProfile)));
            setProfile(profile !== null && profile !== void 0 ? profile : baseProfile);
        }
        catch (ex) {
            smarthub_common_1.Logger.error(ex.message, false, { ex });
        }
    });
    react_1.useEffect(() => {
        if (authContext && fetch && transform && !profile)
            loadProfile();
    }, [authContext, fetch, transform]);
    return react_1.default.createElement(react_1.default.Fragment, null, children);
};
exports.ProfileProvider = ProfileProvider;


/***/ }),

/***/ "./src/components/context/theme-provider/index.ts":
/*!********************************************************!*\
  !*** ./src/components/context/theme-provider/index.ts ***!
  \********************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./theme-provider.component */ "./src/components/context/theme-provider/theme-provider.component.tsx"), exports);


/***/ }),

/***/ "./src/components/context/theme-provider/theme-provider.component.tsx":
/*!****************************************************************************!*\
  !*** ./src/components/context/theme-provider/theme-provider.component.tsx ***!
  \****************************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ThemeProvider = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const react_jss_1 = __webpack_require__(/*! react-jss */ "react-jss");
const react_2 = __webpack_require__(/*! @fluentui/react */ "@fluentui/react");
const ThemeProviderWrapper = react_1.forwardRef(({ children }, ref) => react_1.default.createElement(react_1.default.Fragment, null, children));
const ThemeProvider = ({ children, themes }) => {
    const [preferredThemeId] = smarthub_common_1.usePreference(smarthub_common_1.preferenceKeys.userTheme);
    const [selectedTheme, setSelectedTheme] = react_1.useState(null);
    const [context, setContext] = react_1.useState(null);
    const setTheme = react_1.useCallback((id) => {
        var _a;
        setSelectedTheme((_a = themes.find(t => t.$id == id)) !== null && _a !== void 0 ? _a : themes[0]);
    }, [themes]);
    react_1.useEffect(() => {
        var _a;
        const theme = selectedTheme != null
            ? selectedTheme
            : (preferredThemeId === null || preferredThemeId === void 0 ? void 0 : preferredThemeId.length) ? (_a = themes.find(({ $id }) => $id == preferredThemeId)) !== null && _a !== void 0 ? _a : themes[0] : themes[0];
        const fluentTheme = smarthub_common_1.mergeFluentTheme(theme.definition);
        setContext({
            setTheme,
            themes,
            theme,
            fluentTheme
        });
    }, [themes, preferredThemeId, selectedTheme]);
    return react_1.default.createElement(smarthub_common_1.ThemeContext.Provider, { value: context }, context && react_1.default.createElement(react_jss_1.ThemeProvider, { theme: context.theme.definition },
        react_1.default.createElement(react_2.ThemeProvider, { theme: context === null || context === void 0 ? void 0 : context.fluentTheme, as: ThemeProviderWrapper, applyTo: "none" }, children)));
};
exports.ThemeProvider = ThemeProvider;


/***/ }),

/***/ "./src/components/context/tpc-check-provider/index.ts":
/*!************************************************************!*\
  !*** ./src/components/context/tpc-check-provider/index.ts ***!
  \************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./tpc-check-provider.component */ "./src/components/context/tpc-check-provider/tpc-check-provider.component.tsx"), exports);


/***/ }),

/***/ "./src/components/context/tpc-check-provider/tpc-check-provider.component.tsx":
/*!************************************************************************************!*\
  !*** ./src/components/context/tpc-check-provider/tpc-check-provider.component.tsx ***!
  \************************************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.TPCCheckProvider = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const TPCCheckProvider = ({ children, config }) => {
    const { level, checkUri, infoUri } = config || { level: 'none' };
    const checkDisabled = !(checkUri === null || checkUri === void 0 ? void 0 : checkUri.length);
    const contextRef = react_1.useRef({
        checked: checkDisabled,
        level,
        enabled: checkDisabled,
        infoUri
    });
    const [context, setContext] = react_1.useState(contextRef.current);
    const callback = react_1.useCallback((e) => {
        var _a, _b;
        const enabled = (_b = (_a = e.data) === null || _a === void 0 ? void 0 : _a.smarthub) === null || _b === void 0 ? void 0 : _b.tpcCheck;
        if (enabled == undefined)
            return;
        const { current } = contextRef;
        setContext(Object.assign(Object.assign({}, current), {
            checked: true,
            enabled
        }));
    }, []);
    react_1.useEffect(() => {
        window.addEventListener('message', callback);
        return () => window.removeEventListener('message', callback);
    }, []);
    const allowUI = level !== 'error' || context.enabled;
    return react_1.default.createElement(react_1.default.Fragment, null,
        !context.checked && react_1.default.createElement("iframe", { src: `${checkUri}`, style: {
                width: '0px',
                height: '0px',
                border: '0px'
            } }),
        allowUI && react_1.default.createElement(smarthub_common_1.TPCCheckContext.Provider, { value: context }, children));
};
exports.TPCCheckProvider = TPCCheckProvider;


/***/ }),

/***/ "./src/components/focus-trap/focus-trap.component.tsx":
/*!************************************************************!*\
  !*** ./src/components/focus-trap/focus-trap.component.tsx ***!
  \************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.FocusTrap = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const react_jss_1 = __webpack_require__(/*! react-jss */ "react-jss");
const candidateSelectors = [
    'input',
    'select',
    'textarea',
    'a[href]',
    'button',
    'not("[data-first]")',
    'not("[data-last]")',
    '[tabindex]:not([tabindex="-1"])',
    'audio[controls]',
    'video[controls]',
    '[contenteditable]:not([contenteditable="false"])',
    'details>summary:first-of-type',
    'details',
].join(',');
const useStyles = react_jss_1.createUseStyles((theme) => {
    var _a, _b;
    const { palette, spacing, fonts, sizes, styles } = theme;
    const panel = (_b = (_a = styles === null || styles === void 0 ? void 0 : styles.core) === null || _a === void 0 ? void 0 : _a.panel) !== null && _b !== void 0 ? _b : {};
    const props = { theme };
    const baseStyles = Object.assign(Object.assign({}, fonts.normal), { position: "absolute", height: `${sizes.normal}`, lineHeight: `${sizes.normal}`, padding: `0 ${spacing.smallPlus}`, textAlign: 'center', margin: 'auto', boxSizing: 'border-box', zIndex: 1, alignSelf: 'center', transition: "transform ease-out 300ms", backgroundColor: palette.primary, color: palette.primaryOn, transform: "scale(0)", "&:focus": {
            transform: "scale(1)"
        } });
    return {
        rootStyles: Object.assign({ position: 'relative' }, (smarthub_common_1.themeStyle(panel.root, props))),
        startStyles: Object.assign(Object.assign(Object.assign({}, baseStyles), { top: spacing.smallPlus }), (smarthub_common_1.themeStyle(panel.start, props))),
        endStyles: Object.assign(Object.assign(Object.assign({}, baseStyles), { bottom: spacing.smallPlus }), (smarthub_common_1.themeStyle(panel.start, props))),
    };
});
const FocusTrap = (_a) => {
    var { onClose, as, name, initialFocus, resetFocus, trapFocus, className, startLabel, endLabel, startText, endText, children } = _a, props = tslib_1.__rest(_a, ["onClose", "as", "name", "initialFocus", "resetFocus", "trapFocus", "className", "startLabel", "endLabel", "startText", "endText", "children"]);
    const { startStyles, endStyles, rootStyles } = useStyles();
    const register = smarthub_common_1.useRegisterFocus();
    const Tag = as || 'div';
    const start = react_1.useRef();
    const end = react_1.useRef();
    const ref = react_1.useRef(null);
    const focus = smarthub_common_1.useFocus();
    const onKeyDown = react_1.useCallback(({ key, target, shiftKey, stopPropagation, preventDefault }) => {
        if (key === "Escape") {
            onClose();
        }
        if (key !== 'Tab' || trapFocus === false)
            return;
        const { current: startEl } = start;
        const { current: endEl } = end;
        const nextEl = !shiftKey && target == endEl
            ? startEl
            : shiftKey && target == startEl
                ? endEl
                : null;
        if (nextEl) {
            nextEl.focus();
            stopPropagation();
            preventDefault();
        }
    }, []);
    react_1.useEffect(() => {
        var _a, _b, _c;
        if (initialFocus == 'first') {
            const el = (_a = ref.current) === null || _a === void 0 ? void 0 : _a.querySelector(candidateSelectors);
            if (el)
                el.focus();
        }
        else if (initialFocus == 'self')
            (_b = ref.current) === null || _b === void 0 ? void 0 : _b.focus();
        else if (initialFocus == 'start')
            (_c = start.current) === null || _c === void 0 ? void 0 : _c.focus();
        else if (initialFocus === null || initialFocus === void 0 ? void 0 : initialFocus.length)
            focus(initialFocus);
    }, [resetFocus]);
    react_1.useEffect(() => {
        if (name === null || name === void 0 ? void 0 : name.length)
            register(name, () => {
                ref.current && ref.current.focus();
            });
    }, []);
    return (react_1.default.createElement(Tag, Object.assign({}, props, { ref: ref, tabIndex: 0, className: [rootStyles, className].join(' ') }),
        react_1.default.createElement("div", { role: 'button', ref: start, onKeyDown: onKeyDown, "aria-label": startLabel, className: startStyles, tabIndex: 0 }, startText),
        children,
        react_1.default.createElement("div", { role: 'button', ref: end, onKeyDown: onKeyDown, "aria-label": endLabel, className: endStyles, tabIndex: 0 }, endText)));
};
exports.FocusTrap = FocusTrap;


/***/ }),

/***/ "./src/components/focus-trap/index.ts":
/*!********************************************!*\
  !*** ./src/components/focus-trap/index.ts ***!
  \********************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./focus-trap.component */ "./src/components/focus-trap/focus-trap.component.tsx"), exports);


/***/ }),

/***/ "./src/components/grid/column.component.tsx":
/*!**************************************************!*\
  !*** ./src/components/grid/column.component.tsx ***!
  \**************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Column = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const React = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const component_wrapper_component_1 = __webpack_require__(/*! ./component-wrapper.component */ "./src/components/grid/component-wrapper.component.tsx");
const get_responsive_class_helper_1 = __webpack_require__(/*! ./get-responsive-class.helper */ "./src/components/grid/get-responsive-class.helper.ts");
const row_component_1 = __webpack_require__(/*! ./row.component */ "./src/components/grid/row.component.tsx");
const Column = ({ layout, column, contentView }) => {
    const styles = smarthub_common_1.useGridStyles();
    const { zones: layoutZones } = layout;
    const { tokens: { padding, hideOnExpand, spacer } = {}, responsive, zones } = column;
    const { col, padR, padL } = styles;
    const className = [col, padding == "normal" ? padR : "", (spacer == 'normal' ? padL : ''), get_responsive_class_helper_1.getResponsiveClass(styles, responsive)].join(" ");
    return (contentView != 'expanded' || !hideOnExpand)
        ? React.createElement("div", { className: className },
            column.zones && zones.map((zone, zoneIndex) => {
                const zoneConfig = layoutZones.find(c => c.id == zone.id);
                return (React.createElement(React.Fragment, { key: zoneIndex }, zoneConfig &&
                    zoneConfig.components.map((component) => React.createElement(component_wrapper_component_1.ComponentWrapper, { key: component.$id, config: component }))));
            }),
            column.rows && column.rows.map((row, rowIndex) => {
                return React.createElement(row_component_1.Row, { key: rowIndex, row: row, layout: layout, contentView: contentView });
            }))
        : null;
};
exports.Column = Column;


/***/ }),

/***/ "./src/components/grid/component-wrapper.component.tsx":
/*!*************************************************************!*\
  !*** ./src/components/grid/component-wrapper.component.tsx ***!
  \*************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ComponentWrapper = void 0;
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const ComponentWrapper = ({ config, data, fallback }) => {
    const render = smarthub_common_1.useRender();
    return render(config, data, fallback)();
};
exports.ComponentWrapper = ComponentWrapper;


/***/ }),

/***/ "./src/components/grid/get-responsive-class.helper.ts":
/*!************************************************************!*\
  !*** ./src/components/grid/get-responsive-class.helper.ts ***!
  \************************************************************/
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.getResponsiveClass = void 0;
const getResponsiveClass = (gridStyles, responsive) => {
    let className = [];
    if (responsive) {
        Object.keys(responsive).forEach(k => {
            let design = responsive[k];
            Object.keys(design).forEach(key => {
                const name = key == 'display' || key == 'size' || key == 'align' || key == 'wrap'
                    ? gridStyles[`${k}${design[key]}`]
                    : key == 'order' || key == 'max' || key == 'min'
                        ? gridStyles[`${k}${key}${design[key]}`]
                        : gridStyles[`${k}${key}`];
                className.push(name);
            });
        });
    }
    return className.join(" ");
};
exports.getResponsiveClass = getResponsiveClass;


/***/ }),

/***/ "./src/components/grid/grid.component.tsx":
/*!************************************************!*\
  !*** ./src/components/grid/grid.component.tsx ***!
  \************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Grid = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importDefault(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const get_responsive_class_helper_1 = __webpack_require__(/*! ./get-responsive-class.helper */ "./src/components/grid/get-responsive-class.helper.ts");
const row_component_1 = __webpack_require__(/*! ./row.component */ "./src/components/grid/row.component.tsx");
const Grid = ({ resetScroll, layout, as, className }) => {
    const styles = smarthub_common_1.useGridStyles();
    const { grid, padR, padB } = styles;
    const { content: contentView } = smarthub_common_1.usePanelView();
    const { grid: { tokens: { padding, spacer } = {}, responsive, rows } } = layout;
    const Tag = as || 'div';
    const combinedClass = [className, grid, padding == "none" ? "" : padR, (spacer == 'normal' ? padB : ''), get_responsive_class_helper_1.getResponsiveClass(styles, responsive)].join(" ");
    return (react_1.default.createElement(Tag, { className: combinedClass }, rows === null || rows === void 0 ? void 0 : rows.map((row, rowIndex) => react_1.default.createElement(row_component_1.Row, { key: `${rowIndex}-${resetScroll}`, row: row, layout: layout, contentView: contentView }))));
};
exports.Grid = Grid;


/***/ }),

/***/ "./src/components/grid/index.ts":
/*!**************************************!*\
  !*** ./src/components/grid/index.ts ***!
  \**************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./grid.component */ "./src/components/grid/grid.component.tsx"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./row.component */ "./src/components/grid/row.component.tsx"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./column.component */ "./src/components/grid/column.component.tsx"), exports);


/***/ }),

/***/ "./src/components/grid/row.component.tsx":
/*!***********************************************!*\
  !*** ./src/components/grid/row.component.tsx ***!
  \***********************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Row = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const React = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const column_component_1 = __webpack_require__(/*! ./column.component */ "./src/components/grid/column.component.tsx");
const get_responsive_class_helper_1 = __webpack_require__(/*! ./get-responsive-class.helper */ "./src/components/grid/get-responsive-class.helper.ts");
const Row = ({ layout, row, contentView }) => {
    const styles = smarthub_common_1.useGridStyles();
    const { tokens: { padding, hideOnExpand, spacer } = {}, responsive } = row;
    const { row: rowStyle, padT, padB } = styles;
    const className = [rowStyle, (padding == "normal" ? padT : ""), (spacer == 'normal' ? padB : ''), get_responsive_class_helper_1.getResponsiveClass(styles, responsive)].join(" ");
    return (contentView != 'expanded' || !hideOnExpand)
        ? React.createElement("div", { className: className }, row.columns && row.columns.map((col, colIndex) => React.createElement(column_component_1.Column, { key: colIndex, column: col, layout: layout, contentView: contentView })))
        : null;
};
exports.Row = Row;


/***/ }),

/***/ "./src/components/index.ts":
/*!*********************************!*\
  !*** ./src/components/index.ts ***!
  \*********************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./app */ "./src/components/app/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./chat-root */ "./src/components/chat-root/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./chrome */ "./src/components/chrome/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./context */ "./src/components/context/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./focus-trap */ "./src/components/focus-trap/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./grid */ "./src/components/grid/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./launcher */ "./src/components/launcher/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./main-menu */ "./src/components/main-menu/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./panel */ "./src/components/panel/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./panel-chrome */ "./src/components/panel-chrome/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./region */ "./src/components/region/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./skip-links */ "./src/components/skip-links/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./tpc-message */ "./src/components/tpc-message/index.ts"), exports);


/***/ }),

/***/ "./src/components/launcher/index.ts":
/*!******************************************!*\
  !*** ./src/components/launcher/index.ts ***!
  \******************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./launcher.component */ "./src/components/launcher/launcher.component.tsx"), exports);


/***/ }),

/***/ "./src/components/launcher/launcher.component.tsx":
/*!********************************************************!*\
  !*** ./src/components/launcher/launcher.component.tsx ***!
  \********************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Launcher = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const context_1 = __webpack_require__(/*! ../context */ "./src/components/context/index.ts");
const react_1 = tslib_1.__importDefault(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const tpc_message_1 = __webpack_require__(/*! ../tpc-message */ "./src/components/tpc-message/index.ts");
const launchButtonTemplateID = 'component.launch-button';
const splashTemplateID = 'component.splash-screen';
const Launcher = (_a) => {
    var { children } = _a, props = tslib_1.__rest(_a, ["children"]);
    const [chromeState] = smarthub_common_1.useChromeState();
    const botReady = smarthub_common_1.useBotReady();
    const render = smarthub_common_1.useRender();
    return chromeState == 'closed'
        ? render(launchButtonTemplateID)()
        : react_1.default.createElement(tpc_message_1.TPCMessage, null,
            react_1.default.createElement(context_1.ExtendedContext, Object.assign({}, props),
                !botReady && render(splashTemplateID)(),
                children));
};
exports.Launcher = Launcher;


/***/ }),

/***/ "./src/components/main-menu/build-panel-links.helper.tsx":
/*!***************************************************************!*\
  !*** ./src/components/main-menu/build-panel-links.helper.tsx ***!
  \***************************************************************/
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.buildPanelLinks = void 0;
const buildPanelLinks = (panels, panelLinks, selectPanel, current) => panels.filter(({ navigation }) => navigation == 'primary' || navigation == 'secondary')
    .sort((a, b) => a.order - b.order)
    .reduce((panels, panel) => {
    const { $id, icon, shortTitle, title, description, navigation } = panel;
    const checked = current == $id;
    panels[navigation].push({
        key: $id,
        iconProps: {
            iconName: `${icon === null || icon === void 0 ? void 0 : icon.name}`
        },
        "aria-current": checked,
        checked,
        text: shortTitle,
        title: description,
        ariaLabel: title,
        ariaDescription: description,
        onClick: () => {
            selectPanel(panel);
        }
    });
    return panels;
}, panelLinks);
exports.buildPanelLinks = buildPanelLinks;


/***/ }),

/***/ "./src/components/main-menu/get-cache-key.helper.ts":
/*!**********************************************************!*\
  !*** ./src/components/main-menu/get-cache-key.helper.ts ***!
  \**********************************************************/
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.getCacheKey = void 0;
const getCacheKey = ({ primaryItems, overflowItems, farItems }) => {
    const returnKey = (acc, { key }) => {
        return acc + key;
    };
    const primaryKey = (primaryItems === null || primaryItems === void 0 ? void 0 : primaryItems.length) && primaryItems.reduce(returnKey, '');
    const farKey = (farItems === null || farItems === void 0 ? void 0 : farItems.length) && farItems.reduce(returnKey, '');
    const overflowKey = (overflowItems === null || overflowItems === void 0 ? void 0 : overflowItems.length) ? 'overflow' : '';
    return [primaryKey, farKey, overflowKey].join('');
};
exports.getCacheKey = getCacheKey;


/***/ }),

/***/ "./src/components/main-menu/index.ts":
/*!*******************************************!*\
  !*** ./src/components/main-menu/index.ts ***!
  \*******************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.MainMenu = void 0;
var main_menu_component_1 = __webpack_require__(/*! ./main-menu.component */ "./src/components/main-menu/main-menu.component.tsx");
Object.defineProperty(exports, "MainMenu", ({ enumerable: true, get: function () { return main_menu_component_1.MainMenu; } }));


/***/ }),

/***/ "./src/components/main-menu/main-menu.component.tsx":
/*!**********************************************************!*\
  !*** ./src/components/main-menu/main-menu.component.tsx ***!
  \**********************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.MainMenu = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const react_jss_1 = __webpack_require__(/*! react-jss */ "react-jss");
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const react_2 = __webpack_require__(/*! @fluentui/react */ "@fluentui/react");
const menu_link_component_1 = __webpack_require__(/*! ./menu-link.component */ "./src/components/main-menu/menu-link.component.tsx");
const menu_more_button_component_1 = __webpack_require__(/*! ./menu-more-button.component */ "./src/components/main-menu/menu-more-button.component.tsx");
const use_menu_links_hook_1 = __webpack_require__(/*! ./use-menu-links.hook */ "./src/components/main-menu/use-menu-links.hook.tsx");
const get_cache_key_helper_1 = __webpack_require__(/*! ./get-cache-key.helper */ "./src/components/main-menu/get-cache-key.helper.ts");
const useStyles = react_jss_1.createUseStyles(({ palette, sizes }) => ({
    resize: {
        height: '100vh',
        ["& > div > div:not([data-automation-id]) .ms-FocusZone"]: {
            height: "auto"
        }
    },
    focusZone: {
        display: "flex",
        flexDirection: "column",
        height: '100vh',
        justifyContent: "space-between"
    },
    menu: {
        zIndex: 1,
        transition: "margin-left 300ms ease-in-out",
        flex: "0 0",
        height: '100vh',
        minWidth: sizes.xxLarge,
        position: "relative",
        display: "flex",
        flexDirection: "column",
        backgroundColor: palette.primaryNavBackground,
    },
    nav: {
        flex: "1 1",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
    },
}));
const onReduceData = (data) => {
    let { primaryItems, overflowItems, farItems } = data;
    if (primaryItems.length > 0) {
        overflowItems = [...primaryItems.slice(-1), ...overflowItems];
        primaryItems = primaryItems.slice(0, -1);
    }
    else if (farItems.length > 0) {
        overflowItems = [...farItems.slice(-1), ...overflowItems];
        farItems = farItems.slice(0, -1);
    }
    else
        return undefined;
    const cacheKey = get_cache_key_helper_1.getCacheKey(data);
    return {
        primaryItems,
        overflowItems,
        farItems,
        cacheKey
    };
};
const onRenderOverflow = (data, styles, localize) => {
    const hasSecondSet = data.farItems && data.farItems.length > 0;
    return react_1.default.createElement(react_2.FocusZone, { direction: react_2.FocusZoneDirection.bidirectional, className: styles.focusZone },
        react_1.default.createElement(react_2.OverflowSet, { role: "menubar", "aria-label": localize.mainMenuPrimaryLabel, vertical: true, items: data.primaryItems, overflowItems: data.overflowItems.length ? data.overflowItems : null, onRenderItem: (item) => react_1.default.createElement(menu_link_component_1.MenuLink, Object.assign({}, item)), onRenderOverflowButton: (items) => react_1.default.createElement(menu_more_button_component_1.MenuMoreButton, { items: items }) }),
        hasSecondSet && react_1.default.createElement(react_2.OverflowSet, { role: "menubar", "aria-label": localize.mainMenuSecondaryLabel, vertical: true, items: data.farItems, onRenderItem: (item) => react_1.default.createElement(menu_link_component_1.MenuLink, Object.assign({}, item)), onRenderOverflowButton: () => { return null; } }));
};
const MainMenu = () => {
    const styles = useStyles();
    const localize = smarthub_common_1.useLocalizeConfig();
    const menuLinks = use_menu_links_hook_1.useMenuLinks();
    const { mode } = smarthub_common_1.useViewConfig();
    const hasLinks = ((menuLinks === null || menuLinks === void 0 ? void 0 : menuLinks.farItems.length) + (menuLinks === null || menuLinks === void 0 ? void 0 : menuLinks.overflowItems.length)
        + (menuLinks === null || menuLinks === void 0 ? void 0 : menuLinks.primaryItems.length)) > 0;
    return react_1.useMemo(() => (hasLinks && mode == 'full'
        ? react_1.default.createElement("nav", { className: styles.menu, title: localize.navTitle },
            react_1.default.createElement("section", { className: styles.nav },
                react_1.default.createElement(react_2.ResizeGroup, { className: styles.resize, role: "tabpanel", "aria-label": "Primary navigation", direction: react_2.ResizeGroupDirection.vertical, data: menuLinks, onReduceData: onReduceData, onRenderData: (data) => onRenderOverflow(data, styles, localize) })))
        : react_1.default.createElement(react_1.default.Fragment, null)), [menuLinks, styles, localize]);
};
exports.MainMenu = MainMenu;


/***/ }),

/***/ "./src/components/main-menu/menu-link.component.tsx":
/*!**********************************************************!*\
  !*** ./src/components/main-menu/menu-link.component.tsx ***!
  \**********************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.MenuLink = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const react_2 = __webpack_require__(/*! @fluentui/react */ "@fluentui/react");
const fluentStyles = (({ theme: { palette, fonts, sizes, spacing } }) => ({
    root: {
        display: "block",
        boxSizing: "border-box",
        margin: 0,
        padding: 0,
        width: "100%",
        minWidth: 0,
        maxWidth: sizes.xxLarge,
        height: sizes.xLarge,
        border: `${spacing.tiny} solid transparent`,
        borderLeft: `${spacing.small} solid transparent`,
        backgroundColor: 'transparent',
        transitionTimingFunction: "ease-in",
        transitionDuration: "300ms",
        transitionProperty: "color, border-color, background-color",
    },
    rootHovered: {
        color: palette.filmOn,
        backgroundColor: palette.film,
    },
    rootPressed: {
        color: palette.filmOn,
        backgroundColor: palette.film,
    },
    rootFocused: {
        color: palette.filmOn,
        backgroundColor: palette.film,
        borderColor: palette.filmOn,
    },
    rootChecked: {
        color: palette.filmOn,
        backgroundColor: palette.film,
        borderLeftColor: palette.filmOn,
    },
    rootCheckedHovered: {
        color: palette.filmOn,
        backgroundColor: palette.film,
        borderColor: palette.filmOn,
    },
    rootCheckedPressed: {
        color: palette.filmOn,
        backgroundColor: palette.film,
        borderColor: palette.filmOn,
    },
    flexContainer: {
        width: "100%",
        flexDirection: "column",
        boxSizing: "border-box"
    },
    icon: Object.assign(Object.assign({}, fonts.xxLarge), { color: palette.primaryNavText, margin: `${spacing.medium} 0 0 -${spacing.small}`, width: "100%", height: sizes.small }),
    iconChecked: {
        color: palette.filmOn
    },
    label: Object.assign(Object.assign({}, fonts.tiny), { color: palette.primaryNavText, margin: `-${spacing.smallPlus} 0 0 -${spacing.smallPlus}`, height: sizes.smallPlus, lineHeight: sizes.smallPlus }),
    labelChecked: {
        color: palette.filmOn
    }
}));
const MenuLink = (_a) => {
    var { checked, data, onClick } = _a, rest = tslib_1.__rest(_a, ["checked", "data", "onClick"]);
    const styles = smarthub_common_1.useFluentStylesWithProps(fluentStyles);
    const registerLastFocus = smarthub_common_1.useRegisterLastAction();
    const buttonContent = react_1.useRef();
    const registerFocusCallback = react_1.useCallback(() => {
        registerLastFocus('main', () => {
            buttonContent.current.focus();
        });
    }, []);
    const handleClick = react_1.useCallback(() => {
        onClick(data);
        registerFocusCallback();
    }, [onClick, data]);
    return react_1.default.createElement(react_2.DefaultButton, Object.assign({ componentRef: buttonContent, checked: checked, styles: styles, onClick: handleClick }, rest));
};
exports.MenuLink = MenuLink;


/***/ }),

/***/ "./src/components/main-menu/menu-more-button.component.tsx":
/*!*****************************************************************!*\
  !*** ./src/components/main-menu/menu-more-button.component.tsx ***!
  \*****************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.MenuMoreButton = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importDefault(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const react_2 = __webpack_require__(/*! @fluentui/react */ "@fluentui/react");
const fluentStyles = (({ theme: { palette, fonts, sizes, spacing } }) => ({
    menu: {
        subComponentStyles: {
            callout: {},
            menuItem: ({ checked }) => ({
                label: {
                    fontWeight: checked && '600',
                    color: checked && palette.primary
                },
                icon: {
                    fontWeight: checked && '600',
                    color: checked && palette.primary
                }
            })
        }
    },
    more: {
        root: {
            display: "block",
            boxSizing: "border-box",
            margin: 0,
            padding: 0,
            width: "100%",
            minWidth: 0,
            maxWidth: sizes.xxLarge,
            height: sizes.xLarge,
            border: `${spacing.tiny} solid transparent`,
            borderLeft: `${spacing.small} solid transparent`,
            backgroundColor: 'transparent',
            transitionTimingFunction: "ease-in",
            transitionDuration: "300ms",
            transitionProperty: "color, border-color, background-color",
            "& .ms-Button-menuIcon": {
                color: palette.primaryNavText,
            }
        },
        rootHovered: {
            color: palette.filmOn,
            backgroundColor: palette.film,
            "& .ms-Button-menuIcon": {
                color: palette.filmOn,
            }
        },
        rootFocused: {
            color: palette.filmOn,
            backgroundColor: palette.film,
            borderColor: palette.filmOn,
            "& .ms-Button-menuIcon": {
                color: palette.filmOn,
            }
        },
        rootExpanded: {
            color: palette.filmOn,
            backgroundColor: palette.film,
            borderColor: palette.filmOn,
            "& .ms-Button-menuIcon": {
                color: palette.filmOn,
            }
        },
        rootExpandedHovered: {
            color: palette.filmOn,
            backgroundColor: palette.film,
            borderColor: palette.filmOn,
            "& .ms-Button-menuIcon": {
                color: palette.filmOn,
            }
        },
        rootPressed: {
            color: palette.filmOn,
            backgroundColor: palette.film,
            borderColor: palette.filmOn,
            "& .ms-Button-menuIcon": {
                color: palette.filmOn,
            }
        },
        flexContainer: {
            width: "100%",
            flexDirection: "column-reverse",
            boxSizing: "border-box"
        },
        menuIcon: Object.assign(Object.assign({}, fonts.xxLarge), { color: palette.primaryNavText, order: 1, margin: `${spacing.medium} 0 0 ${spacing.small}`, width: "100%", height: fonts.xxLarge.fontSize }),
        menuIconHovered: {
            color: palette.filmOn,
        },
        menuIconPressed: {
            color: palette.filmOn,
        },
        menuIconExpanded: {
            color: palette.filmOn,
        },
        menuIconExpandedHovered: {
            color: palette.filmOn,
        },
        label: Object.assign(Object.assign({}, fonts.tiny), { order: 2, color: palette.primaryNavText, margin: `-${spacing.smallPlus} 0 0 -${spacing.smallPlus}`, height: sizes.smallPlus, lineHeight: sizes.smallPlus }),
    }
}));
const MenuMoreButton = ({ items }) => {
    const styles = smarthub_common_1.useFluentStylesWithProps(fluentStyles);
    const localize = smarthub_common_1.useLocalizeConfig();
    return (react_1.default.createElement(react_2.CommandBarButton, { role: "menuitem", "aria-label": localize.panelMenuMoreLabel, title: localize.panelMenuMoreLabel, styles: styles.more, text: localize.panelMenuMoreText, menuIconProps: { iconName: 'More' }, menuProps: {
            styles: styles.menu,
            items: items
        } }));
};
exports.MenuMoreButton = MenuMoreButton;


/***/ }),

/***/ "./src/components/main-menu/use-action-links.hook.tsx":
/*!************************************************************!*\
  !*** ./src/components/main-menu/use-action-links.hook.tsx ***!
  \************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useActionLinks = void 0;
const react_1 = __webpack_require__(/*! react */ "react");
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const useActionLinks = () => {
    const actions = smarthub_common_1.useAppActions();
    const getThemeImage = smarthub_common_1.useGetThemeImageURI();
    const handleCommand = smarthub_common_1.useHandleCommand();
    return react_1.useMemo(() => actions
        .reduce((actions, appAction, idx) => {
        const { action, name, title, description, shortTitle, icon, position, coachmark } = appAction;
        actions[position !== null && position !== void 0 ? position : smarthub_common_1.AppActionPosition.farBefore].push({
            key: `${name}-${idx}`,
            text: shortTitle,
            iconProps: {
                iconName: typeof icon == 'string' ? icon : undefined,
                imageProps: icon && typeof icon == 'object'
                    ? {
                        src: getThemeImage(icon.image),
                        alt: typeof icon.image == 'object'
                            ? icon.image.text
                            : title
                    }
                    : undefined
            },
            ariaDescription: description,
            ariaLabel: title,
            title,
            coachmark: coachmark,
            onClick: () => handleCommand(action)
        });
        return actions;
    }, {
        [smarthub_common_1.AppActionPosition.farAfter]: [],
        [smarthub_common_1.AppActionPosition.farBefore]: [],
        [smarthub_common_1.AppActionPosition.moreAfter]: [],
        [smarthub_common_1.AppActionPosition.moreBefore]: [],
        [smarthub_common_1.AppActionPosition.nearAfter]: [],
        [smarthub_common_1.AppActionPosition.nearBefore]: [],
    }), [actions, getThemeImage]);
};
exports.useActionLinks = useActionLinks;


/***/ }),

/***/ "./src/components/main-menu/use-menu-links.hook.tsx":
/*!**********************************************************!*\
  !*** ./src/components/main-menu/use-menu-links.hook.tsx ***!
  \**********************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useMenuLinks = void 0;
const react_1 = __webpack_require__(/*! react */ "react");
const use_action_links_hook_1 = __webpack_require__(/*! ./use-action-links.hook */ "./src/components/main-menu/use-action-links.hook.tsx");
const use_panel_links_hook_1 = __webpack_require__(/*! ./use-panel-links.hook */ "./src/components/main-menu/use-panel-links.hook.tsx");
const useMenuLinks = () => {
    const panelLinks = use_panel_links_hook_1.usePanelLinks();
    const actionLinks = use_action_links_hook_1.useActionLinks();
    return react_1.useMemo(() => {
        const data = {
            primaryItems: [
                ...actionLinks.nearBefore,
                ...panelLinks.primary,
                ...actionLinks.nearAfter,
            ],
            farItems: [
                ...actionLinks.farBefore,
                ...panelLinks.secondary,
                ...actionLinks.farAfter
            ],
            overflowItems: [
                ...actionLinks.moreBefore,
                ...actionLinks.moreAfter,
            ]
        };
        return data;
    }, [panelLinks, actionLinks]);
};
exports.useMenuLinks = useMenuLinks;


/***/ }),

/***/ "./src/components/main-menu/use-panel-links.hook.tsx":
/*!***********************************************************!*\
  !*** ./src/components/main-menu/use-panel-links.hook.tsx ***!
  \***********************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.usePanelLinks = void 0;
const react_1 = __webpack_require__(/*! react */ "react");
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const build_panel_links_helper_1 = __webpack_require__(/*! ./build-panel-links.helper */ "./src/components/main-menu/build-panel-links.helper.tsx");
const usePanelLinks = () => {
    const panels = smarthub_common_1.usePanels();
    const setPanelId = smarthub_common_1.useSetPanelId();
    const current = smarthub_common_1.usePanelId();
    const setChatPanelView = smarthub_common_1.useSetPanelView();
    const chatPanelViewRef = smarthub_common_1.useHookRef(smarthub_common_1.usePanelView, 'chat');
    const pageViewRef = smarthub_common_1.useHookRef(smarthub_common_1.usePanelView, 'page');
    const setPage = smarthub_common_1.useSetPanelId('page');
    //TODO move to panelviewstate provider
    const selectPanel = react_1.useCallback((panel) => {
        if (chatPanelViewRef.current.visible && (chatPanelViewRef.current.size == 'full' || chatPanelViewRef.current.size == 'asside'))
            setChatPanelView(Object.assign(Object.assign({}, chatPanelViewRef.current), { visible: false }));
        if (pageViewRef.current.size == 'full')
            setPage();
        setPanelId(panel.$id);
    }, []);
    return react_1.useMemo(() => {
        const panelLinks = {
            primary: [],
            secondary: [],
        };
        return (panels === null || panels === void 0 ? void 0 : panels.length) ? build_panel_links_helper_1.buildPanelLinks(panels, panelLinks, selectPanel, current)
            : panelLinks;
    }, [panels, current]);
};
exports.usePanelLinks = usePanelLinks;


/***/ }),

/***/ "./src/components/panel-chrome/index.ts":
/*!**********************************************!*\
  !*** ./src/components/panel-chrome/index.ts ***!
  \**********************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./panel-chrome.component */ "./src/components/panel-chrome/panel-chrome.component.tsx"), exports);


/***/ }),

/***/ "./src/components/panel-chrome/panel-chrome.component.tsx":
/*!****************************************************************!*\
  !*** ./src/components/panel-chrome/panel-chrome.component.tsx ***!
  \****************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.PanelChrome = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const react_jss_1 = __webpack_require__(/*! react-jss */ "react-jss");
const context_1 = __webpack_require__(/*! ../context */ "./src/components/context/index.ts");
const focus_trap_1 = __webpack_require__(/*! ../focus-trap */ "./src/components/focus-trap/index.ts");
const panel_inner_component_1 = __webpack_require__(/*! ./panel-inner.component */ "./src/components/panel-chrome/panel-inner.component.tsx");
const region_1 = __webpack_require__(/*! ../region */ "./src/components/region/index.ts");
const useStyles = react_jss_1.createUseStyles((theme) => {
    var _a, _b;
    const { palette, spacing, styles } = theme;
    const panel = (_b = (_a = styles === null || styles === void 0 ? void 0 : styles.panel) === null || _a === void 0 ? void 0 : _a.chrome) !== null && _b !== void 0 ? _b : {};
    const props = { theme };
    return {
        root: ({ config: { type }, }) => (Object.assign({ display: "flex", flexDirection: "column", justifyContent: "center", boxSizing: "border-box", transition: "top 200ms ease-in-out", height: "100vh", width: "100%", zIndex: 2, backgroundColor: type == "page"
                ? palette.neutralEmpty
                : type == "chat"
                    ? palette.neutralMinus3
                    : palette.neutralMinus5, color: type == "page"
                ? palette.neutralEmptyOn
                : type == "chat"
                    ? palette.neutralMinus3On
                    : palette.neutralMinus5On, boxShadow: `0 0 ${spacing.normal} ${palette.filmMinus1}`, "& *": {
                overscrollBehavior: "auto",
            }, "& *::-webkit-scrollbar-track": {
                borderRadius: spacing.xSmall,
                background: "transparent",
                border: "0",
            }, "& *::-webkit-scrollbar": {
                width: spacing.medium,
                height: spacing.medium,
                border: "0",
            }, "& *:hover::-webkit-scrollbar": {
                width: spacing.medium,
                height: spacing.medium,
            }, "& *::-webkit-scrollbar-thumb": {
                background: palette.primary,
                borderRadius: spacing.xSmall,
                border: "0",
            } }, smarthub_common_1.themeStyle(panel.root, props))),
        right: {
            alignSelf: "flex-end",
        },
        left: {
            alignSelf: "flex-start",
        },
        docked: ({ config: { size }, responsive, }) => (Object.assign({ transition: "width 200ms ease-in-out", width: smarthub_common_1.responsiveColumnWidths[responsive[size]] }, smarthub_common_1.themeStyle(panel.docked, { config: { size }, responsive, theme }))),
        full: ({ config: { size }, responsive, }) => (Object.assign(Object.assign({ left: 0, top: 0, right: 0, bottom: 0, display: "flex", position: responsive.overlay === false ? "relative" : "absolute", flex: responsive.overlay === false ? "1 1" : undefined }, smarthub_common_1.themeStyle(panel.full, { config: { size }, responsive, theme })), { ["& $inner"]: Object.assign({ width: responsive.overlay === false
                    ? "100%"
                    : smarthub_common_1.responsiveColumnWidths[responsive[size]] }, smarthub_common_1.themeStyle(panel.fullFrame, { config: { size }, responsive, theme })), ["& $overlay"]: Object.assign({ transition: "top 200ms ease-in-out", position: "absolute", left: 0, width: "100%", height: "100%", top: 0, backgroundColor: palette.neutralMinus5 }, smarthub_common_1.themeStyle(panel.fullOverlay, {
                config: { size },
                responsive,
                theme,
            })) })),
        overlay: Object.assign({}, smarthub_common_1.themeStyle(panel.overlay, props)),
        inner: Object.assign({ overflow: "hidden", display: "flex", flexDirection: "column", flex: "1 1", width: "100%", height: "100%" }, smarthub_common_1.themeStyle(panel.inner, props)),
        "@supports (-webkit-touch-callout: none)": {
            root: ({ config: { type }, }) => ({
                height: "86vh",
            }),
        },
    };
});
const PanelChrome = () => {
    var _a, _b;
    const { panel, type, panel: { title, initialFocus }, regions, regions: { menu, launcher, pages }, } = smarthub_common_1.usePanelViewContext();
    const entity = smarthub_common_1.usePanelEntity(type);
    const localise = smarthub_common_1.useLocalizeConfig();
    const endText = localise[`${type}EndText`];
    const startText = localise[`${type}StartText`];
    const endLabel = localise[`${type}EndLabel`];
    const startLabel = localise[`${type}StartLabel`];
    const panelLabel = localise[`${type}PanelLabel`];
    const viewConfig = smarthub_common_1.useViewConfig();
    const { dockSizes, trapFocus } = viewConfig[type];
    const viewState = smarthub_common_1.usePanelView();
    const [dockPostion] = smarthub_common_1.usePreference(smarthub_common_1.preferenceKeys.chatDockPosition, false);
    const { chat: { dockPositions: { preferred: position }, }, } = smarthub_common_1.useViewConfig();
    const preferredPosition = react_1.useMemo(() => {
        if (dockPostion) {
            return dockPostion;
        }
        return position;
    }, [dockPostion, position]);
    const gridStyles = smarthub_common_1.useGridStyles();
    const styleConfig = react_1.useMemo(() => (Object.assign(Object.assign({}, viewState), { type })), [viewState, type]);
    const styleProps = smarthub_common_1.useStyleProps(styleConfig, (_b = (_a = panel === null || panel === void 0 ? void 0 : panel.dock) === null || _a === void 0 ? void 0 : _a.options) !== null && _b !== void 0 ? _b : dockSizes);
    const styles = useStyles(styleProps);
    const panelStyles = smarthub_common_1.usePanelStyles();
    const resetFocus = `${panel.$id}${entity === null || entity === void 0 ? void 0 : entity.$entityId}`;
    const resetPanelId = smarthub_common_1.useResetPanelId(type);
    const focusLastAction = smarthub_common_1.useFocusLastAction();
    const onClose = react_1.useCallback(() => {
        resetPanelId();
        focusLastAction(type);
    }, [type]);
    return react_1.useMemo(() => {
        var _a;
        return (react_1.default.createElement(focus_trap_1.FocusTrap, Object.assign({}, {
            as: "article",
            name: `${type}-panel`,
            endLabel,
            endText,
            startLabel,
            startText,
            trapFocus,
            initialFocus,
            resetFocus,
            onClose,
        }, { className: [
                styles.root,
                viewState.size == "full" ? styles.full : styles.docked,
            ].join(" "), "aria-label": `${panelLabel}, ${title}${((_a = entity === null || entity === void 0 ? void 0 : entity.title) === null || _a === void 0 ? void 0 : _a.length) ? `, ${entity.title}` : ""}` }),
            launcher && react_1.default.createElement(region_1.Region, { layout: launcher }),
            pages && react_1.default.createElement(region_1.Region, { layout: pages }),
            react_1.default.createElement("div", { className: styles.overlay }),
            menu && (react_1.default.createElement("nav", null,
                react_1.default.createElement(region_1.Region, { layout: menu }))),
            react_1.default.createElement(context_1.BreakpointProvider, { className: [
                    styles.inner,
                    preferredPosition == "right" ? styles.right : styles.left,
                ].join(" ") },
                react_1.default.createElement(panel_inner_component_1.PanelInner, { regions: regions, resetScroll: resetFocus }))));
    }, [gridStyles, styles, panelStyles, regions, viewState, resetFocus, onClose]);
};
exports.PanelChrome = PanelChrome;


/***/ }),

/***/ "./src/components/panel-chrome/panel-inner.component.tsx":
/*!***************************************************************!*\
  !*** ./src/components/panel-chrome/panel-inner.component.tsx ***!
  \***************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.PanelInner = exports.useStyles = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const region_1 = __webpack_require__(/*! ../region */ "./src/components/region/index.ts");
const react_jss_1 = __webpack_require__(/*! react-jss */ "react-jss");
exports.useStyles = react_jss_1.createUseStyles((theme) => {
    var _a, _b, _c;
    const panel = (_c = (_b = (_a = theme.styles) === null || _a === void 0 ? void 0 : _a.panel) === null || _b === void 0 ? void 0 : _b.chrome) !== null && _c !== void 0 ? _c : {};
    const props = { theme };
    return {
        sidebar: ({ responsive: { overlay } }) => (Object.assign({ position: overlay ? "absolute" : "relative", height: "100%" }, smarthub_common_1.themeStyle(panel.sidebar, props))),
        header: smarthub_common_1.themeStyle(panel.header, props),
        bodyWrapper: {
            display: "flex",
            flex: "1",
            fontSize: "16px",
            overflow: "hidden",
            position: "relative",
            "& p": {
                fontSize: "16px",
                lineHeight: "1.5em",
                color: "inherit !important",
                fontFamily: `Calibri, "Helvetica Neue", Arial, "sans-serif"`,
            },
            "& .webchat__bubble__content > p": {
                padding: "10px !important",
                margin: "0px !important",
            },
            "& img": {
                display: "inherit !important",
            },
        },
        body: Object.assign({ flex: "1 1" }, smarthub_common_1.themeStyle(panel.body, props)),
        menu: Object.assign({ flex: "1 0 100%", width: "100%" }, smarthub_common_1.themeStyle(panel.menu, props)),
        footer: smarthub_common_1.themeStyle(panel.footer, props),
    };
});
const responsive = {
    sm: { overlay: true },
    lg: { overlay: false },
};
const PanelInner = ({ regions, resetScroll }) => {
    const { body, footer, header, sidebar, splash } = regions;
    const gridStyles = smarthub_common_1.useGridStyles();
    const styleProps = smarthub_common_1.useStyleProps(null, responsive);
    const styles = exports.useStyles(styleProps);
    const panelStyles = smarthub_common_1.usePanelStyles();
    return react_1.useMemo(() => (react_1.default.createElement("div", { className: [gridStyles.grid, gridStyles.row, gridStyles.smstretch].join(" ") },
        sidebar && (react_1.default.createElement("aside", { className: [
                gridStyles.col,
                gridStyles.smmax12,
                gridStyles.lgmax6,
                gridStyles.lgxmax4,
                gridStyles.xlmax3,
                gridStyles.xlxmax2,
                styles.sidebar,
            ].join(" ") },
            react_1.default.createElement(region_1.Region, { layout: sidebar }))),
        react_1.default.createElement("div", { className: [
                gridStyles.col,
                gridStyles.sm12,
                gridStyles.lg6,
                gridStyles.lgx8,
                gridStyles.xl9,
                gridStyles.xlx10,
                gridStyles.smclip,
                gridStyles.smfill,
                panelStyles.body,
            ].join(" ") },
            header && (react_1.default.createElement("div", null,
                react_1.default.createElement(region_1.Region, { layout: header }))),
            body && (react_1.default.createElement("div", { className: styles.bodyWrapper },
                splash && react_1.default.createElement(region_1.Region, { layout: splash }),
                react_1.default.createElement(region_1.Region, { as: "section", layout: body, className: styles.body, resetScroll: resetScroll }))),
            footer && (react_1.default.createElement("footer", null,
                react_1.default.createElement(region_1.Region, { layout: footer })))))), [
        gridStyles,
        styles,
        panelStyles,
        body,
        footer,
        header,
        sidebar,
        resetScroll,
    ]);
};
exports.PanelInner = PanelInner;


/***/ }),

/***/ "./src/components/panel/index.ts":
/*!***************************************!*\
  !*** ./src/components/panel/index.ts ***!
  \***************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./panel.component */ "./src/components/panel/panel.component.tsx"), exports);


/***/ }),

/***/ "./src/components/panel/panel.component.tsx":
/*!**************************************************!*\
  !*** ./src/components/panel/panel.component.tsx ***!
  \**************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Panel = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importDefault(__webpack_require__(/*! react */ "react"));
const context_1 = __webpack_require__(/*! ../context */ "./src/components/context/index.ts");
const panel_chrome_1 = __webpack_require__(/*! ../panel-chrome */ "./src/components/panel-chrome/index.ts");
const Panel = ({ type }) => {
    return (react_1.default.createElement(context_1.PanelViewProvider, { type: type },
        react_1.default.createElement(panel_chrome_1.PanelChrome, null)));
};
exports.Panel = Panel;


/***/ }),

/***/ "./src/components/region/index.ts":
/*!****************************************!*\
  !*** ./src/components/region/index.ts ***!
  \****************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./region.component */ "./src/components/region/region.component.tsx"), exports);


/***/ }),

/***/ "./src/components/region/region.component.tsx":
/*!****************************************************!*\
  !*** ./src/components/region/region.component.tsx ***!
  \****************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Region = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const grid_1 = __webpack_require__(/*! ../grid */ "./src/components/grid/index.ts");
const Region = (_a) => {
    var { layout, fallback, resetScroll } = _a, props = tslib_1.__rest(_a, ["layout", "fallback", "resetScroll"]);
    const render = smarthub_common_1.useRender();
    const isComponent = layout.hasOwnProperty('template')
        || layout.$schema == smarthub_common_1.IComponentSchema;
    return react_1.useMemo(() => isComponent
        ? render(layout, null, fallback)()
        : react_1.default.createElement(grid_1.Grid, Object.assign({ layout: layout, resetScroll: resetScroll }, props)), [layout, isComponent, fallback, resetScroll]);
};
exports.Region = Region;


/***/ }),

/***/ "./src/components/skip-links/index.ts":
/*!********************************************!*\
  !*** ./src/components/skip-links/index.ts ***!
  \********************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./skip-links.component */ "./src/components/skip-links/skip-links.component.tsx"), exports);


/***/ }),

/***/ "./src/components/skip-links/skip-links.component.tsx":
/*!************************************************************!*\
  !*** ./src/components/skip-links/skip-links.component.tsx ***!
  \************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.SkipLinks = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const react_2 = __webpack_require__(/*! @fluentui/react */ "@fluentui/react");
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const react_jss_1 = __webpack_require__(/*! react-jss */ "react-jss");
const useStyles = react_jss_1.createUseStyles(({ sizes }) => ({
    root: {
        position: "absolute",
        top: `-${sizes.mediumPlus}`,
        height: `${sizes.mediumPlus}`,
        width: "100%",
        zIndex: 1,
        transition: "top ease-out 300ms",
        "&:focus-within": {
            top: 0
        }
    }
}));
const SkipLinks = () => {
    const styles = useStyles();
    const focus = smarthub_common_1.useFocus();
    const localize = smarthub_common_1.useLocalizeConfig();
    return react_1.useMemo(() => (react_1.default.createElement("div", { className: styles.root },
        react_1.default.createElement(react_2.CommandBar, { items: [{
                    key: 'main-panel',
                    ariaLabel: localize.skipToMain,
                    title: localize.skipToMain,
                    text: localize.skipToMain,
                    onClick: () => { focus('main-panel'); }
                }, {
                    key: 'chat-controls',
                    ariaLabel: localize.skipToChat,
                    title: localize.skipToChat,
                    text: localize.skipToChat,
                    onClick: () => { focus('chat-controls'); }
                }] }))), []);
};
exports.SkipLinks = SkipLinks;


/***/ }),

/***/ "./src/components/tpc-message/index.ts":
/*!*********************************************!*\
  !*** ./src/components/tpc-message/index.ts ***!
  \*********************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./tpc-message.component */ "./src/components/tpc-message/tpc-message.component.tsx"), exports);


/***/ }),

/***/ "./src/components/tpc-message/tpc-message.component.tsx":
/*!**************************************************************!*\
  !*** ./src/components/tpc-message/tpc-message.component.tsx ***!
  \**************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.TPCMessage = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const react_2 = __webpack_require__(/*! @fluentui/react */ "@fluentui/react");
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const cacheKey = 'tpc';
const cacheOptions = {
    storage: 'session'
};
const modalProps = {
    isBlocking: false,
    styles: { main: { maxWidth: 550 } },
};
const TPCMessage = ({ children }) => {
    const { enabled, checked, level, infoUri } = smarthub_common_1.useTPCCheck();
    const allowUI = level == 'none'
        || (checked && level == 'info');
    const { mode } = smarthub_common_1.useViewConfig();
    const { tpcMessage: strings } = smarthub_common_1.useLocalizeConfig();
    const { okText, okTitle, okLabel, closeText, closeTitle, closeLabel, infoText, infoTitle, infoLabel, title, subText: subTextTypes } = strings[mode];
    const subText = subTextTypes[level];
    const [dismissed, setDismissed] = react_1.useState(true);
    react_1.useEffect(() => {
        const hasDismissed = level == 'none'
            || (checked && enabled)
            || (level == 'info'
                && smarthub_common_1.Cache.get(cacheKey, cacheOptions));
        setDismissed(hasDismissed);
    }, [enabled, checked]);
    const toggle = react_1.useCallback(() => {
        if (level == 'info')
            smarthub_common_1.Cache.set(cacheKey, true, cacheOptions);
        setDismissed(true);
    }, [level]);
    const dialogContentProps = {
        type: react_2.DialogType.largeHeader,
        title,
        subText
    };
    return react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_2.Dialog, { hidden: dismissed, onDismiss: toggle, dialogContentProps: dialogContentProps, modalProps: modalProps },
            react_1.default.createElement(react_2.DialogFooter, null,
                allowUI
                    ? react_1.default.createElement(react_2.PrimaryButton, { onClick: toggle, text: okText, title: okTitle, ariaLabel: okLabel })
                    : react_1.default.createElement(react_2.PrimaryButton, { onClick: toggle, title: closeTitle, text: closeText, ariaLabel: closeLabel }),
                (infoUri === null || infoUri === void 0 ? void 0 : infoUri.length) > 0 && react_1.default.createElement(react_2.DefaultButton, { text: infoText, title: infoTitle, href: infoUri, ariaLabel: infoLabel }))),
        allowUI && children);
};
exports.TPCMessage = TPCMessage;


/***/ }),

/***/ "./src/index.ts":
/*!**********************!*\
  !*** ./src/index.ts ***!
  \**********************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./components */ "./src/components/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./middleware */ "./src/middleware/index.ts"), exports);


/***/ }),

/***/ "./src/middleware/bot/action-collection.middleware.ts":
/*!************************************************************!*\
  !*** ./src/middleware/bot/action-collection.middleware.ts ***!
  \************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ActionCollection = void 0;
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
class ActionCollection extends smarthub_common_1.BaseMiddlewareCollection {
    constructor() {
        super();
    }
    testFallback(config, info) {
        return info.cardAction.type == config.id;
    }
}
exports.ActionCollection = ActionCollection;


/***/ }),

/***/ "./src/middleware/bot/activity-collection.middleware.ts":
/*!**************************************************************!*\
  !*** ./src/middleware/bot/activity-collection.middleware.ts ***!
  \**************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ActivityCollection = void 0;
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
class ActivityCollection extends smarthub_common_1.BaseMiddlewareCollection {
    constructor() {
        super();
    }
    testFallback(config, info) {
        return info.activity.type == config.id;
    }
}
exports.ActivityCollection = ActivityCollection;


/***/ }),

/***/ "./src/middleware/bot/attachment-collection.middleware.ts":
/*!****************************************************************!*\
  !*** ./src/middleware/bot/attachment-collection.middleware.ts ***!
  \****************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.AttachmentCollection = void 0;
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
class AttachmentCollection extends smarthub_common_1.BaseMiddlewareCollection {
    constructor() {
        super();
    }
    testFallback(config, info) {
        return info.attachment.contentType == config.id;
    }
}
exports.AttachmentCollection = AttachmentCollection;


/***/ }),

/***/ "./src/middleware/bot/components/handle-any.fn.tsx":
/*!*********************************************************!*\
  !*** ./src/middleware/bot/components/handle-any.fn.tsx ***!
  \*********************************************************/
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.handleAny = void 0;
const handleAny = ({ focus }, info) => {
    focus('chat-controls');
    return false;
};
exports.handleAny = handleAny;


/***/ }),

/***/ "./src/middleware/bot/components/handle-open-url.fn.tsx":
/*!**************************************************************!*\
  !*** ./src/middleware/bot/components/handle-open-url.fn.tsx ***!
  \**************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.handleOpenUrl = void 0;
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const handleOpenUrl = ({ handleCommand, focus }, { cardAction }) => {
    const { value } = cardAction;
    //const redirectorLink = value.match(/^https?:\/\/(?<domain>[a-zA-Z0-9\.\-]*)\/concierge\/linkredirector\.ashx\?FLEX_RESULT_URL=(?<url>[a-zA-Z0-9\.\-\%\_]*)&FLEX_RESULT_ID\=(?<id>[a-zA-Z0-9\-]*)$/)
    handleCommand({
        $id: "",
        $schema: smarthub_common_1.RouteActionSchema,
        uri: value,
    });
    focus("chat-controls");
    return true;
};
exports.handleOpenUrl = handleOpenUrl;


/***/ }),

/***/ "./src/middleware/bot/components/handle-sign-in.fn.tsx":
/*!*************************************************************!*\
  !*** ./src/middleware/bot/components/handle-sign-in.fn.tsx ***!
  \*************************************************************/
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.handleSignIn = void 0;
const attempts = [];
//TODO replace this with an action
const handleSignIn = ({ focus, localizeConfig }, { cardAction }) => {
    const { value } = cardAction;
    const repeat = attempts.indexOf(value) > -1;
    focus('chat-controls');
    if (!repeat)
        attempts.push(value);
    else
        alert(localizeConfig.chatSigningInMessage);
    return repeat;
};
exports.handleSignIn = handleSignIn;


/***/ }),

/***/ "./src/middleware/bot/components/index.ts":
/*!************************************************!*\
  !*** ./src/middleware/bot/components/index.ts ***!
  \************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.handleAny = exports.handleSignIn = exports.handleOpenUrl = void 0;
var handle_open_url_fn_1 = __webpack_require__(/*! ./handle-open-url.fn */ "./src/middleware/bot/components/handle-open-url.fn.tsx");
Object.defineProperty(exports, "handleOpenUrl", ({ enumerable: true, get: function () { return handle_open_url_fn_1.handleOpenUrl; } }));
var handle_sign_in_fn_1 = __webpack_require__(/*! ./handle-sign-in.fn */ "./src/middleware/bot/components/handle-sign-in.fn.tsx");
Object.defineProperty(exports, "handleSignIn", ({ enumerable: true, get: function () { return handle_sign_in_fn_1.handleSignIn; } }));
var handle_any_fn_1 = __webpack_require__(/*! ./handle-any.fn */ "./src/middleware/bot/components/handle-any.fn.tsx");
Object.defineProperty(exports, "handleAny", ({ enumerable: true, get: function () { return handle_any_fn_1.handleAny; } }));


/***/ }),

/***/ "./src/middleware/bot/core-actionmiddleware.fn.ts":
/*!********************************************************!*\
  !*** ./src/middleware/bot/core-actionmiddleware.fn.ts ***!
  \********************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.coreActionMiddleware = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const components_1 = __webpack_require__(/*! ./components */ "./src/middleware/bot/components/index.ts");
const coreActionMiddleware = (props) => () => next => (actionInfo) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
    const { cardAction: { type } } = actionInfo;
    const handled = type == 'openUrl'
        ? components_1.handleOpenUrl(props, actionInfo)
        : type == 'signin'
            ? components_1.handleSignIn(props, actionInfo)
            : components_1.handleAny(props, actionInfo);
    if (!handled)
        return next(actionInfo);
});
exports.coreActionMiddleware = coreActionMiddleware;


/***/ }),

/***/ "./src/middleware/bot/create-action-middleware.fn.ts":
/*!***********************************************************!*\
  !*** ./src/middleware/bot/create-action-middleware.fn.ts ***!
  \***********************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.createActionMiddleware = void 0;
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const createActionMiddleware = (coreMiddleware, additionalMiddleware) => {
    return (props) => smarthub_common_1.concatMiddleware(additionalMiddleware, coreMiddleware(props));
};
exports.createActionMiddleware = createActionMiddleware;


/***/ }),

/***/ "./src/middleware/bot/create-activity-middleware.fn.ts":
/*!*************************************************************!*\
  !*** ./src/middleware/bot/create-activity-middleware.fn.ts ***!
  \*************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.createActivityMiddleware = void 0;
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const createActivityMiddleware = (coreMiddleware, additionalMiddleware) => {
    return (props) => smarthub_common_1.concatMiddleware(additionalMiddleware, coreMiddleware(props));
};
exports.createActivityMiddleware = createActivityMiddleware;


/***/ }),

/***/ "./src/middleware/bot/create-attachment-middleware.fn.ts":
/*!***************************************************************!*\
  !*** ./src/middleware/bot/create-attachment-middleware.fn.ts ***!
  \***************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.createAttachmentMiddleware = void 0;
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const createAttachmentMiddleware = (coreMiddleware, additionalMiddleware) => {
    return (props) => smarthub_common_1.concatMiddleware(additionalMiddleware, coreMiddleware(props));
};
exports.createAttachmentMiddleware = createAttachmentMiddleware;


/***/ }),

/***/ "./src/middleware/bot/index.ts":
/*!*************************************!*\
  !*** ./src/middleware/bot/index.ts ***!
  \*************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./components */ "./src/middleware/bot/components/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./action-collection.middleware */ "./src/middleware/bot/action-collection.middleware.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./activity-collection.middleware */ "./src/middleware/bot/activity-collection.middleware.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./attachment-collection.middleware */ "./src/middleware/bot/attachment-collection.middleware.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./core-actionmiddleware.fn */ "./src/middleware/bot/core-actionmiddleware.fn.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./create-action-middleware.fn */ "./src/middleware/bot/create-action-middleware.fn.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./create-activity-middleware.fn */ "./src/middleware/bot/create-activity-middleware.fn.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./create-attachment-middleware.fn */ "./src/middleware/bot/create-attachment-middleware.fn.ts"), exports);


/***/ }),

/***/ "./src/middleware/fetch/components/fetch-concat.fn.ts":
/*!************************************************************!*\
  !*** ./src/middleware/fetch/components/fetch-concat.fn.ts ***!
  \************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.fetchConcat = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const helpers_1 = __webpack_require__(/*! ../helpers */ "./src/middleware/fetch/helpers/index.ts");
const fetchConcat = (info) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
    const { query } = info;
    const results = yield helpers_1.fetchGroupResults(query, info);
    return results.reduce((result, { id, data, continuation }) => {
        var _a;
        return ({
            id: query.id,
            data: [
                ...(_a = result === null || result === void 0 ? void 0 : result.data) !== null && _a !== void 0 ? _a : [],
                ...(data
                    ? Array.isArray(data)
                        ? data
                        : [data]
                    : [])
            ],
            continuation: (result === null || result === void 0 ? void 0 : result.continuation) || continuation
                ? Object.assign(Object.assign({}, result === null || result === void 0 ? void 0 : result.continuation), (continuation !== null && continuation !== void 0 ? continuation : { [id]: continuation })) : null
        });
    }, null);
});
exports.fetchConcat = fetchConcat;


/***/ }),

/***/ "./src/middleware/fetch/components/fetch-group.fn.ts":
/*!***********************************************************!*\
  !*** ./src/middleware/fetch/components/fetch-group.fn.ts ***!
  \***********************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.fetchGroup = exports.IGroupQuerySchema = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const helpers_1 = __webpack_require__(/*! ../helpers */ "./src/middleware/fetch/helpers/index.ts");
exports.IGroupQuerySchema = "https://ics.ai/smarthub/query/group";
const fetchGroup = (info) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
    const { query } = info;
    const results = yield helpers_1.fetchGroupResults(query, info);
    return results.reduce((result, { id, data, continuation }) => {
        var _a, _b;
        return ({
            id: query.id,
            data: Object.assign(Object.assign({ $schema: (_a = query.schema) !== null && _a !== void 0 ? _a : exports.IGroupQuerySchema, $id: query.id }, (_b = result === null || result === void 0 ? void 0 : result.data) !== null && _b !== void 0 ? _b : {}), (data ? { [id]: data } : {})),
            continuation: (result === null || result === void 0 ? void 0 : result.continuation) || continuation
                ? Object.assign(Object.assign({}, result === null || result === void 0 ? void 0 : result.continuation), (continuation !== null && continuation !== void 0 ? continuation : { [id]: continuation })) : null
        });
    }, null);
});
exports.fetchGroup = fetchGroup;


/***/ }),

/***/ "./src/middleware/fetch/components/fetch-items.fn.ts":
/*!***********************************************************!*\
  !*** ./src/middleware/fetch/components/fetch-items.fn.ts ***!
  \***********************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.fetchItems = void 0;
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const fetchItems = (info) => {
    var _a, _b;
    const { query, context, providers } = info;
    const provider = ((_a = query.provider) === null || _a === void 0 ? void 0 : _a.length) > 0
        ? providers.find(p => p.name == query.provider)
        : null;
    if (provider)
        return (context === null || context === void 0 ? void 0 : context.body) || ((_b = query.request) === null || _b === void 0 ? void 0 : _b.body)
            ? provider.submit(query, context)
            : provider.query(query, context);
    else
        smarthub_common_1.Logger.warn(`Provider ${query.provider} for query not found`, info);
    return Promise.reject();
};
exports.fetchItems = fetchItems;


/***/ }),

/***/ "./src/middleware/fetch/components/fetch-list.fn.ts":
/*!**********************************************************!*\
  !*** ./src/middleware/fetch/components/fetch-list.fn.ts ***!
  \**********************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.fetchList = exports.IListQuerySchema = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const helpers_1 = __webpack_require__(/*! ../helpers */ "./src/middleware/fetch/helpers/index.ts");
exports.IListQuerySchema = "https://ics.ai/smarthub/query/list";
const fetchList = (info) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
    const { query } = info;
    const results = yield helpers_1.fetchGroupResults(query, info);
    return results.reduce((result, { id, data, continuation }) => {
        var _a, _b;
        return ({
            id: query.id,
            data: [
                ...(_a = result === null || result === void 0 ? void 0 : result.data) !== null && _a !== void 0 ? _a : [],
                {
                    $schema: (_b = query.schema) !== null && _b !== void 0 ? _b : exports.IListQuerySchema,
                    $id: id,
                    data
                }
            ],
            continuation: (result === null || result === void 0 ? void 0 : result.continuation) || continuation
                ? Object.assign(Object.assign({}, result === null || result === void 0 ? void 0 : result.continuation), (continuation !== null && continuation !== void 0 ? continuation : { [id]: continuation })) : null
        });
    }, null);
});
exports.fetchList = fetchList;


/***/ }),

/***/ "./src/middleware/fetch/components/index.ts":
/*!**************************************************!*\
  !*** ./src/middleware/fetch/components/index.ts ***!
  \**************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./fetch-concat.fn */ "./src/middleware/fetch/components/fetch-concat.fn.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./fetch-group.fn */ "./src/middleware/fetch/components/fetch-group.fn.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./fetch-items.fn */ "./src/middleware/fetch/components/fetch-items.fn.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./fetch-list.fn */ "./src/middleware/fetch/components/fetch-list.fn.ts"), exports);


/***/ }),

/***/ "./src/middleware/fetch/core-fetch-middleware.fn.ts":
/*!**********************************************************!*\
  !*** ./src/middleware/fetch/core-fetch-middleware.fn.ts ***!
  \**********************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.coreFetchMiddleware = void 0;
const components_1 = __webpack_require__(/*! ./components */ "./src/middleware/fetch/components/index.ts");
const coreFetchMiddleware = () => next => (info) => {
    if (info.query.hasOwnProperty("queries")) {
        const { action } = info.query;
        switch (action) {
            case 'group': return components_1.fetchGroup(info);
            case 'list': return components_1.fetchList(info);
            default: return components_1.fetchConcat(info);
        }
    }
    else
        return components_1.fetchItems(info);
};
exports.coreFetchMiddleware = coreFetchMiddleware;


/***/ }),

/***/ "./src/middleware/fetch/create-fetch-middleware.fn.ts":
/*!************************************************************!*\
  !*** ./src/middleware/fetch/create-fetch-middleware.fn.ts ***!
  \************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.createFetchMiddleware = void 0;
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const createFetchMiddleware = (coreMiddleware, additionalMiddleware) => {
    const middleware = smarthub_common_1.concatMiddleware(additionalMiddleware, coreMiddleware)({});
    //TODO redability
    return (...args) => {
        try {
            return middleware((obj) => {
                smarthub_common_1.Logger.error("[createMiddleware] fetch not found", false, { args: args, obj: obj });
                return obj;
            })(...args);
        }
        catch (err) {
            return JSON.stringify(err, null, 2);
        }
    };
};
exports.createFetchMiddleware = createFetchMiddleware;


/***/ }),

/***/ "./src/middleware/fetch/fetch-collection.middleware.ts":
/*!*************************************************************!*\
  !*** ./src/middleware/fetch/fetch-collection.middleware.ts ***!
  \*************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.FetchCollection = void 0;
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
class FetchCollection extends smarthub_common_1.BaseMiddlewareCollection {
    constructor() {
        super();
    }
    testFallback(config, info) {
        return info.query.id == config.id;
    }
}
exports.FetchCollection = FetchCollection;


/***/ }),

/***/ "./src/middleware/fetch/helpers/fetch-group-results.helper.ts":
/*!********************************************************************!*\
  !*** ./src/middleware/fetch/helpers/fetch-group-results.helper.ts ***!
  \********************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.fetchGroupResults = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const fetchGroupResults = (group, { context, providers, fetch }) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
    const infos = group.queries.reduce((collection, query) => {
        const continuation = context.continuation
            ? context.continuation[query.id]
            : null;
        if (!context.continuation || continuation)
            collection.push({
                context: Object.assign(Object.assign({}, context), { continuation: continuation }),
                query,
                providers,
                fetch
            });
        return collection;
    }, []);
    return yield Promise.all(infos.map(info => fetch(info)));
});
exports.fetchGroupResults = fetchGroupResults;


/***/ }),

/***/ "./src/middleware/fetch/helpers/index.ts":
/*!***********************************************!*\
  !*** ./src/middleware/fetch/helpers/index.ts ***!
  \***********************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./fetch-group-results.helper */ "./src/middleware/fetch/helpers/fetch-group-results.helper.ts"), exports);


/***/ }),

/***/ "./src/middleware/fetch/index.ts":
/*!***************************************!*\
  !*** ./src/middleware/fetch/index.ts ***!
  \***************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./components */ "./src/middleware/fetch/components/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./helpers */ "./src/middleware/fetch/helpers/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./core-fetch-middleware.fn */ "./src/middleware/fetch/core-fetch-middleware.fn.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./create-fetch-middleware.fn */ "./src/middleware/fetch/create-fetch-middleware.fn.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./fetch-collection.middleware */ "./src/middleware/fetch/fetch-collection.middleware.ts"), exports);


/***/ }),

/***/ "./src/middleware/index.ts":
/*!*********************************!*\
  !*** ./src/middleware/index.ts ***!
  \*********************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./fetch */ "./src/middleware/fetch/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./render */ "./src/middleware/render/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./bot */ "./src/middleware/bot/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./transform */ "./src/middleware/transform/index.ts"), exports);


/***/ }),

/***/ "./src/middleware/render/create-render-middleware.fn.tsx":
/*!***************************************************************!*\
  !*** ./src/middleware/render/create-render-middleware.fn.tsx ***!
  \***************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.createRenderMiddleware = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importDefault(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const createRenderMiddleware = (coreMiddleware, additionalMiddleware) => {
    const middleware = smarthub_common_1.concatMiddleware(additionalMiddleware, coreMiddleware)({});
    return (...args) => {
        try {
            return middleware(({ component, options, FallBack }) => (children) => {
                return FallBack
                    ? react_1.default.createElement(FallBack, { config: component, data: options }, children)
                    : react_1.default.createElement("div", null,
                        react_1.default.createElement("p", null, "No renderer for this component"),
                        react_1.default.createElement("pre", null, JSON.stringify({ component, options }, null, 2)));
            })(...args);
        }
        catch (err) {
            return () => (react_1.default.createElement("div", null,
                react_1.default.createElement("p", null, "Failed to render component"),
                react_1.default.createElement("pre", null, JSON.stringify(err, null, 2))));
        }
    };
};
exports.createRenderMiddleware = createRenderMiddleware;


/***/ }),

/***/ "./src/middleware/render/index.ts":
/*!****************************************!*\
  !*** ./src/middleware/render/index.ts ***!
  \****************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./create-render-middleware.fn */ "./src/middleware/render/create-render-middleware.fn.tsx"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./render-collection.middleware */ "./src/middleware/render/render-collection.middleware.ts"), exports);


/***/ }),

/***/ "./src/middleware/render/render-collection.middleware.ts":
/*!***************************************************************!*\
  !*** ./src/middleware/render/render-collection.middleware.ts ***!
  \***************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.RenderCollection = void 0;
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
class RenderCollection extends smarthub_common_1.BaseMiddlewareCollection {
    constructor() {
        super();
    }
    testFallback(config, info) {
        return info.component.template == config.id;
    }
}
exports.RenderCollection = RenderCollection;


/***/ }),

/***/ "./src/middleware/transform/core-transform-middleware.fn.ts":
/*!******************************************************************!*\
  !*** ./src/middleware/transform/core-transform-middleware.fn.ts ***!
  \******************************************************************/
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.coreTransformMiddleware = void 0;
const coreTransformMiddleware = () => next => (info) => {
    return next(info);
};
exports.coreTransformMiddleware = coreTransformMiddleware;


/***/ }),

/***/ "./src/middleware/transform/create-transform-middleware.fn.ts":
/*!********************************************************************!*\
  !*** ./src/middleware/transform/create-transform-middleware.fn.ts ***!
  \********************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.createTransformMiddleware = void 0;
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const createTransformMiddleware = (coreMiddleware, additionalMiddleware) => {
    const middleware = smarthub_common_1.concatMiddleware(additionalMiddleware, coreMiddleware)({});
    //TODO redability
    return (...args) => {
        try {
            return middleware((obj) => {
                smarthub_common_1.Logger.error("[createMiddleware] transform not found", false, { args: args, obj: obj });
                return Array.isArray(obj === null || obj === void 0 ? void 0 : obj.data)
                    ? []
                    : null;
            })(...args);
        }
        catch (err) {
            return JSON.stringify(err, null, 2);
        }
    };
};
exports.createTransformMiddleware = createTransformMiddleware;


/***/ }),

/***/ "./src/middleware/transform/index.ts":
/*!*******************************************!*\
  !*** ./src/middleware/transform/index.ts ***!
  \*******************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.TransformCollection = exports.createTransformMiddleware = exports.coreTransformMiddleware = void 0;
var core_transform_middleware_fn_1 = __webpack_require__(/*! ./core-transform-middleware.fn */ "./src/middleware/transform/core-transform-middleware.fn.ts");
Object.defineProperty(exports, "coreTransformMiddleware", ({ enumerable: true, get: function () { return core_transform_middleware_fn_1.coreTransformMiddleware; } }));
var create_transform_middleware_fn_1 = __webpack_require__(/*! ./create-transform-middleware.fn */ "./src/middleware/transform/create-transform-middleware.fn.ts");
Object.defineProperty(exports, "createTransformMiddleware", ({ enumerable: true, get: function () { return create_transform_middleware_fn_1.createTransformMiddleware; } }));
var transform_collection_class_1 = __webpack_require__(/*! ./transform-collection.class */ "./src/middleware/transform/transform-collection.class.ts");
Object.defineProperty(exports, "TransformCollection", ({ enumerable: true, get: function () { return transform_collection_class_1.TransformCollection; } }));


/***/ }),

/***/ "./src/middleware/transform/transform-collection.class.ts":
/*!****************************************************************!*\
  !*** ./src/middleware/transform/transform-collection.class.ts ***!
  \****************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.TransformCollection = void 0;
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
class TransformCollection extends smarthub_common_1.BaseMiddlewareCollection {
    constructor() {
        super();
    }
    upsertTemplate(template) {
        if (template instanceof Array) {
            const handlers = template.map(t => this.createHandler(t));
            this.upsert(handlers);
            return;
        }
        const handler = this.createHandler(template);
        this.upsert(handler);
    }
    createHandler({ id, sourceSchema, targetSchema, template, priority }) {
        return {
            id,
            priority,
            sourceSchema,
            targetSchema,
            template: null,
            handle: function (info) {
                try {
                    return smarthub_common_1.transformData(template, info, this);
                }
                catch (ex) {
                    smarthub_common_1.Logger.error(`Failed to transform data ${ex}`, false, { info, template });
                }
            }
        };
    }
    testFallback(config, info) {
        var _a, _b, _c;
        if (Array.isArray(info.data))
            return ((_a = info.data) === null || _a === void 0 ? void 0 : _a.length) > 0 && ((_b = info.data[0]) === null || _b === void 0 ? void 0 : _b.$schema) == config.sourceSchema && info.targetSchema == config.targetSchema;
        else
            return ((_c = info.data) === null || _c === void 0 ? void 0 : _c.$schema) == config.sourceSchema && info.targetSchema == config.targetSchema;
    }
}
exports.TransformCollection = TransformCollection;


/***/ }),

/***/ "@fluentui/react":
/*!**********************************!*\
  !*** external "@fluentui/react" ***!
  \**********************************/
/***/ ((module) => {

module.exports = require("@fluentui/react");

/***/ }),

/***/ "botframework-directlinejs":
/*!********************************************!*\
  !*** external "botframework-directlinejs" ***!
  \********************************************/
/***/ ((module) => {

module.exports = require("botframework-directlinejs");

/***/ }),

/***/ "botframework-webchat":
/*!***************************************!*\
  !*** external "botframework-webchat" ***!
  \***************************************/
/***/ ((module) => {

module.exports = require("botframework-webchat");

/***/ }),

/***/ "dayjs":
/*!************************!*\
  !*** external "dayjs" ***!
  \************************/
/***/ ((module) => {

module.exports = require("dayjs");

/***/ }),

/***/ "dayjs/plugin/isSameOrBefore":
/*!**********************************************!*\
  !*** external "dayjs/plugin/isSameOrBefore" ***!
  \**********************************************/
/***/ ((module) => {

module.exports = require("dayjs/plugin/isSameOrBefore");

/***/ }),

/***/ "query-string":
/*!*******************************!*\
  !*** external "query-string" ***!
  \*******************************/
/***/ ((module) => {

module.exports = require("query-string");

/***/ }),

/***/ "react":
/*!************************!*\
  !*** external "react" ***!
  \************************/
/***/ ((module) => {

module.exports = require("react");

/***/ }),

/***/ "react-jss":
/*!****************************!*\
  !*** external "react-jss" ***!
  \****************************/
/***/ ((module) => {

module.exports = require("react-jss");

/***/ }),

/***/ "recoil":
/*!*************************!*\
  !*** external "recoil" ***!
  \*************************/
/***/ ((module) => {

module.exports = require("recoil");

/***/ }),

/***/ "resize-observer-polyfill":
/*!*******************************************!*\
  !*** external "resize-observer-polyfill" ***!
  \*******************************************/
/***/ ((module) => {

module.exports = require("resize-observer-polyfill");

/***/ }),

/***/ "smarthub-common":
/*!**********************************!*\
  !*** external "smarthub-common" ***!
  \**********************************/
/***/ ((module) => {

module.exports = require("smarthub-common");

/***/ }),

/***/ "tslib":
/*!************************!*\
  !*** external "tslib" ***!
  \************************/
/***/ ((module) => {

module.exports = require("tslib");

/***/ }),

/***/ "use-debounce":
/*!*******************************!*\
  !*** external "use-debounce" ***!
  \*******************************/
/***/ ((module) => {

module.exports = require("use-debounce");

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module is referenced by other modules so it can't be inlined
/******/ 	var __webpack_exports__ = __webpack_require__("./src/index.ts");
/******/ 	var __webpack_export_target__ = exports;
/******/ 	for(var i in __webpack_exports__) __webpack_export_target__[i] = __webpack_exports__[i];
/******/ 	if(__webpack_exports__.__esModule) Object.defineProperty(__webpack_export_target__, "__esModule", { value: true });
/******/ 	
/******/ })()
;
//# sourceMappingURL=index.js.map